(function () {
    'use strict';
    function ___babelHelper___typeof(obj) {
        return obj && typeof Symbol !== 'undefined' && obj.constructor === Symbol ? 'symbol' : typeof obj;
    }
    function ___babelHelper___createClass(Constructor, protoProps, staticProps) {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ('value' in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function ___babelHelper___classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function');
        }
    }
    function ___babelHelper___possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
        }
        return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
    }
    function ___babelHelper___inherits(subClass, superClass) {
        function defaults(obj, defaults) {
            var keys = Object.getOwnPropertyNames(defaults);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var value = Object.getOwnPropertyDescriptor(defaults, key);
                if (value && value.configurable && obj[key] === undefined) {
                    Object.defineProperty(obj, key, value);
                }
            }
            return obj;
        }
        if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass)
            defaults(subClass, superClass);
    }
    function ___babelHelper___taggedTemplateLiteralLoose(strings, raw) {
        strings.raw = raw;
        return strings;
    }
    ;
    (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = typeof require == 'function' && require;
                    if (!u && a)
                        return a(o, !0);
                    if (i)
                        return i(o, !0);
                    var f = new Error('Cannot find module \'' + o + '\'');
                    throw f.code = 'MODULE_NOT_FOUND', f;
                }
                var l = n[o] = { exports: {} };
                t[o][0].call(l.exports, function (e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = typeof require == 'function' && require;
        for (var o = 0; o < r.length; o++)
            s(r[o]);
        return s;
    }({
        1: [
            function (require, module, exports) {
                var ArrayOptionOutput = function () {
                    function ArrayOptionOutput(option, writeOption, i18n, generateId) {
                        var _this = this;
                        ___babelHelper___classCallCheck(this, ArrayOptionOutput);
                        this.option = option;
                        this.$dragged = null;
                        this.$entries = $('<div>').append(option.entries.map(function (subOption) {
                            return _this.writeDraggableSubOption(subOption, writeOption, i18n);
                        }));
                        var $buttons = $('<div class=\'buttons\'>');
                        option.availableTypes.forEach(function (type, i) {
                            if (i)
                                $buttons.append(' ');
                            $buttons.append($('<button type=\'button\'>').html(i18n('options.' + option.fullName + '.' + type + '.add')).click(function () {
                                //option.addEntry(type,entry=>this.$entries.append(this.writeDraggableSubOption(entry,writeOption,i18n)))
                                _this.$entries.append(_this.writeDraggableSubOption(option.makeEntry(type), writeOption, i18n));
                                _this.updateArrayEntries();
                            }));
                        });
                        this.$output = option.$ = $('<fieldset>').append('<legend>' + i18n('options.' + option.fullName) + '</legend>', this.$entries, $buttons);
                    }
                    ArrayOptionOutput.prototype.canDeleteEntry = function canDeleteEntry($entry) {
                        return true;
                    };
                    ArrayOptionOutput.prototype.updateArrayEntries = function updateArrayEntries() {
                        this.option.entries = this.$entries.children().map(function () {
                            return $(this).data('option');
                        }).get();
                    };
                    ArrayOptionOutput.prototype.writeDraggableSubOption = function writeDraggableSubOption(subOption, writeOption, i18n) {
                        var _this2 = this;
                        // have to make drag handler 'draggable', not the whole item
                        // because inputs and labels don't like to be inside 'draggable'
                        // http://stackoverflow.com/questions/13017177/selection-disabled-while-using-html5-drag-and-drop
                        var moveUp = function ($moved) {
                            $moved.prev().before($moved);
                            _this2.updateArrayEntries();
                        };
                        var moveDown = function ($moved) {
                            $moved.next().after($moved);
                            _this2.updateArrayEntries();
                        };
                        var attemptDelete = function ($entry) {
                            if (_this2.canDeleteEntry($entry)) {
                                $entry.remove();
                                _this2.updateArrayEntries();
                            }
                        };
                        var This = this;
                        return $('<div class=\'draggable-with-handle\'>').data('option', subOption).append(writeOption(subOption), ' ', $('<span draggable=\'true\' tabindex=\'0\' title=\'' + i18n('options-output.drag.tip') + '\'>').append('<span>' + i18n('options-output.drag') + '</span>').on('dragstart', function (ev) {
                            This.$dragged = $(this).parent();
                            ev.originalEvent.dataTransfer.effectAllowed = 'move';
                            ev.originalEvent.dataTransfer.setData('Text', name);
                            if (ev.originalEvent.dataTransfer.setDragImage) {
                                // doesn't work in IE
                                ev.originalEvent.dataTransfer.setDragImage(This.$dragged[0], 0, 0);
                            }
                            setTimeout(function () {
                                This.$dragged.addClass('ghost');
                            }, 0);
                        }).on('touchstart', function (ev) {
                            var $sorted = $(this).parent();
                            $sorted.addClass('ghost');
                            return false;    // disable touch panning on Firefox
                        }).on('touchmove', function (ev) {
                            var $sorted = $(this).parent();
                            var h = $sorted.height();
                            var t = $sorted.offset().top;
                            var y = ev.originalEvent.touches[0].pageY;
                            // TODO test if length of touches is 1
                            var $prev = $sorted.prev();
                            if ($prev.length && y < t && y - $prev.offset().top < h) {
                                moveUp($sorted);
                            }
                            var $next = $sorted.next();
                            if ($next.length && y > t + h && y - $next.offset().top > $next.height() - h) {
                                moveDown($sorted);
                            }
                            return false;    // disable touch panning
                        }).on('touchend touchcancel', function (ev) {
                            var $sorted = $(this).parent();
                            $sorted.removeClass('ghost');
                        }).keydown(function (ev) {
                            var $handle = $(this);
                            var $sorted = $handle.parent();
                            if (ev.keyCode == 38) {
                                moveUp($sorted);
                                $handle.focus();
                                return false;
                            } else if (ev.keyCode == 40) {
                                moveDown($sorted);
                                $handle.focus();
                                return false;
                            }
                        }), ' ', $('<button class=\'delete\' title=\'' + i18n('options-output.delete.tip') + '\'>').append('<span>' + i18n('options-output.delete') + '</span>').click(function () {
                            attemptDelete($(this).parent());
                        }).keydown(function (ev) {
                            if (ev.keyCode == 13 || ev.keyCode == 32) {
                                attemptDelete($(this).parent());
                                return false;
                            }
                        })).on('dragover', function (ev) {
                            ev.preventDefault();
                            ev.originalEvent.dataTransfer.dropEffect = 'move';
                            var $target = $(this);
                            if (This.$dragged) {
                                if ($target.next().is(This.$dragged)) {
                                    var dh = This.$dragged.height();
                                    var y = ev.pageY - $target.offset().top;
                                    if (y < dh) {
                                        moveUp(This.$dragged);
                                    }
                                } else if ($target.nextAll().is(This.$dragged)) {
                                    moveUp(This.$dragged);
                                } else if ($target.prev().is(This.$dragged)) {
                                    var th = $target.height();
                                    var _dh = This.$dragged.height();
                                    var _y = ev.pageY - $target.offset().top;
                                    if (_y > th - _dh) {
                                        moveDown(This.$dragged);
                                    }
                                } else if ($target.prevAll().is(This.$dragged)) {
                                    moveDown(This.$dragged);
                                }
                            }
                        }).on('drop', function (ev) {
                            ev.preventDefault();
                        }).on('dragend', function (ev) {
                            ev.preventDefault();
                            if (This.$dragged) {
                                This.$dragged.removeClass('ghost');
                                This.$dragged = null;
                            }
                        });
                    };
                    return ArrayOptionOutput;
                }();
                module.exports = ArrayOptionOutput;
            },
            {}
        ],
        2: [
            function (require, module, exports) {
                module.exports = function (lang) {
                    return function (strings) {
                        var additionalStringsPrefix = 'code-output';
                        var additionalStrings = {
                            en: {
                                'save': 'Save source code',
                                'run': 'Run in new window',
                                'open.codepen': 'Open in CodePen',
                                'open.jsfiddle': 'Open in JSFiddle',
                                'open.plunker': 'Open in Plunker',
                                'section.html': 'HTML',
                                'section.css': 'CSS',
                                'section.js': 'JavaScript',
                                'embedded': 'embedded in HTML source code',
                                'mode.full': 'complete HTML',
                                'mode.body': 'only HTML body',
                                'mode.embed': 'embed in HTML',
                                'mode.paste': 'extract to paste into HTML later',
                                'mode.file': 'extract to load as external resource',
                                'formatting': 'Formatting',
                                'formatting.indent': 'indent with tabs',
                                'formatting.indentNumber': 'spaces per indent',
                                'formatting.jsSemicolons': 'JavaScript semicolons',
                                'warning.no-hljs': '<a href=https://highlightjs.org/>highlight.js</a> (hosted on <a href=http://cdnjs.cloudflare.com>cdnjs.cloudflare.com</a>) is not loaded. Syntax highlighting is disabled.'
                            },
                            ru: {
                                'save': 'Сохранить исходный код',
                                'run': 'Запустить в новом окне',
                                'open.codepen': 'Открыть в CodePen',
                                'open.jsfiddle': 'Открыть в JSFiddle',
                                'open.plunker': 'Открыть в Plunker',
                                'section.html': 'HTML',
                                'section.css': 'CSS',
                                'section.js': 'JavaScript',
                                'embedded': 'встроен в код HTML',
                                'mode.full': 'полностью',
                                'mode.body': 'только <code>body</code>',
                                'mode.embed': 'встроить в HTML',
                                'mode.paste': 'извлечь для последующей вставки в HTML',
                                'mode.file': 'извлечь для загрузки в качестве внешнего ресурса',
                                'formatting': 'Форматирование',
                                'formatting.indent': 'отступы с помощью tab',
                                'formatting.indentNumber': 'пробелов в отступе',
                                'formatting.jsSemicolons': '<code>;</code> в JavaScript',
                                'warning.no-hljs': '<a href=https://highlightjs.org/>highlight.js</a> (с сервера <a href=http://cdnjs.cloudflare.com>cdnjs.cloudflare.com</a>) не загружен. Подсветка синтаксиса отключена.'
                            }
                        };
                        for (var id in additionalStrings[lang]) {
                            strings[additionalStringsPrefix + '.' + id] = additionalStrings[lang][id];
                        }
                        return strings;
                    };
                };
            },
            {}
        ],
        3: [
            function (require, module, exports) {
                var debounce = require(8);
                var detailsPolyfill = require(5);
                var getHtmlDataUri = function (html) {
                    return 'data:text/html;charset=utf-8,' + encodeURIComponent(html);
                };
                var makeObjectWithSetters = function (values, setCallback) {
                    var obj = {};
                    var _loop = function (prop) {
                        Object.defineProperty(obj, prop, {
                            get: function () {
                                return values[prop];
                            },
                            set: function (v) {
                                values[prop] = v;
                                setCallback();
                            }
                        });
                    };
                    for (var prop in values) {
                        _loop(prop);
                    }
                    return obj;
                };
                var CodeOutput = function () {
                    function CodeOutput(generateCode, i18n) {
                        var _this = this;
                        ___babelHelper___classCallCheck(this, CodeOutput);
                        this.formatting = makeObjectWithSetters(this.defaultFormatting, function () {
                            _this.update.flush();
                            _this.applyUpdatedCode(i18n);
                        });
                        this.sectionModes = makeObjectWithSetters({
                            html: 'full',
                            css: 'embed',
                            js: 'embed'
                        }, function () {
                            _this.update.flush();
                            _this.applyUpdatedCode(i18n);
                        });
                        this._code = generateCode();
                        this.update = debounce(function () {
                            _this._code = generateCode();
                            _this.applyUpdatedCode(i18n);
                        }, 200);
                        this.initDomProps();
                        var writeFormattingControls = function () {
                            var This = _this;
                            var $indentCheckbox = undefined, $indentNumber = undefined;
                            var updateIndent = function () {
                                var indent = '\t';
                                if (!$indentCheckbox.prop('checked')) {
                                    var n = 4;
                                    if ($indentNumber[0].checkValidity()) {
                                        n = Number($indentNumber.val());
                                    }
                                    indent = require(29)(' ')(n);
                                }
                                _this.formatting.indent = indent;
                            };
                            return $('<details>').append('<summary>' + i18n('code-output.formatting') + '</summary>', $('<div>').append($('<label>').append($indentCheckbox = $('<input type=\'checkbox\'>').prop('checked', _this.formatting.indent == '\t').change(updateIndent), ' ' + i18n('code-output.formatting.indent'))), $('<div>').append($('<label>').append($indentNumber = $('<input type=\'number\' min=\'0\' max=\'32\' required>').val(_this.formatting.indent == '\t' ? 4 : _this.formatting.indent.length).on('input change', updateIndent), ' ' + i18n('code-output.formatting.indentNumber'))), $('<div>').append($('<label>').append($('<input type=\'checkbox\'>').prop('checked', _this.formatting.jsSemicolons).change(function () {
                                This.formatting.jsSemicolons = this.checked;
                            }), ' ' + i18n('code-output.formatting.jsSemicolons')))).each(detailsPolyfill);
                        };
                        var writeSection = function (sectionName) {
                            return $('<details open>').append(_this.writeSectionSummary(sectionName, i18n), _this.$sectionCode[sectionName] = $('<div class=\'code\'>')).each(detailsPolyfill);
                        };
                        var $output = $('<div class=\'code-output\'>').append(this.writeButtons(i18n)).append(writeFormattingControls(), writeSection('html'), writeSection('css'), writeSection('js'));
                        if (!window.hljs) {
                            $output.append('<p>' + i18n('code-output.warning.no-hljs') + '</p>');
                        }
                        $output.append(this.writeButtons(i18n));
                        this.applyUpdatedCode(i18n);
                        // public interface:
                        // this.update
                        this.$output = $output;
                    }
                    // private interface:
                    CodeOutput.prototype.initDomProps = function initDomProps() {
                        this.$sectionCode = {};
                        this.$saveButtons = {};
                    };
                    CodeOutput.prototype.applyUpdatedCode = function applyUpdatedCode(i18n) {
                        // TODO pass code to avoid recursion on accessing this.code... or not b/c reading this.sectionModes and like
                        var sections = this.code.extractSections(this.sectionModes);
                        for (var sectionName in sections) {
                            if (this.sectionModes[sectionName] == 'embed') {
                                this.$sectionCode[sectionName].empty().append('<p>' + i18n('code-output.embedded') + '</p>');
                            } else {
                                var $code = undefined;
                                this.$sectionCode[sectionName].empty().append($('<pre>').append($code = $('<code class=\'' + sectionName + '\'>')));
                                $code.html(sections[sectionName].getHtml(this.formatting).join('\n'));
                                if (window.hljs) {
                                    hljs.highlightBlock($code[0]);
                                }
                            }
                            if (sectionName != 'html') {
                                // extractable section
                                this.$saveButtons[sectionName].prop('disabled', this.sectionModes[sectionName] == 'embed');
                            }
                        }
                    };
                    CodeOutput.prototype.writeButtons = function writeButtons(i18n) {
                        var This = this;
                        var postData = function (url, target, data) {
                            var $form = $('<form method=\'post\' action=\'' + url + '\' target=\'' + target + '\'>');
                            for (var name in data) {
                                $form.append($('<input type=\'hidden\'>').attr('name', name).val(data[name]));
                            }
                            $form.appendTo('body').submit().remove();
                        };
                        return $('<div>').append($('<button type=\'button\'>' + i18n('code-output.run') + '</button>').click(function () {
                            var html = This.code.get(This.formatting).join('\n');
                            if (navigator.msSaveOrOpenBlob) {
                                // has drawbacks:
                                // * Firefox and Chrome have trouble showing the source
                                // * weird bug in Firefox:
                                //   in webgl-starter: add z-rotation, slider input, add speed, slider input, run, change rotation range, run again
                                // * Firefox shows url of a generator page
                                var w = window.open('', 'generatedCode');
                                w.document.open();
                                w.document.write(html);
                                w.document.close();
                            } else {
                                // has drawbacks:
                                // * doesn't work in IE b/c they decided it's security risk
                                // * long url
                                window.open(getHtmlDataUri(html), 'generatedCode');
                            }
                        }), ' ', $('<button type=\'button\'>' + i18n('code-output.open.codepen') + '</button>').click(function () {
                            // http://blog.codepen.io/documentation/api/prefill/
                            var sections = This.code.extractSections({
                                html: 'body',
                                css: 'paste',
                                js: 'paste'
                            });
                            var getSection = function (sectionName) {
                                return sections[sectionName].get(This.formatting).join('\n');
                            };
                            postData('http://codepen.io/pen/define/', 'codepenGeneratedCode', {
                                data: JSON.stringify({
                                    html: getSection('html'),
                                    css: getSection('css'),
                                    js: getSection('js'),
                                    title: This.code.title
                                })
                            });
                        }), // doesn't work?
                        ' ', $('<button type=\'button\'>' + i18n('code-output.open.jsfiddle') + '</button>').click(function () {
                            // http://doc.jsfiddle.net/api/post.html
                            var sections = This.code.extractSections({
                                html: 'body',
                                css: 'paste',
                                js: 'paste'
                            });
                            var getSection = function (sectionName) {
                                return sections[sectionName].get(This.formatting).join('\n');
                            };
                            postData('http://jsfiddle.net/api/post/library/pure/', 'jsfiddleGeneratedCode', {
                                html: getSection('html'),
                                css: getSection('css'),
                                js: getSection('js'),
                                title: This.code.title,
                                wrap: 'b'
                            });
                        }), ' ', $('<button type=\'button\'>' + i18n('code-output.open.plunker') + '</button>').click(function () {
                            var _postData;
                            // https://github.com/angular/angular.js/blob/489835dd0b36a108bedd5ded439a186aca4fa739/docs/app/src/examples.js#L139-L157
                            var sections = This.code.extractSections({
                                html: 'full',
                                css: 'file',
                                js: 'file'
                            });
                            var getSection = function (sectionName) {
                                return sections[sectionName].get(This.formatting).join('\n');
                            };
                            postData('http://plnkr.co/edit/?p=preview', 'plunkerGeneratedCode', (_postData = {}, _postData['files[index.html]'] = getSection('html'), _postData['files[' + sections['css'].filename + ']'] = getSection('css'), _postData['files[' + sections['js'].filename + ']'] = getSection('js'), _postData['private'] = true, _postData));
                        }));
                    };
                    CodeOutput.prototype.writeSectionSummary = function writeSectionSummary(sectionName, i18n) {
                        var This = this;
                        var $summary = $('<summary>' + i18n('code-output.section.' + sectionName) + '</summary>');
                        $summary.append(' ', $('<select>').append((sectionName == 'html' ? [
                            'full',
                            'body'
                        ] : [
                            'embed',
                            'paste',
                            'file'
                        ]).map(function (mode) {
                            return $('<option>').val(mode).html(i18n('code-output.mode.' + mode));
                        })).val(this.sectionModes[sectionName]).change(function () {
                            This.sectionModes[sectionName] = this.value;
                        }), ' ', // doesn't work in IE
                        //$("<a download='"+section.filename+"'><button type='button'>"+i18n('code-output.save')+"</button></a>").click(function(){
                        //	// yes I want a button, but download attr is only available for links
                        //	$(this).attr('href',getHtmlDataUri(
                        //		section.get(this.formatting).join("\n")
                        //	))
                        //})
                        this.$saveButtons[sectionName] = $('<button type=\'button\'>' + i18n('code-output.save') + '</button>').click(function () {
                            var section = This.code.extractSections(This.sectionModes)[sectionName];
                            // http://stackoverflow.com/a/24354303
                            var blob = new Blob([section.get(This.formatting).join('\n')], { type: section.mimeType });
                            if (navigator.msSaveOrOpenBlob) {
                                navigator.msSaveOrOpenBlob(blob, section.filename);
                            } else {
                                var $a = $('<a>').attr('download', section.filename).attr('href', URL.createObjectURL(blob)).appendTo('body');
                                $a.get(0).click();
                                $a.remove();
                            }
                        }));
                        return $summary;
                    };
                    ___babelHelper___createClass(CodeOutput, [
                        {
                            key: 'code',
                            get: function () {
                                this.update.flush();
                                return this._code;
                            }    // extend/override fns:
                        },
                        {
                            key: 'defaultFormatting',
                            get: function () {
                                return {
                                    indent: '\t',
                                    jsSemicolons: false
                                };
                            }
                        }
                    ]);
                    return CodeOutput;
                }();
                module.exports = CodeOutput;
            },
            {
                '29': 29,
                '5': 5,
                '8': 8
            }
        ],
        4: [
            function (require, module, exports) {
                var CodeSection = function () {
                    function CodeSection(filename, mimeType, lines) {
                        ___babelHelper___classCallCheck(this, CodeSection);
                        this.filename = filename;
                        this.mimeType = mimeType;
                        this.lines = lines;
                    }
                    CodeSection.prototype.get = function get(formatting) {
                        return this.lines.get(formatting);
                    };
                    CodeSection.prototype.getHtml = function getHtml(formatting) {
                        return this.lines.getHtml(formatting);
                    };
                    return CodeSection;
                }();
                module.exports = CodeSection;
            },
            {}
        ],
        5: [
            function (require, module, exports) {
                var detailsSupported = 'open' in document.createElement('details');
                // http://thenewcode.com/680/Feature-Detection-and-Styling-For-The-HTML5-details-Element
                module.exports = function () {
                    // to be called in .each()
                    if (detailsSupported)
                        return;
                    var $details = $(this);
                    var toggleOpen = function () {
                        if (!$details.attr('open')) {
                            $details.attr('open', '');
                        } else {
                            $details.removeAttr('open');
                        }
                    };
                    var keyCodeEnter = 13;
                    var keyCodeSpace = 32;
                    var handleEvent = function (ev) {
                        return $(ev.target).closest('summary, :input, a[href]').is('summary');
                    };
                    // check if event target is not an input/link, also check its ancestors (jQuery doesn't include <option> in :input selector)
                    $details.addClass('polyfill').children('summary').attr('tabindex', 0).click(function (ev) {
                        if (handleEvent(ev)) {
                            toggleOpen();
                        }
                    }).keydown(function (ev) {
                        if (handleEvent(ev) && (ev.keyCode == keyCodeEnter || ev.keyCode == keyCodeSpace)) {
                            toggleOpen();
                            return false;
                        }
                    });
                };
            },
            {}
        ],
        6: [
            function (require, module, exports) {
                // assumes string is dot-separated, like this: "some.html.id"
                var capitalize = require(7);
                module.exports = function (s) {
                    return s.split('.').map(function (w, i) {
                        return i > 0 ? capitalize(w) : w;
                    }).join('');
                };
            },
            { '7': 7 }
        ],
        7: [
            function (require, module, exports) {
                // assumes string is lowercase
                module.exports = function (s) {
                    return s.charAt(0).toUpperCase() + s.slice(1);
                };
            },
            {}
        ],
        8: [
            function (require, module, exports) {
                // no options
                module.exports = function (func, wait) {
                    var timeoutId = null;
                    var debounced = function () {
                        clearTimeout(timeoutId);
                        timeoutId = setTimeout(function () {
                            timeoutId = null;
                            func();
                        }, wait);
                    };
                    debounced.flush = function () {
                        if (timeoutId) {
                            timeoutId = null;
                            func();
                        }
                    };
                    return debounced;
                };
            },
            {}
        ],
        9: [
            function (require, module, exports) {
                module.exports = function (s) {
                    var entityMap = {
                        '&': '&amp;',
                        '<': '&lt;',
                        '>': '&gt;',
                        '"': '&quot;',
                        '\'': '&#39;'
                    };
                    // lodash also escapes `
                    return String(s).replace(/[&<>"']/g, function (m) {
                        return entityMap[m];
                    });
                };
            },
            {}
        ],
        10: [
            function (require, module, exports) {
                var formatNumbersInternal = function (numbers, precision, keepDot, noPlus) {
                    var maxPrecision = 0;
                    if (keepDot) {
                        maxPrecision = 1;
                    }
                    var hasNegative = false;
                    for (var i in numbers) {
                        var p = undefined;
                        if (precision !== undefined) {
                            p = precision;
                        } else if (numbers[i].precision !== undefined) {
                            p = numbers[i].precision;
                        } else {
                            throw new Error('formatNumbers received no precision');
                        }
                        var number = Number(numbers[i]);
                        var s = number.toFixed(p);
                        if (Number(s) < 0) {
                            // protects against negative zero
                            hasNegative = true;
                        }
                        if (p > 0) {
                            p -= s.match(/0*$/)[0].length;
                        }
                        if (p > maxPrecision) {
                            maxPrecision = p;
                        }
                    }
                    var ss = Array.isArray(numbers) ? [] : {};
                    for (var _i in numbers) {
                        var _number = Number(numbers[_i]);
                        var _s = _number.toFixed(maxPrecision);
                        if (Number(_s) >= 0 && _s.charAt(0) == '-') {
                            // protects against negative zero
                            _s = _s.slice(1);
                        }
                        if (!noPlus && hasNegative && _number > 0) {
                            _s = '+' + _s;
                        }
                        ss[_i] = _s;
                    }
                    return ss;
                };
                var formatNumbers = function (number, precision) {
                    return formatNumbersInternal(number, precision);
                };
                formatNumbers.html = function (number, precision) {
                    return formatNumbersInternal(number, precision, false, true);
                };
                formatNumbers.js = function (number, precision) {
                    return formatNumbersInternal(number, precision);
                };
                formatNumbers.glsl = function (number, precision) {
                    return formatNumbersInternal(number, precision, true);
                };
                module.exports = formatNumbers;
            },
            {}
        ],
        11: [
            function (require, module, exports) {
                var GroupOptionOutput = function GroupOptionOutput(option, writeOption, i18n, generateId) {
                    ___babelHelper___classCallCheck(this, GroupOptionOutput);
                    this.option = option;
                    this.$output = option.$ = $('<fieldset>').append('<legend>' + i18n('options.' + option.fullName) + '</legend>').append(option.entries.map(writeOption));
                };
                module.exports = GroupOptionOutput;
            },
            {}
        ],
        12: [
            function (require, module, exports) {
                module.exports = function (inStrings) {
                    var strings = {};
                    var expandRegexp = /^([^{]*)\{([^}]*)\}(.*)$/;
                    function expandIdAndString(id, string) {
                        var idMatch = expandRegexp.exec(id);
                        if (idMatch) {
                            (function () {
                                var idStart = idMatch[1];
                                var idMidsStr = idMatch[2];
                                var idEnd = idMatch[3];
                                var idMids = idMidsStr.split(',');
                                var stringMatch = expandRegexp.exec(string);
                                if (stringMatch) {
                                    (function () {
                                        var stringStart = stringMatch[1];
                                        var stringMidsStr = stringMatch[2];
                                        var stringEnd = stringMatch[3];
                                        var stringMids = stringMidsStr.split(',');
                                        idMids.forEach(function (idMid, i) {
                                            if (stringMidsStr != '') {
                                                var stringMid = stringMids[i];
                                                expandIdAndString(idStart + idMid + idEnd, stringStart + stringMid + stringEnd);
                                            } else {
                                                expandIdAndString(idStart + idMid + idEnd, stringStart + idMid + stringEnd);
                                            }
                                        });
                                    }());
                                } else {
                                    idMids.forEach(function (idMid) {
                                        expandIdAndString(idStart + idMid + idEnd, string);
                                    });
                                }
                            }());
                        } else {
                            strings[id] = string;
                        }
                    }
                    for (var id in inStrings) {
                        expandIdAndString(id, inStrings[id]);
                    }
                    return strings;
                };
            },
            {}
        ],
        13: [
            function (require, module, exports) {
                module.exports = function (lang) {
                    return function (strings) {
                        for (var id in strings) {
                            strings[id] = strings[id].replace(/\[\[(.*?)\]\]/g, function (match, p1) {
                                var link = undefined, text = undefined;
                                var i = p1.indexOf('|');
                                if (i < 0) {
                                    link = p1;
                                    text = p1;
                                } else {
                                    link = p1.slice(0, i);
                                    text = p1.slice(i + 1);
                                }
                                return '<a href=\'https://' + lang + '.wikipedia.org/wiki/' + link.replace(/ /g, '_') + '\'>' + text + '</a>';
                            });
                        }
                        return strings;
                    };
                };
            },
            {}
        ],
        14: [
            function (require, module, exports) {
                var escape = require(9);
                module.exports = function (langStrings) {
                    return function (lang) {
                        var defaultLang = 'en';
                        lang = lang || defaultLang;
                        lang = lang.split('-')[0];
                        // get primary language subtag
                        var strings = langStrings[lang];
                        if (strings === undefined) {
                            lang = defaultLang;
                            strings = langStrings[lang];
                        }
                        var i18n = function (id) {
                            if (strings[id] !== undefined) {
                                return strings[id];
                            } else {
                                throw new Error('undefined string ' + id);
                            }
                        };
                        i18n.lang = lang;
                        i18n.has = function (id) {
                            return strings[id] !== undefined;
                        };
                        if (lang == 'en') {
                            i18n.number = function (n) {
                                return String(n).replace('-', '\u2212');
                            };
                            i18n.pluralSuffix = function (n) {
                                var ns = String(n);
                                if (require(28)(ns    /*:string*/)('.')) {
                                    return '2';
                                } else {
                                    var nn = Number(n);
                                    if (Math.abs(nn) == 1) {
                                        return '1';
                                    } else {
                                        return '2';
                                    }
                                }
                            };
                        } else if (lang == 'ru') {
                            i18n.number = function (n) {
                                return String(n).replace('-', '\u2212').replace('.', ',');
                            };
                            i18n.pluralSuffix = function (n) {
                                var ns = String(n);
                                if (require(28)(ns    /*:string*/)('.')) {
                                    return '2';
                                } else {
                                    var teen = ns.slice(-2, -1) === '1';
                                    if (ns.slice(-1) === '1' && !teen) {
                                        return '1';
                                    } else if (require(28)('234')(ns.slice(-1)) && !teen) {
                                        return '2';
                                    } else {
                                        return '5';
                                    }
                                }
                            };
                        }
                        i18n.plural = function (n, id) {
                            return this(id + '.' + this.pluralSuffix(n));
                        };
                        i18n.numberWithUnits = function (n, unit, abbrFn) {
                            if (abbrFn === undefined) {
                                // codegen needs its own fn
                                abbrFn = function (abbr, expansion) {
                                    return '<abbr title=\'' + escape(expansion) + '\'>' + abbr + '</abbr>';
                                };    // expansion is html for stuff like s^(-1)
                            }
                            var s = this.number(n);
                            if (unit !== undefined) {
                                if (unit.length == 1 && /^\W/.test(unit)) {
                                    s += unit;
                                } else {
                                    s += ' ';
                                    // nbsp
                                    var abbr = undefined;
                                    if (unit == '1/second') {
                                        abbr = i18n('units.second.a') + '<sup>\u22121</sup>';
                                    } else {
                                        abbr = i18n('units.' + unit + '.a');
                                    }
                                    var expansion = this.plural(n, 'units.' + unit);
                                    s += abbrFn(abbr, expansion);
                                }
                            }
                            return s;
                        };
                        return i18n;
                    };
                };
            },
            {
                '28': 28,
                '9': 9
            }
        ],
        15: [
            function (require, module, exports) {
                var escape = require(9);
                var Lines = require(17);
                var InterleaveLines = function (_Lines) {
                    ___babelHelper___inherits(InterleaveLines, _Lines);
                    function InterleaveLines() {
                        ___babelHelper___classCallCheck(this, InterleaveLines);
                        return ___babelHelper___possibleConstructorReturn(this, _Lines.apply(this, arguments));
                    }
                    InterleaveLines.prototype.doGet = function doGet(formatting, html) {
                        var out = [];
                        var first = true;
                        var fp = function () {
                            if (first) {
                                first = false;
                            } else {
                                out.push('');
                            }
                        };
                        var _arr = this.data;
                        for (var _i = 0; _i < _arr.length; _i++) {
                            var item = _arr[_i];
                            if (item instanceof Lines) {
                                var subOut = item.doGet(formatting, html);
                                if (subOut.length > 0) {
                                    fp();
                                    out.push.apply(out, subOut);
                                }
                            } else if (typeof item == 'string') {
                                fp();
                                var s = html ? escape(item) : item;
                                out.push(s);
                            }
                        }
                        return out;
                    };
                    return InterleaveLines;
                }(Lines);
                module.exports = InterleaveLines;
            },
            {
                '17': 17,
                '9': 9
            }
        ],
        16: [
            function (require, module, exports) {
                var Lines = require(17);
                var JsLines = function (_Lines) {
                    ___babelHelper___inherits(JsLines, _Lines);
                    function JsLines() {
                        ___babelHelper___classCallCheck(this, JsLines);
                        return ___babelHelper___possibleConstructorReturn(this, _Lines.apply(this, arguments));
                    }
                    JsLines.prototype.processStringInGet = function processStringInGet(s, formatting) {
                        if (formatting.jsSemicolons) {
                            return s.replace(/^;/, '');
                        } else {
                            return s.replace(/;$/, '');
                        }
                    };
                    return JsLines;
                }(Lines);
                module.exports = JsLines;
            },
            { '17': 17 }
        ],
        17: [
            function (require, module, exports) {
                /*
Create lines - short version:
	return Lines.bae(
		line1,
		line2,
		...
	)

	return SubclassOfLines.b(
		ctorArgs
	).ae(
		line1,
		line2,
		...
	)

Create lines - long version:
	const a=Lines.b()
	a( // shorthand for a.a()
		lineAddedAfterLastLine
	)
	a.a(
		lineAddedAfterLastLine
	)
	a.t(
		lineAppendedToLastLine
	)
	return a.e()

Read lines:
	formatting={indent:...,refs:...} // optional arg for some code formatting/annotation things
	lines.get(formatting) // get array of plaintext lines - need array to possibly put it line by line inside an <ol>
	lines.getHtml(formatting) // get array of html lines
*/
                var escape = require(9);
                var TO = {};
                // TODO Symbol
                var Lines = function () {
                    // lines private interface:
                    function Lines(data) {
                        ___babelHelper___classCallCheck(this, Lines);
                        if (!Array.isArray(data)) {
                            throw new TypeError('attempted to construct Lines with non-array data argument');
                        }
                        this.data = data;
                    }
                    Lines.prototype.isDataEmpty = function isDataEmpty() {
                        var _arr = this.data;
                        for (var _i = 0; _i < _arr.length; _i++) {
                            var item = _arr[_i];
                            if (item instanceof Lines) {
                                if (!item.isEmpty()) {
                                    return false;
                                }
                            } else if (typeof item == 'string') {
                                return false;
                            }
                        }
                        return true;
                    };
                    Lines.prototype.processStringInGet = function processStringInGet(s, formatting) {
                        return s;
                    };
                    Lines.prototype.doGet = function doGet(formatting, html) {
                        var out = [];
                        var addTo = false;
                        var _arr2 = this.data;
                        for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
                            var item = _arr2[_i2];
                            if (item === TO) {
                                addTo = true;
                            } else if (item instanceof Lines) {
                                var subOut = item.doGet(formatting, html);
                                if (addTo && subOut.length > 0) {
                                    out.push(out.pop() + subOut.shift());
                                }
                                out.push.apply(out, subOut);
                                addTo = false;
                            } else if (typeof item == 'string') {
                                var s = this.processStringInGet(item, formatting);
                                if (formatting.indent !== undefined && formatting.indent != '\t') {
                                    s = s.replace(/^(\t)+/, function (match) {
                                        return require(29)(formatting.indent)(match.length);
                                    });
                                }
                                s = html ? escape(s) : s;
                                if (addTo) {
                                    out.push(out.pop() + s);
                                } else {
                                    out.push(s);
                                }
                                addTo = false;
                            }
                        }
                        return out;
                    };
                    // lines public interface:
                    Lines.b = function b() {
                        var _this = this, _arguments = arguments;
                        var data = [];
                        var makeLines = function () {
                            return new (Function.prototype.bind.apply(_this, [null].concat([data], Array.prototype.slice.call(_arguments))))();
                        };
                        var a = function () {
                            return a.a.apply(a, arguments);
                        };
                        a.a = function () {
                            data.push.apply(data, arguments);
                            return this;
                        };
                        a.t = function () {
                            data.push.apply(data, [TO].concat(Array.prototype.slice.call(arguments)));
                            return this;
                        };
                        a.e = makeLines;
                        a.ae = function () {
                            return this.a.apply(this, arguments).e();
                        };
                        return a;
                    };
                    Lines.ba = function ba() {
                        var _b;
                        return (_b = this.b()).a.apply(_b, arguments);
                    };
                    Lines.be = function be() {
                        return this.b().e();
                    };
                    Lines.bae = function bae() {
                        var _b2;
                        return (_b2 = this.b()).a.apply(_b2, arguments).e();
                    };
                    Lines.prototype.isEmpty = function isEmpty() {
                        return this.isDataEmpty();
                    };
                    Lines.prototype.get = function get(formatting) {
                        if (formatting === undefined)
                            formatting = {};
                        return this.doGet(formatting, false);
                    };
                    Lines.prototype.getHtml = function getHtml(formatting) {
                        if (formatting === undefined)
                            formatting = {};
                        return this.doGet(formatting, true);
                    };
                    Lines.prototype.count = function count() {
                        return this.doGet({}, false).length;    // can be faster b/c don't need to output stuff
                    };
                    // TODO make HtmlLines
                    Lines.html = function html(strings) {
                        var _arguments2 = arguments;
                        // html template tag
                        // usage example for attributes: Lines.html`<input type=text value=${value}>`
                        // usage example for elements: Lines.html`<option>${option}</option>`
                        return strings.reduce(function (r, s, i) {
                            var v = _arguments2[i];
                            switch (r.slice(-1)) {
                            case '=':
                                if (v === false) {
                                    return r.replace(/\s+[a-zA-Z0-9-]+=$/, '') + s;    // TODO more permitting attr name regexp
                                } else if (v === true) {
                                    return r.replace(/=$/, '') + s;
                                }
                                v = String(v).replace(/&/g, '&amp;');
                                if (v == '') {
                                    return r.replace(/=$/, '') + s;
                                } else if (!/[\s"'=<>`]/.test(v)) {
                                    return r + v + s;
                                } else if (!/'/.test(v)) {
                                    return r + '\'' + v + '\'' + s;
                                } else {
                                    v = v.replace(/"/g, '&quot;');
                                    return r + '"' + v + '"' + s;
                                }
                            case '>':
                                v = String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;');
                                return r + v + s;
                            }
                            throw new Error('invalid character before substitution');
                        });
                    };
                    return Lines;
                }();
                module.exports = Lines;
            },
            {
                '29': 29,
                '9': 9
            }
        ],
        18: [
            function (require, module, exports) {
                var WrapLines = require(26);
                var NoseWrapLines = function (_WrapLines) {
                    ___babelHelper___inherits(NoseWrapLines, _WrapLines);
                    function NoseWrapLines() {
                        ___babelHelper___classCallCheck(this, NoseWrapLines);
                        return ___babelHelper___possibleConstructorReturn(this, _WrapLines.apply(this, arguments));
                    }
                    NoseWrapLines.prototype.isEmpty = function isEmpty() {
                        return this.isDataEmpty();
                    };
                    NoseWrapLines.prototype.doGet = function doGet(formatting, html) {
                        if (this.isEmpty()) {
                            return [];
                        } else {
                            return _WrapLines.prototype.doGet.call(this, formatting, html);
                        }
                    };
                    return NoseWrapLines;
                }(WrapLines);
                module.exports = NoseWrapLines;
            },
            { '26': 26 }
        ],
        19: [
            function (require, module, exports) {
                /*
use Option.<Class>.make(<description w/o className>)(data) to create Option object
	THIS WON'T WORK WITH Arrays/Groups!

fixed options spec:
	input option returns its value in primitive context (possibly with valueOf() method)
		value has primitive type
	options have the following properties in order of priority (most important first)
		type property (defaults to 'type') if option is an array member
			why need type property if there's name? - because name is not imported/exported
		suboption-named properties equal to suboptions for collections
		'entries' array of suboptions for array and collection
		'value' and 'name' properties for non-boolean options
	TODO decide on: boolean option cannot be an array member (where to store it's type?)
*/
                var Option = {};
                // abstract classes
                Option.Base = function () {
                    _class.make = function make(name) {
                        var nScalars = 0, nArrays = 0, nObjects = 0;
                        var scalarArg = undefined, arrayArg = [], objectArg = {};
                        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                            rest[_key - 1] = arguments[_key];
                        }
                        for (var _i = 0; _i < rest.length; _i++) {
                            var arg = rest[_i];
                            if (typeof arg == 'string' || typeof arg == 'number' || typeof arg == 'boolean') {
                                if (nScalars++ == 0)
                                    scalarArg = arg;
                            } else if (Array.isArray(arg)) {
                                if (nArrays++ == 0)
                                    arrayArg = arg;
                            } else if (arg instanceof Object) {
                                if (nObjects++ == 0)
                                    objectArg = arg;
                            }
                        }
                        var optionClass = this;
                        var settings = this.collectArgs(scalarArg, arrayArg, objectArg);
                        return function (data, parent, visibilityManager, makeEntry) {
                            return new optionClass(name, settings, data, parent, visibilityManager, makeEntry);
                        };
                    };
                    _class.collectArgs = function collectArgs(scalarArg, arrayArg, settings) {
                        return settings;
                    };
                    function _class(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class);
                        this.parent = parent;
                        this.name = name;
                        this.fullName = name;
                        if (parent && parent.fullName !== null) {
                            this.fullName = parent.fullName + '.' + name;
                        }
                        this.updateCallbacks = [];
                        this._$ = null;
                        // visibility and callbacks
                        this.isVisible = function () {
                            return true;
                        };
                        if (visibilityManager) {
                            visibilityManager.register(this);
                            if (settings.visibilityData !== undefined) {
                                if (settings.visibilityDataLogic != 'or') {
                                    this.isVisible = function () {
                                        for (var testName in settings.visibilityData) {
                                            var value = visibilityManager.options[testName].value;
                                            if (settings.visibilityData[testName].indexOf(value) < 0) {
                                                return false;
                                            }
                                        }
                                        return true;
                                    };
                                } else {
                                    this.isVisible = function () {
                                        for (var testName in settings.visibilityData) {
                                            var value = visibilityManager.options[testName].value;
                                            if (settings.visibilityData[testName].indexOf(value) >= 0) {
                                                return true;
                                            }
                                        }
                                        return false;
                                    };
                                }
                                for (var testName in settings.visibilityData) {
                                    visibilityManager.declareAffectedBy(this, testName);
                                }
                            }
                        }
                    }
                    _class.prototype.updateVisibility = function updateVisibility() {
                        if (this.$)
                            this.$.toggle(this.isVisible());
                    };
                    _class.prototype.update = function update() {
                        this.updateCallbacks.forEach(function (updateCallback) {
                            updateCallback();
                        });
                        if (this.parent) {
                            this.parent.update();
                        }
                    };
                    _class.prototype.addUpdateCallback = function addUpdateCallback(updateCallback) {
                        this.updateCallbacks.push(updateCallback);
                    };
                    _class.prototype.shortenExport = function shortenExport(data) {
                        // used by parent
                        var dataKeys = Object.keys(data);
                        if (dataKeys.length == 1 && dataKeys[0] == 'value') {
                            return data.value;
                        } else {
                            return data;
                        }
                    };
                    _class.prototype.shortenExportAssign = function shortenExportAssign(data, parentData, name) {
                        var dataKeys = Object.keys(data);
                        if (dataKeys.length == 1 && dataKeys[0] == 'value') {
                            parentData[name] = data.value;
                        } else if (dataKeys.length > 0) {
                            parentData[name] = data;
                        }
                    };
                    ___babelHelper___createClass(_class, [{
                            key: '$',
                            get: function () {
                                return this._$;
                            },
                            set: function ($) {
                                this._$ = $;
                                this.updateVisibility();
                            }
                        }]);
                    return _class;
                }();
                Option.Input = function (_Option$Base) {
                    ___babelHelper___inherits(_class2, _Option$Base);
                    _class2.collectArgs = function collectArgs(scalarArg, arrayArg, settings) {
                        settings = Object.create(settings);
                        if (settings.defaultValue === undefined)
                            settings.defaultValue = scalarArg;
                        return _Option$Base.collectArgs.call(this, scalarArg, arrayArg, settings);
                    };
                    function _class2(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class2);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _Option$Base.apply(this, arguments));
                        _this.defaultValue = settings.defaultValue;
                        if (typeof data == 'object') {
                            data = data.value;
                        }
                        if (data !== undefined) {
                            _this._value = data;
                        } else {
                            _this._value = _this.defaultValue;
                        }
                        return _this;
                    }
                    _class2.prototype.export = function _export() {
                        var data = {};
                        if (this.value != this.defaultValue)
                            data.value = this.value;
                        return data;
                    };
                    ___babelHelper___createClass(_class2, [{
                            key: 'value',
                            get: function () {
                                return this._value;
                            },
                            set: function (value) {
                                this._value = value;
                                this.update();
                            }
                        }]);
                    return _class2;
                }(Option.Base);
                Option.Boolean = function (_Option$Input) {
                    ___babelHelper___inherits(_class3, _Option$Input);
                    function _class3() {
                        ___babelHelper___classCallCheck(this, _class3);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Input.apply(this, arguments));
                    }
                    _class3.collectArgs = function collectArgs(scalarArg, arrayArg, settings) {
                        return _Option$Input.collectArgs.call(this, !!scalarArg, arrayArg, settings);
                    };
                    _class3.prototype.fix = function fix() {
                        return this.value;
                    };
                    return _class3;
                }(Option.Input);
                Option.NonBoolean = function (_Option$Input2) {
                    ___babelHelper___inherits(_class4, _Option$Input2);
                    function _class4() {
                        ___babelHelper___classCallCheck(this, _class4);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Input2.apply(this, arguments));
                    }
                    _class4.prototype.fix = function fix() {
                        var value = this.value;
                        return {
                            // can't use fixed value in boolean context
                            name: this.name,
                            value: value,
                            valueOf: function () {
                                return value;
                            },
                            toString: function () {
                                return String(value);
                            }
                        };
                    };
                    return _class4;
                }(Option.Input);
                Option.Factor = function (_Option$NonBoolean) {
                    ___babelHelper___inherits(_class5, _Option$NonBoolean);
                    _class5.collectArgs = function collectArgs(scalarArg, arrayArg, settings) {
                        settings = Object.create(settings);
                        if (settings.availableValues === undefined)
                            settings.availableValues = arrayArg;
                        if (scalarArg === undefined)
                            scalarArg = settings.availableValues[0];
                        return _Option$NonBoolean.collectArgs.call(this, scalarArg, arrayArg, settings);
                    };
                    function _class5(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class5);
                        var _this4 = ___babelHelper___possibleConstructorReturn(this, _Option$NonBoolean.apply(this, arguments));
                        _this4.availableValues = settings.availableValues;
                        return _this4;
                    }
                    return _class5;
                }(Option.NonBoolean);
                Option.Number = function (_Option$NonBoolean2) {
                    ___babelHelper___inherits(_class6, _Option$NonBoolean2);
                    // requires precision, gives step = Math.pow(0.1,precision).toFixed(precision)
                    _class6.collectArgs = function collectArgs(scalarArg, arrayArg, settings) {
                        settings = Object.create(settings);
                        if (settings.availableMin === undefined)
                            settings.availableMin = arrayArg[0];
                        if (settings.availableMax === undefined)
                            settings.availableMax = arrayArg[1];
                        if (scalarArg === undefined)
                            scalarArg = settings.availableMin;
                        return _Option$NonBoolean2.collectArgs.call(this, scalarArg, arrayArg, settings);
                    };
                    function _class6(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class6);
                        var _this5 = ___babelHelper___possibleConstructorReturn(this, _Option$NonBoolean2.apply(this, arguments));
                        _this5.availableMin = settings.availableMin;
                        _this5.availableMax = settings.availableMax;
                        _this5.unit = settings.unit;
                        return _this5;
                    }
                    _class6.prototype.fix = function fix() {
                        var fixed = _Option$NonBoolean2.prototype.fix.call(this);
                        fixed.precision = this.precision;
                        fixed.unit = this.unit;
                        return fixed;
                    };
                    return _class6;
                }(Option.NonBoolean);
                Option.Collection = function (_Option$Base2) {
                    ___babelHelper___inherits(_class7, _Option$Base2);
                    _class7.collectArgs = function collectArgs(scalarArg, arrayArg, settings) {
                        settings = Object.create(settings);
                        if (settings.descriptions === undefined)
                            settings.descriptions = arrayArg;
                        return _Option$Base2.collectArgs.call(this, scalarArg, arrayArg, settings);
                    };
                    function _class7(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class7);
                        var _this6 = ___babelHelper___possibleConstructorReturn(this, _Option$Base2.apply(this, arguments));
                        _this6.entries = settings.descriptions.map(function (x) {
                            var subName = x[1];
                            var subData = undefined;
                            if (typeof data == 'object')
                                subData = data[subName];
                            return makeEntry(x, subData, _this6, visibilityManager);    // nested option
                        });
                        return _this6;
                    }
                    _class7.prototype.export = function _export() {
                        var data = {};
                        var _arr = this.entries;
                        for (var _i2 = 0; _i2 < _arr.length; _i2++) {
                            var entry = _arr[_i2];
                            entry.shortenExportAssign(entry.export(), data, entry.name);
                        }
                        return data;
                    };
                    _class7.prototype.fix = function fix() {
                        var fixedEntries = [];
                        var fixed = {
                            name: this.name,
                            entries: fixedEntries
                        };
                        var _arr2 = this.entries;
                        for (var _i3 = 0; _i3 < _arr2.length; _i3++) {
                            var entry = _arr2[_i3];
                            fixedEntries.push(fixed[entry.name] = entry.fix());
                        }
                        return fixed;
                    };
                    return _class7;
                }(Option.Base);
                // concrete classes
                Option.Void = function (_Option$Base3) {
                    ___babelHelper___inherits(_class8, _Option$Base3);
                    function _class8() {
                        ___babelHelper___classCallCheck(this, _class8);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Base3.apply(this, arguments));
                    }
                    // useful as array entry w/o settings
                    _class8.prototype.export = function _export() {
                        return {};
                    };
                    _class8.prototype.fix = function fix() {
                        return { name: this.name };
                    };
                    return _class8;
                }(Option.Base);
                Option.Checkbox = function (_Option$Boolean) {
                    ___babelHelper___inherits(_class9, _Option$Boolean);
                    function _class9() {
                        ___babelHelper___classCallCheck(this, _class9);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Boolean.apply(this, arguments));
                    }
                    return _class9;
                }(Option.Boolean);
                Option.Select = function (_Option$Factor) {
                    ___babelHelper___inherits(_class10, _Option$Factor);
                    function _class10() {
                        ___babelHelper___classCallCheck(this, _class10);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Factor.apply(this, arguments));
                    }
                    return _class10;
                }(Option.Factor);
                Option.Text = function (_Option$Factor2) {
                    ___babelHelper___inherits(_class11, _Option$Factor2);
                    function _class11() {
                        ___babelHelper___classCallCheck(this, _class11);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Factor2.apply(this, arguments));
                    }
                    return _class11;
                }(Option.Factor);
                Option.Int = function (_Option$Number) {
                    ___babelHelper___inherits(_class12, _Option$Number);
                    function _class12() {
                        ___babelHelper___classCallCheck(this, _class12);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Number.apply(this, arguments));
                    }
                    ___babelHelper___createClass(_class12, [{
                            key: 'precision',
                            get: function () {
                                return 0;
                            }
                        }]);
                    return _class12;
                }(Option.Number);
                Option.Float = function (_Option$Number2) {
                    ___babelHelper___inherits(_class13, _Option$Number2);
                    function _class13(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class13);
                        var _this12 = ___babelHelper___possibleConstructorReturn(this, _Option$Number2.apply(this, arguments));
                        if (settings.precision !== undefined) {
                            _this12.precision = settings.precision;
                        } else {
                            if (_this12.availableMax >= 100) {
                                _this12.precision = 1;
                            } else if (_this12.availableMax >= 10) {
                                _this12.precision = 2;
                            } else {
                                _this12.precision = 3;
                            }
                        }
                        return _this12;
                    }
                    return _class13;
                }(Option.Number);
                Option.Root = function (_Option$Collection) {
                    ___babelHelper___inherits(_class14, _Option$Collection);
                    function _class14() {
                        ___babelHelper___classCallCheck(this, _class14);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Collection.apply(this, arguments));
                    }
                    return _class14;
                }(Option.Collection);
                Option.Group = function (_Option$Collection2) {
                    ___babelHelper___inherits(_class15, _Option$Collection2);
                    function _class15() {
                        ___babelHelper___classCallCheck(this, _class15);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Collection2.apply(this, arguments));
                    }
                    return _class15;
                }(Option.Collection);
                Option.Array = function (_Option$Base4) {
                    ___babelHelper___inherits(_class16, _Option$Base4);
                    // TODO consider extending Collection
                    _class16.collectArgs = function collectArgs(scalarArg, arrayArg, settings) {
                        settings = Object.create(settings);
                        if (settings.descriptions === undefined)
                            settings.descriptions = arrayArg;
                        if (settings.typePropertyName === undefined)
                            settings.typePropertyName = scalarArg;
                        return _Option$Base4.collectArgs.call(this, scalarArg, arrayArg, settings);
                    };
                    function _class16(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class16);
                        var _this15 = ___babelHelper___possibleConstructorReturn(this, _Option$Base4.apply(this, arguments));
                        _this15.availableConstructors = new Map();
                        if (visibilityManager)
                            visibilityManager.enterArray();
                        var _arr3 = settings.descriptions;
                        var _loop = function () {
                            var x = _arr3[_i4];
                            // TODO test array inside array
                            var type = x[1];
                            var ctor = function (subData) {
                                return makeEntry(x, subData, _this15, visibilityManager);
                            };
                            _this15.availableConstructors.set(type, ctor);
                        };
                        for (var _i4 = 0; _i4 < _arr3.length; _i4++) {
                            _loop();
                        }
                        if (visibilityManager)
                            visibilityManager.exitArray();
                        if (settings.typePropertyName !== undefined) {
                            _this15.typePropertyName = settings.typePropertyName;
                        } else {
                            _this15.typePropertyName = 'type';
                        }
                        // populate array entries from data:
                        _this15._entries = [];
                        var subDatas = [];
                        if (Array.isArray(data)) {
                            subDatas = data;
                        } else if (typeof data == 'object') {
                            subDatas = data.value;
                        }
                        var defaultType = _this15.availableTypes[0];
                        for (var _i5 = 0; _i5 < subDatas.length; _i5++) {
                            var subData = subDatas[_i5];
                            var subType = defaultType;
                            if (typeof subData == 'object' && subData[_this15.typePropertyName] !== undefined) {
                                subType = subData[_this15.typePropertyName];
                            }
                            var subCtor = _this15.availableConstructors.get(subType);
                            if (subCtor) {
                                _this15._entries.push(subCtor(subData));
                            }
                        }
                        return _this15;
                    }
                    _class16.prototype.makeEntry = function makeEntry(type, data) {
                        return this.availableConstructors.get(type)(data);
                    };
                    _class16.prototype.export = function _export() {
                        var _this16 = this;
                        var defaultType = this.availableTypes[0];
                        return {
                            value: this._entries.map(function (entry) {
                                var subData = entry.export();
                                var subType = entry.name;
                                if (subType != defaultType)
                                    subData[_this16.typePropertyName] = subType;
                                return entry.shortenExport(subData);
                            })
                        };
                    };
                    _class16.prototype.fix = function fix() {
                        var _this17 = this;
                        return {
                            name: this.name,
                            entries: this._entries.map(function (entry) {
                                var subFixed = entry.fix();
                                if (typeof subFixed == 'object')
                                    subFixed[_this17.typePropertyName] = entry.name;
                                return subFixed;
                            })
                        };
                    };
                    ___babelHelper___createClass(_class16, [
                        {
                            key: 'availableTypes',
                            get: function () {
                                var types = [];
                                this.availableConstructors.forEach(function (_, type) {
                                    types.push(type);
                                });
                                return types;
                            }
                        },
                        {
                            key: 'entries',
                            get: function () {
                                return this._entries;
                            },
                            set: function (entries) {
                                this._entries = entries;
                                this.update();
                            }
                        }
                    ]);
                    return _class16;
                }(Option.Base);
                module.exports = Option;
            },
            {}
        ],
        20: [
            function (require, module, exports) {
                module.exports = function (lang) {
                    return function (strings) {
                        var additionalStringsPrefix = 'options-output';
                        var additionalStrings = {
                            en: {
                                'reset': 'Reset',
                                'drag': 'Drag',
                                'drag.tip': 'Drag or press \u2191/\u2193 while in focus to reorder items',
                                'delete': 'Delete',
                                'delete.tip': 'Delete item'
                            },
                            ru: {
                                'reset': 'Сбросить',
                                'drag': 'Перетащить',
                                'drag.tip': 'Перетаскивайте или нажимайте \u2191/\u2193, пока элемент в фокусе, чтобы изменить порядок элементов',
                                'delete': 'Удалить',
                                'delete.tip': 'Удалить элемент'
                            }
                        };
                        for (var id in additionalStrings[lang]) {
                            strings[additionalStringsPrefix + '.' + id] = additionalStrings[lang][id];
                        }
                        return strings;
                    };
                };
            },
            {}
        ],
        21: [
            function (require, module, exports) {
                var formatNumbers = require(10);
                var writeTip = require(24);
                var Option = require(19);
                var ArrayOptionOutput = require(1);
                var GroupOptionOutput = require(11);
                var OptionsOutput = function () {
                    function OptionsOutput(options, generateId, i18n) {
                        ___babelHelper___classCallCheck(this, OptionsOutput);
                        var optionClassWriters = new Map();
                        this.setOptionClassWriters(optionClassWriters);
                        function writeOption(option) {
                            var optionProto = option;
                            while (optionProto = Object.getPrototypeOf(optionProto)) {
                                var optionClassWriter = optionClassWriters.get(optionProto.constructor);
                                if (optionClassWriter) {
                                    return optionClassWriter(option, writeOption, i18n, generateId);
                                }
                            }
                        }
                        // public prop:
                        this.$output = writeOption(options.root);
                    }
                    OptionsOutput.prototype.getLeadLabel = function getLeadLabel(id, i18n, option) {
                        return '<label for=\'' + id + '\'>' + i18n('options.' + option.fullName) + ':</label><span class=\'space\'> </span>';
                    };
                    // override this fn for custom writers
                    OptionsOutput.prototype.setOptionClassWriters = function setOptionClassWriters(optionClassWriters) {
                        var _this = this;
                        optionClassWriters.set(Option.Root, function (option, writeOption, i18n, generateId) {
                            return option.$ = $('<div class=\'options-output\'>').append(option.entries.map(writeOption));
                        });
                        optionClassWriters.set(Option.Group, function () {
                            return new (Function.prototype.bind.apply(GroupOptionOutput, [null].concat(Array.prototype.slice.call(arguments))))().$output;
                        });
                        optionClassWriters.set(Option.Void, function (option, writeOption, i18n, generateId) {
                            return option.$ = $('<div class=\'option no-lead\'>').html(i18n('options.' + option.fullName));
                        });
                        optionClassWriters.set(Option.Checkbox, function (option, writeOption, i18n, generateId) {
                            var id = generateId();
                            return option.$ = $('<div class=\'option no-lead\'>').append($('<input type=\'checkbox\' id=\'' + id + '\'>').prop('checked', option.value).change(function () {
                                option.value = $(this).prop('checked');
                            }), ' <label for=\'' + id + '\'>' + i18n('options.' + option.fullName) + '</label>');
                        });
                        optionClassWriters.set(Option.Select, function (option, writeOption, i18n, generateId) {
                            var valueId = function (value) {
                                return 'options.' + option.fullName + '.' + value;
                            };
                            var valueInfoId = function (value) {
                                return 'options-info.' + option.fullName + '.' + value;
                            };
                            var id = generateId();
                            var $select = undefined;
                            option.$ = $('<div class=\'option\'>').append(_this.getLeadLabel(id, i18n, option), $select = $('<select id=\'' + id + '\'>').append(option.availableValues.map(function (availableValue) {
                                return $('<option>').val(availableValue).html(i18n(valueId(availableValue)));
                            })).val(option.value).change(function () {
                                option.value = this.value;
                            }));
                            if (option.availableValues.some(function (availableValue) {
                                    return i18n.has(valueInfoId(availableValue));
                                })) {
                                (function () {
                                    var $tip = writeTip('info', '');
                                    option.$.append(' ', $tip);
                                    var handler = function () {
                                        if (i18n.has(valueInfoId(this.value))) {
                                            $tip.find('.tip-content').html(i18n(valueInfoId(this.value)));
                                            $tip.css('display', '');    // $tip.show() won't work right with inline-block
                                        } else {
                                            $tip.css('display', 'none');
                                            $tip.find('.tip-content').empty();
                                        }
                                    };
                                    handler.call($select[0]);
                                    $select.change(handler);
                                }());
                            }
                            return option.$;
                        });
                        optionClassWriters.set(Option.Text, function (option, writeOption, i18n, generateId) {
                            var id = generateId();
                            var listId = generateId();
                            return option.$ = $('<div class=\'option\'>').append(_this.getLeadLabel(id, i18n, option), $('<input type=\'text\' id=\'' + id + '\' list=\'' + listId + '\' />').val(option.value).on('input change', function () {
                                option.value = this.value;
                            }), ' ', $('<datalist id=\'' + listId + '\'>').append(option.availableValues.map(function (availableValue) {
                                return $('<option>').text(availableValue);
                            })));
                        });
                        optionClassWriters.set(Option.Number, function (option, writeOption, i18n, generateId) {
                            var p = option.precision;
                            var setInputAttrs = function ($input) {
                                return $input.attr('min', option.availableMin).attr('max', option.availableMax).attr('step', Math.pow(0.1, p).toFixed(p));
                            };
                            var setInputAttrsAndListeners = function ($input, getOtherInput) {
                                return setInputAttrs($input).val(option.value).on('input change', function () {
                                    if (this.checkValidity()) {
                                        var $that = getOtherInput();
                                        $that.val(this.value);
                                        option.value = parseFloat(this.value);
                                    }
                                });
                            };
                            var id = generateId();
                            var $sliderInput = undefined, $numberInput = undefined;
                            var $rangeMinInput = undefined, $rangeMaxInput = undefined;
                            var fmt = formatNumbers({
                                min: option.availableMin,
                                max: option.availableMax
                            }, option.precision);
                            option.$ = $('<div class=\'option\'>').append(_this.getLeadLabel(id, i18n, option), $('<span class=\'nowrap\'>').append('<span class=\'min\'>' + i18n.numberWithUnits(fmt.min, option.unit) + '</span> ', $sliderInput = setInputAttrsAndListeners($('<input type=\'range\' id=\'' + id + '\'>'), function () {
                                return $numberInput;
                            }), ' <span class=\'max\'>' + i18n.numberWithUnits(fmt.max, option.unit) + '</span>'), ' ', $numberInput = setInputAttrsAndListeners($('<input type=\'number\' required>'), function () {
                                return $sliderInput;
                            }), ' ', $('<button type=\'button\'>' + i18n('options-output.reset') + '</button>').click(function () {
                                $sliderInput.val(option.defaultValue).change();
                            }));
                            var infoId = 'options-info.' + option.fullName;
                            if (i18n.has(infoId)) {
                                option.$.append(' ', writeTip('info', i18n(infoId)));
                            }
                            return option.$;
                        });
                        optionClassWriters.set(Option.Array, function () {
                            return new (Function.prototype.bind.apply(ArrayOptionOutput, [null].concat(Array.prototype.slice.call(arguments))))().$output;
                        });
                    };
                    return OptionsOutput;
                }();
                module.exports = OptionsOutput;
            },
            {
                '1': 1,
                '10': 10,
                '11': 11,
                '19': 19,
                '24': 24
            }
        ],
        22: [
            function (require, module, exports) {
                var OptionVisibilityManager = function () {
                    function OptionVisibilityManager() {
                        ___babelHelper___classCallCheck(this, OptionVisibilityManager);
                        this.options = {};
                        this.affects = {};
                        this.inArray = 0;
                    }
                    OptionVisibilityManager.prototype.register = function register(option) {
                        var _this = this;
                        if (!this.inArray) {
                            this.options[option.fullName] = option;
                            option.addUpdateCallback(function () {
                                _this.updateVisibilityAffectedBy(option.fullName);
                            });
                        }
                    };
                    OptionVisibilityManager.prototype.declareAffectedBy = function declareAffectedBy(option, byFullName) {
                        if (this.affects[byFullName] === undefined) {
                            this.affects[byFullName] = [];
                        }
                        this.affects[byFullName].push(option);
                    };
                    OptionVisibilityManager.prototype.updateVisibilityAffectedBy = function updateVisibilityAffectedBy(byFullName) {
                        if (this.affects[byFullName] !== undefined) {
                            this.affects[byFullName].forEach(function (option) {
                                option.updateVisibility();
                            });
                        }
                    };
                    OptionVisibilityManager.prototype.enterArray = function enterArray() {
                        this.inArray += 1;
                    };
                    OptionVisibilityManager.prototype.exitArray = function exitArray() {
                        this.inArray -= 1;
                    };
                    return OptionVisibilityManager;
                }();
                var Options = function () {
                    function Options(data) {
                        ___babelHelper___classCallCheck(this, Options);
                        // data = imported values, import is done in ctor to avoid calling updateCallback later
                        var Option = this.optionClasses;
                        var makeEntry = function (description, data, parent, visibilityManager) {
                            var _Option$className;
                            var className = description[0];
                            if (Option[className] === undefined) {
                                throw new Error('invalid option type \'' + className + '\'');
                            }
                            var makeArgs = description.slice(1);
                            return (_Option$className = Option[className]).make.apply(_Option$className, makeArgs)(data, parent, visibilityManager, makeEntry);
                        };
                        this.root = Option.Root.make(null, this.entriesDescription)(data, null, new OptionVisibilityManager(), makeEntry);
                    }
                    // methods to be redefined by subclasses
                    // TODO make them static?
                    // public methods
                    Options.prototype.addUpdateCallback = function addUpdateCallback(updateCallback) {
                        this.root.addUpdateCallback(updateCallback);
                    };
                    Options.prototype.export = function _export() {
                        return this.root.shortenExport(this.root.export());
                    };
                    Options.prototype.fix = function fix() {
                        return this.root.fix();
                    };
                    ___babelHelper___createClass(Options, [
                        {
                            key: 'optionClasses',
                            get: function () {
                                return require(19);
                            }
                        },
                        {
                            key: 'entriesDescription',
                            get: function () {
                                return [];
                            }
                        }
                    ]);
                    return Options;
                }();
                module.exports = Options;
            },
            { '19': 19 }
        ],
        23: [
            function (require, module, exports) {
                var escape = require(9);
                var Lines = require(17);
                var RefLines = function (_Lines) {
                    ___babelHelper___inherits(RefLines, _Lines);
                    function RefLines(data, ref) {
                        ___babelHelper___classCallCheck(this, RefLines);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _Lines.call(this, data));
                        _this.ref = ref;
                        return _this;
                    }
                    RefLines.parse = function parse(s) {
                        var a = Lines.ba('');
                        var re = /^(.*?)\[([^\]]+)\]\[([^\]]+)\]/;
                        for (; s.length > 0;) {
                            var match = re.exec(s);
                            if (match) {
                                a.t(match[1]);
                                a.t(this.b(match[3]).ae(match[2]));
                                s = s.substr(match[0].length);
                            } else {
                                a.t(s);
                                break;
                            }
                        }
                        return a.e();
                    };
                    RefLines.prototype.doGet = function doGet(formatting, html) {
                        var plainOut = _Lines.prototype.doGet.call(this, formatting, html);
                        var href = undefined;
                        if (html && typeof formatting.refs == 'object') {
                            href = formatting.refs[this.ref];
                        }
                        if (href !== undefined) {
                            return plainOut.map(function (s) {
                                return '<a href=\'' + escape(href) + '\'>' + s + '</a>';
                            });
                        } else {
                            return plainOut;
                        }
                    };
                    return RefLines;
                }(Lines);
                module.exports = RefLines;
            },
            {
                '17': 17,
                '9': 9
            }
        ],
        24: [
            function (require, module, exports) {
                module.exports = function (tipClass, tipContent) {
                    var $tip = $('<span class=\'tip-' + tipClass + '\' tabindex=\'0\'><span class=\'tip-content\'>' + tipContent + '</span></span>');
                    var popupTimeoutId = null;
                    var popupLevel = 0;
                    var handlePopup = function (dLevel, delay) {
                        if (delay === undefined) {
                            delay = 200;
                        }
                        if (dLevel == +1 && popupLevel == 0) {
                            clearTimeout(popupTimeoutId);
                            popupTimeoutId = setTimeout(function () {
                                // sort of hoverintent, simple delay will do b/c tip icon is small
                                $tip.addClass('open');
                            }, delay);
                        } else if (dLevel == -1 && popupLevel == 1) {
                            clearTimeout(popupTimeoutId);
                            popupTimeoutId = setTimeout(function () {
                                $tip.removeClass('open');
                            }, delay);
                        }
                        popupLevel += dLevel;
                    };
                    $tip.mouseenter(function () {
                        handlePopup(+1);
                    }).focusin(function () {
                        handlePopup(+1, 0);    // need immediate popup on focusin
                    }).on('mouseleave focusout', function () {
                        handlePopup(-1);
                    });
                    return $tip;
                };
            },
            {}
        ],
        25: [
            function (require, module, exports) {
                var _templateObject = ___babelHelper___taggedTemplateLiteralLoose([
                        '<link rel=stylesheet href=',
                        '>'
                    ], [
                        '<link rel=stylesheet href=',
                        '>'
                    ]), _templateObject2 = ___babelHelper___taggedTemplateLiteralLoose([
                        '<script src=',
                        '></script>'
                    ], [
                        '<script src=',
                        '></script>'
                    ]), _templateObject3 = ___babelHelper___taggedTemplateLiteralLoose([
                        '<html lang=',
                        '>'
                    ], [
                        '<html lang=',
                        '>'
                    ]);
                var Lines = require(17);
                var NoseWrapLines = require(18);
                var CodeSection = require(4);
                var WebCode = function () {
                    function WebCode() {
                        ___babelHelper___classCallCheck(this, WebCode);
                    }
                    WebCode.prototype.get = function get(formatting) {
                        return this.getLines().get(formatting);
                    };
                    WebCode.prototype.getHtml = function getHtml(formatting) {
                        return this.getLines().getHtml(formatting);
                    };
                    WebCode.prototype.extractSections = function extractSections(sectionModes) {
                        if (sectionModes === undefined) {
                            sectionModes = {};
                        }
                        var stylePlaceLines = NoseWrapLines.b('<style>', '</style>').ae(this.cachedStyleLines);
                        var styleExtractLines = Lines.be();
                        if (sectionModes.css == 'paste') {
                            if (sectionModes.html == 'body') {
                                stylePlaceLines = Lines.be();
                            } else {
                                stylePlaceLines = Lines.bae('<!-- <style> ' + this.getSectionPasteComment('css') + ' </style> -->');
                            }
                            styleExtractLines = this.cachedStyleLines;
                        } else if (sectionModes.css == 'file') {
                            stylePlaceLines = Lines.bae(Lines.html(_templateObject, this.basename + '.css'));
                            styleExtractLines = this.cachedStyleLines;
                        }
                        var scriptPlaceLines = NoseWrapLines.b('<script>', '</script>').ae(this.cachedScriptLines);
                        var scriptExtractLines = Lines.be();
                        if (sectionModes.js == 'paste') {
                            if (sectionModes.html == 'body') {
                                scriptPlaceLines = Lines.be();
                            } else {
                                scriptPlaceLines = Lines.bae('<!-- <script> ' + this.getSectionPasteComment('js') + ' </script> -->');
                            }
                            scriptExtractLines = this.cachedScriptLines;
                        } else if (sectionModes.js == 'file') {
                            scriptPlaceLines = Lines.bae(Lines.html(_templateObject2, this.basename + '.js'));
                            scriptExtractLines = this.cachedScriptLines;
                        }
                        var htmlExtractLines = undefined;
                        if (sectionModes.html == 'body') {
                            htmlExtractLines = this.getBodyHtmlSectionLines(stylePlaceLines, scriptPlaceLines);
                        } else {
                            htmlExtractLines = this.getFullHtmlSectionLines(stylePlaceLines, scriptPlaceLines);
                        }
                        var type = function (sectionName) {
                            return 'text/' + (sectionName == 'js' ? 'javascript' : sectionName);
                        };
                        return {
                            html: new CodeSection(this.filename, type('html'), htmlExtractLines),
                            css: new CodeSection(this.basename + '.css', type('css'), styleExtractLines),
                            js: new CodeSection(this.basename + '.js', type('js'), scriptExtractLines)
                        };
                    };
                    // get title()
                    // private:
                    WebCode.prototype.getLines = function getLines() {
                        return this.getFullHtmlSectionLines(NoseWrapLines.b('<style>', '</style>').ae(this.cachedStyleLines), NoseWrapLines.b('<script>', '</script>').ae(this.cachedScriptLines));
                    };
                    WebCode.prototype.getFullHtmlSectionLines = function getFullHtmlSectionLines(stylePlaceLines, scriptPlaceLines) {
                        var a = Lines.b();
                        a('<!DOCTYPE html>');
                        if (this.lang !== null) {
                            a(Lines.html(_templateObject3, this.lang));
                        } else {
                            a('<html>');
                        }
                        a('<head>', '<meta charset=utf-8>');
                        if (this.title !== null) {
                            a('<title>' + this.title + '</title>');
                        }
                        a(stylePlaceLines, this.cachedHeadLines, '</head>', '<body>', this.cachedBodyLines, scriptPlaceLines, '</body>', '</html>');
                        return a.e();
                    };
                    WebCode.prototype.getBodyHtmlSectionLines = function getBodyHtmlSectionLines(stylePlaceLines, scriptPlaceLines) {
                        return Lines.bae(stylePlaceLines, this.cachedHeadLines, this.cachedBodyLines, scriptPlaceLines);
                    };
                    WebCode.prototype.getSectionPasteComment = function getSectionPasteComment(sectionName) {
                        // section placeholder comment in paste mode - likely to be overridden with i18n
                        return sectionName + ' goes here';
                    };
                    ___babelHelper___createClass(WebCode, [
                        {
                            key: 'filename',
                            // public:
                            get: function () {
                                return this.basename + '.html';
                            }
                        },
                        {
                            key: 'mimeType',
                            get: function () {
                                return 'text/html';
                            }
                        },
                        {
                            key: 'cachedStyleLines',
                            get: function () {
                                if (!this._styleLines)
                                    this._styleLines = this.styleLines;
                                return this._styleLines;
                            }
                        },
                        {
                            key: 'cachedHeadLines',
                            get: function () {
                                if (!this._headLines)
                                    this._headLines = this.headLines;
                                return this._headLines;
                            }
                        },
                        {
                            key: 'cachedBodyLines',
                            get: function () {
                                if (!this._bodyLines)
                                    this._bodyLines = this.bodyLines;
                                return this._bodyLines;
                            }
                        },
                        {
                            key: 'cachedScriptLines',
                            get: function () {
                                if (!this._scriptLines)
                                    this._scriptLines = this.scriptLines;
                                return this._scriptLines;
                            }    // to be redefined in subclasses:
                        },
                        {
                            key: 'basename',
                            get: function () {
                                // filename base
                                return 'source';
                            }
                        },
                        {
                            key: 'lang',
                            get: function () {
                                // language tag for <html lang=xx> or null to skip it - likely read from i18n
                                return null;
                            }
                        },
                        {
                            key: 'title',
                            get: function () {
                                // page title or null to skip it
                                return null;
                            }
                        },
                        {
                            key: 'styleLines',
                            get: function () {
                                // contents of <style>
                                return Lines.be();
                            }
                        },
                        {
                            key: 'headLines',
                            get: function () {
                                // contents of <head> following <style>, goes to <body> in html body mode
                                return Lines.be();
                            }
                        },
                        {
                            key: 'bodyLines',
                            get: function () {
                                // contents of <body> preceding <script>
                                return Lines.be();
                            }
                        },
                        {
                            key: 'scriptLines',
                            get: function () {
                                // contents of <script>
                                return Lines.be();
                            }
                        }
                    ]);
                    return WebCode;
                }();
                module.exports = WebCode;
            },
            {
                '17': 17,
                '18': 18,
                '4': 4
            }
        ],
        26: [
            function (require, module, exports) {
                var escape = require(9);
                var Lines = require(17);
                var WrapLines = function (_Lines) {
                    ___babelHelper___inherits(WrapLines, _Lines);
                    function WrapLines(data) {
                        ___babelHelper___classCallCheck(this, WrapLines);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _Lines.call(this, data));
                        for (var _len = arguments.length, wrappers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                            wrappers[_key - 1] = arguments[_key];
                        }
                        _this.wrappers = wrappers;
                        return _this;
                    }
                    WrapLines.prototype.isEmpty = function isEmpty() {
                        return false;
                    };
                    WrapLines.prototype.doGet = function doGet(formatting, html) {
                        var _this2 = this;
                        var indent = '\t';
                        if (formatting.indent !== undefined) {
                            indent = formatting.indent;
                        }
                        var out = [];
                        var i = 0;
                        var pushWrapper = function () {
                            var item = _this2.wrappers[i];
                            if (item instanceof Lines) {
                                var subOut = item.doGet(formatting, html);
                                out.push.apply(out, subOut);
                            } else if (typeof item == 'string') {
                                var s = html ? escape(item) : item;
                                out.push(s);
                            }
                            i++;
                        };
                        pushWrapper();
                        var _arr = this.data;
                        for (var _i = 0; _i < _arr.length; _i++) {
                            var item = _arr[_i];
                            if (item instanceof Lines) {
                                var subOut = item.doGet(formatting, html);
                                out.push.apply(out, subOut.map(function (s) {
                                    return indent + s;
                                }));
                                if (this.wrappers.length != 2) {
                                    pushWrapper();
                                }
                            } else if (typeof item == 'string') {
                                var s = html ? escape(item) : item;
                                out.push(indent + s);
                                if (this.wrappers.length != 2) {
                                    pushWrapper();
                                }
                            }
                        }
                        if (this.wrappers.length == 2) {
                            pushWrapper();
                        }
                        return out;
                    };
                    return WrapLines;
                }(Lines);
                module.exports = WrapLines;
            },
            {
                '17': 17,
                '9': 9
            }
        ],
        27: [
            function (require, module, exports) {
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log10
                module.exports = Math.log10 || function (x) {
                    return Math.log(x) / Math.LN10;
                };
            },
            {}
        ],
        28: [
            function (require, module, exports) {
                module.exports = function (haystack) {
                    return function (needle, start) {
                        if (haystack != null && haystack.includes !== undefined || typeof haystack !== 'string') {
                            return haystack.includes(needle, start);
                        } else {
                            return haystack.indexOf(needle, start) !== -1;
                        }
                    };
                };
            },
            {}
        ],
        29: [
            function (require, module, exports) {
                module.exports = function (s) {
                    return function (n) {
                        if (s != null && s.repeat !== undefined || typeof s !== 'string') {
                            return s.repeat(n);
                        } else {
                            return Array(n + 1).join(s);
                        }
                    };
                };
            },
            {}
        ],
        30: [
            function (require, module, exports) {
                var JsLines = require(16);
                var RefLines = require(23);
                var Feature = require(38);
                var AudioContext = function (_Feature) {
                    ___babelHelper___inherits(AudioContext, _Feature);
                    function AudioContext(options) {
                        ___babelHelper___classCallCheck(this, AudioContext);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _Feature.call(this));
                        _this.options = options;
                        return _this;
                    }
                    AudioContext.prototype.requestFeatureContext = function requestFeatureContext(featureContext) {
                        var _this2 = this;
                        featureContext.getJsConnectAssignLines = function (decl, target, value, connectors, connectArgs) {
                            var declTarget = target;
                            if (decl != '') {
                                declTarget = decl + ' ' + target;
                            }
                            var connectArgsConcat = '';
                            if (connectArgs !== undefined) {
                                connectArgsConcat = ',' + connectArgs;
                            }
                            var a = JsLines.b();
                            if (_this2.options.connectReturnValue && Array.isArray(connectors) && connectors.length == 1) {
                                var connector = connectors[0];
                                a(declTarget + '=' + connector + '.connect(' + value + connectArgsConcat + ');');
                            } else {
                                a(declTarget + '=' + value + ';');
                                if (Array.isArray(connectors)) {
                                    a.apply(undefined, connectors.map(function (connector) {
                                        return connector + '.connect(' + target + connectArgsConcat + ');';
                                    }));
                                } else {
                                    var _connector = connectors.slice(0, -1);
                                    // hack to get singular name form plural
                                    a(connectors + '.forEach(function(' + _connector + '){', '\t' + _connector + '.connect(' + target + connectArgsConcat + ');', '});');
                                }
                            }
                            return a.e();
                        };
                    };
                    AudioContext.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                        var a = JsLines.b();
                        if (featureContext.audioContext) {
                            a(RefLines.parse('// ' + i18n('comment.context')));
                            if (this.options.noVendorPrefix) {
                                a('var ctx=new AudioContext;');
                            } else {
                                a('var ctx=new (AudioContext || webkitAudioContext);');
                            }
                        }
                        return a.e();
                    };
                    return AudioContext;
                }(Feature);
                module.exports = AudioContext;
            },
            {
                '16': 16,
                '23': 23,
                '38': 38
            }
        ],
        31: [
            function (require, module, exports) {
                var writeTip = require(24);
                var FilterOptionOutput = require(39);
                var BiquadFilterOptionOutput = function (_FilterOptionOutput) {
                    ___babelHelper___inherits(BiquadFilterOptionOutput, _FilterOptionOutput);
                    function BiquadFilterOptionOutput(option, writeOption, i18n, generateId) {
                        ___babelHelper___classCallCheck(this, BiquadFilterOptionOutput);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _FilterOptionOutput.call(this, option, writeOption, i18n, generateId));
                        var $cloneButton = undefined;
                        var computeCoefs = function (sampleRate, type, frequency, detune, Q, gain, post20160415) {
                            // constants defined in the spec
                            var F_s = sampleRate;
                            var f_0 = frequency * Math.pow(2, detune / 1200);
                            var G = gain;
                            var A = Math.pow(10, G / 40);
                            var omega_0 = 2 * Math.PI * f_0 / F_s;
                            var alpha_Q = Math.sin(omega_0) / (2 * Q);
                            var Q_dB = Math.pow(10, Q / 20);
                            // fix for incorrect alpha_B
                            var alpha_B = Math.sin(omega_0) / 2 * Math.sqrt((4 - Math.sqrt(16 - 16 / (Q_dB * Q_dB))) / 2);
                            // was incorrect in the spec
                            var alpha_Q_dB = Math.sin(omega_0) / (2 * Q_dB);
                            // introduced on 2016-04-15
                            var S = 1;
                            var alpha_S = Math.sin(omega_0) / 2 * Math.sqrt((A + 1 / A) * (1 / S - 1) + 2);
                            // shortcuts
                            var c = Math.cos(omega_0);
                            var aSA2 = 2 * alpha_S * Math.sqrt(A);
                            switch (type) {
                            case 'lowpass':
                                return {
                                    feedforward: [
                                        (1 - c) / 2,
                                        1 - c,
                                        (1 - c) / 2
                                    ],
                                    feedback: post20160415 ? [
                                        1 + alpha_Q_dB,
                                        -2 * c,
                                        1 - alpha_Q_dB
                                    ] : [
                                        1 + alpha_B,
                                        -2 * c,
                                        1 - alpha_B
                                    ]
                                };
                            case 'highpass':
                                return {
                                    feedforward: [
                                        (1 + c) / 2,
                                        -(1 + c),
                                        (1 + c) / 2
                                    ],
                                    feedback: post20160415 ? [
                                        1 + alpha_Q_dB,
                                        -2 * c,
                                        1 - alpha_Q_dB
                                    ] : [
                                        1 + alpha_B,
                                        -2 * c,
                                        1 - alpha_B
                                    ]
                                };
                            case 'bandpass':
                                return {
                                    feedforward: [
                                        alpha_Q,
                                        0,
                                        -alpha_Q
                                    ],
                                    feedback: [
                                        1 + alpha_Q,
                                        -2 * c,
                                        1 - alpha_Q
                                    ]
                                };
                            case 'notch':
                                return {
                                    feedforward: [
                                        1,
                                        -2 * c,
                                        1
                                    ],
                                    feedback: [
                                        1 + alpha_Q,
                                        -2 * c,
                                        1 - alpha_Q
                                    ]
                                };
                            case 'allpass':
                                return {
                                    feedforward: [
                                        1 - alpha_Q,
                                        -2 * c,
                                        1 + alpha_Q
                                    ],
                                    feedback: [
                                        1 + alpha_Q,
                                        -2 * c,
                                        1 - alpha_Q
                                    ]
                                };
                            case 'peaking':
                                return {
                                    feedforward: [
                                        1 + alpha_Q * A,
                                        -2 * c,
                                        1 - alpha_Q * A
                                    ],
                                    feedback: [
                                        1 + alpha_Q / A,
                                        -2 * c,
                                        1 - alpha_Q / A
                                    ]
                                };
                            case 'lowshelf':
                                return {
                                    feedforward: [
                                        A * (A + 1 - (A - 1) * c + aSA2),
                                        2 * A * (A - 1 - (A + 1) * c),
                                        A * (A + 1 - (A - 1) * c - aSA2)
                                    ],
                                    feedback: [
                                        A + 1 + (A - 1) * c + aSA2,
                                        -2 * (A - 1 + (A + 1) * c),
                                        A + 1 + (A - 1) * c - aSA2
                                    ]
                                };
                            case 'highshelf':
                                return {
                                    feedforward: [
                                        A * (A + 1 + (A - 1) * c + aSA2),
                                        -2 * A * (A - 1 + (A + 1) * c),
                                        A * (A + 1 + (A - 1) * c - aSA2)
                                    ],
                                    feedback: [
                                        A + 1 - (A - 1) * c + aSA2,
                                        2 * (A - 1 - (A + 1) * c),
                                        A + 1 - (A - 1) * c - aSA2
                                    ]
                                };
                            }
                        };
                        var This = _this;
                        var $cloneUi = undefined;
                        var writeCloneButton = function (post20160415) {
                            return $('<button type=\'button\' class=\'clone\'>' + i18n('options-output.filter.biquad.clone.' + (post20160415 ? 'post' : 'pre')) + '</button>').click(function () {
                                var _this2 = this;
                                This.runIfCanCreateAudioContext(function (audioContext) {
                                    var fixedOption = option.fix();
                                    var coefs = computeCoefs(audioContext.sampleRate, fixedOption.type.value, fixedOption.frequency.value, fixedOption.detune.value, Math.pow(10, fixedOption.Q.value), fixedOption.gain.value, post20160415);
                                    if (coefs) {
                                        $(_this2).data('coefs', coefs);
                                    } else {
                                        $(_this2).removeData('coefs');
                                    }
                                }, $cloneUi, i18n('options-output.filter.contextError'));
                            });
                        };
                        _this.$output.append($('<div class=\'option only-buttons\'>').append('<label>' + i18n('options-output.filter.biquad.clone') + ':</label><span class=\'space\'> </span>', $cloneUi = $('<span>').append(writeCloneButton(false), ' ', writeCloneButton(true), ' ', writeTip('info', i18n('options-output.filter.biquad.clone.info')))));
                        return _this;
                    }
                    BiquadFilterOptionOutput.prototype.getFilterNodes = function getFilterNodes(audioContext) {
                        var biquadNode = audioContext.createBiquadFilter();
                        var fixedOption = this.option.fix();
                        biquadNode.type = fixedOption.type.value;
                        biquadNode.frequency.value = fixedOption.frequency.value;
                        biquadNode.detune.value = fixedOption.detune.value;
                        biquadNode.Q.value = Math.pow(10, fixedOption.Q.value);
                        biquadNode.gain.value = fixedOption.gain.value;
                        return [biquadNode];
                    };
                    return BiquadFilterOptionOutput;
                }(FilterOptionOutput);
                module.exports = BiquadFilterOptionOutput;
            },
            {
                '24': 24,
                '39': 39
            }
        ],
        32: [
            function (require, module, exports) {
                var _templateObject = ___babelHelper___taggedTemplateLiteralLoose([
                    '\t<canvas id=my.canvas width=',
                    ' height=',
                    '></canvas>'
                ], [
                    '\t<canvas id=my.canvas width=',
                    ' height=',
                    '></canvas>'
                ]);
                var Lines = require(17);
                var JsLines = require(16);
                var Feature = require(38);
                var Canvas = function (_Feature) {
                    ___babelHelper___inherits(Canvas, _Feature);
                    function Canvas(options) {
                        ___babelHelper___classCallCheck(this, Canvas);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _Feature.call(this));
                        _this.options = options;
                        return _this;
                    }
                    Canvas.getStyleLines = function getStyleLines(canvasContextProperty, colorOption) {
                        var a = JsLines.b();
                        var cs = [
                            'r',
                            'g',
                            'b'
                        ];
                        var color = cs.map(function (c) {
                            return colorOption[c] + '%';
                        }).join();
                        var isBlack = cs.every(function (c) {
                            return colorOption[c] == 0;
                        });
                        if (colorOption.a == 100) {
                            if (!isBlack) {
                                a('canvasContext.' + canvasContextProperty + '=\'rgb(' + color + ')\';');
                            }
                        } else {
                            a('canvasContext.' + canvasContextProperty + '=\'rgba(' + color + ',' + (colorOption.a / 100).toFixed(2) + ')\';');
                        }
                        return a.e();
                    };
                    Canvas.prototype.getHtmlLines = function getHtmlLines(featureContext, i18n) {
                        var a = Lines.b();
                        if (featureContext.canvas) {
                            a('<div>', Lines.html(_templateObject, this.options.width, this.options.height), '</div>');
                        }
                        return a.e();
                    };
                    Canvas.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                        var a = JsLines.b();
                        if (featureContext.canvas) {
                            a('var canvas=document.getElementById(\'my.canvas\');', 'var canvasContext=canvas.getContext(\'2d\');');
                        }
                        if (featureContext.canvasVolumeGradient) {
                            a('var canvasVolumeGradient=canvasContext.createLinearGradient(0,0,0,canvas.height);', 'canvasVolumeGradient.addColorStop(1.00,\'#000\');', 'canvasVolumeGradient.addColorStop(0.75,\'#F00\');', 'canvasVolumeGradient.addColorStop(0.25,\'#FF0\');', 'canvasVolumeGradient.addColorStop(0.00,\'#FFF\');');
                        }
                        return a.e();
                    };
                    Canvas.prototype.getJsLoopPreLines = function getJsLoopPreLines(featureContext, i18n) {
                        var a = JsLines.b();
                        if (featureContext.canvas) {
                            if (this.options.background.type == 'clear') {
                                a('canvasContext.clearRect(0,0,canvas.width,canvas.height);');
                            } else {
                                a(Canvas.getStyleLines('fillStyle', this.options.background.color));
                                a('canvasContext.fillRect(0,0,canvas.width,canvas.height);');
                            }
                        }
                        return a.e();
                    };
                    return Canvas;
                }(Feature);
                module.exports = Canvas;
            },
            {
                '16': 16,
                '17': 17,
                '38': 38
            }
        ],
        33: [
            function (require, module, exports) {
                var writeTip = require(24);
                var BaseCodeOutput = require(3);
                var CodeOutput = function (_BaseCodeOutput) {
                    ___babelHelper___inherits(CodeOutput, _BaseCodeOutput);
                    function CodeOutput() {
                        ___babelHelper___classCallCheck(this, CodeOutput);
                        return ___babelHelper___possibleConstructorReturn(this, _BaseCodeOutput.apply(this, arguments));
                    }
                    CodeOutput.prototype.initDomProps = function initDomProps() {
                        _BaseCodeOutput.prototype.initDomProps.call(this);
                        this.$warnings = $();
                    };
                    CodeOutput.prototype.applyUpdatedCode = function applyUpdatedCode(i18n) {
                        _BaseCodeOutput.prototype.applyUpdatedCode.call(this, i18n);
                        this.$warnings.css('display', this.code.isInteresting ? 'none' : '');    // .toggle() won't work right with inline-block
                    };
                    CodeOutput.prototype.writeButtons = function writeButtons(i18n) {
                        var $warning = writeTip('warn', i18n('code-output.warning.jsfiddle-run'));
                        return _BaseCodeOutput.prototype.writeButtons.call(this, i18n).append(' ', $warning);
                    };
                    CodeOutput.prototype.writeSectionSummary = function writeSectionSummary(sectionName, i18n) {
                        var $section = _BaseCodeOutput.prototype.writeSectionSummary.call(this, sectionName, i18n);
                        if (sectionName == 'html' || sectionName == 'js') {
                            var $warning = writeTip('warn', i18n('code-output.warning.interesting'));
                            $section.append(' ', $warning);
                            this.$warnings = this.$warnings.add($warning);
                        }
                        return $section;
                    };
                    ___babelHelper___createClass(CodeOutput, [{
                            key: 'defaultFormatting',
                            get: function () {
                                var formatting = _BaseCodeOutput.prototype.defaultFormatting;
                                formatting.refs = {
                                    context: 'https://www.w3.org/TR/webaudio/#AudioContext',
                                    source: 'https://www.w3.org/TR/webaudio/#MediaElementAudioSourceNode',
                                    gain: 'https://www.w3.org/TR/webaudio/#GainNode',
                                    panner: 'https://www.w3.org/TR/webaudio/#the-stereopannernode-interface',
                                    biquad: 'https://www.w3.org/TR/webaudio/#the-biquadfilternode-interface',
                                    iir: 'https://www.w3.org/TR/webaudio/#the-iirfilternode-interface',
                                    convolver: 'https://www.w3.org/TR/webaudio/#ConvolverNode',
                                    peaking: 'https://www.w3.org/TR/webaudio/#idl-def-BiquadFilterType.peaking',
                                    destination: 'https://www.w3.org/TR/webaudio/#AudioDestinationNode',
                                    compressor: 'https://www.w3.org/TR/webaudio/#the-dynamicscompressornode-interface',
                                    analyser: 'https://www.w3.org/TR/webaudio/#the-analysernode-interface',
                                    splitter: 'https://www.w3.org/TR/webaudio/#the-channelsplitternode-interface',
                                    buffer: 'https://www.w3.org/TR/webaudio/#AudioBufferSourceNode'
                                };
                                return formatting;
                            }
                        }]);
                    return CodeOutput;
                }(BaseCodeOutput);
                module.exports = CodeOutput;
            },
            {
                '24': 24,
                '3': 3
            }
        ],
        34: [
            function (require, module, exports) {
                var AudioContext = require(30);
                var Loader = require(43);
                var SourceSet = require(48);
                var FilterSequence = require(40);
                var Destination = require(36);
                var Canvas = require(32);
                var Lines = require(17);
                var JsLines = require(16);
                var InterleaveLines = require(15);
                var NoseWrapLines = require(18);
                var BaseWebCode = require(25);
                var Code = function (_BaseWebCode) {
                    ___babelHelper___inherits(Code, _BaseWebCode);
                    function Code(options, i18n) {
                        ___babelHelper___classCallCheck(this, Code);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _BaseWebCode.call(this));
                        _this.i18n = i18n;
                        _this.featureContext = {};
                        _this.features = [
                            new AudioContext(options.api),
                            new Loader(options.loader),
                            new SourceSet(options.sources),
                            new FilterSequence(options.filters),
                            new Destination(options.destination),
                            new Canvas(options.canvas)
                        ];
                        // possible feature context flags:
                        //	audioContext = AudioContext has to assign the audio context to var ctx
                        //	canvasVolumeGradient = Canvas has to create canvasVolumeGradient
                        //	connectSampleToCompressor = this is a hack
                        //	connectSampleToJsNames = this is a hack: array of strings to connect samples to
                        //	loader = Loader has to provide loadSample() function
                        //	loaderOnError = loadSample() caller has to pass the error handler
                        //	setConnectSampleToJsNames = have a node(s) to connect samples to (some filters like equaliser may not save a refernce to it otherwise)
                        //	TODO the rest
                        // helpers:
                        //	getJsConnectAssignLines = set by AudioContext
                        var _arr = _this.features;
                        for (var _i = 0; _i < _arr.length; _i++) {
                            var feature = _arr[_i];
                            feature.requestFeatureContext(_this.featureContext);
                        }
                        _this.isInteresting = !!_this.featureContext.audioContext;
                        return _this;
                    }
                    ___babelHelper___createClass(Code, [
                        {
                            key: 'basename',
                            get: function () {
                                return 'webaudio';
                            }
                        },
                        {
                            key: 'lang',
                            get: function () {
                                return this.i18n.lang;
                            }
                        },
                        {
                            key: 'title',
                            get: function () {
                                return this.i18n('code.title');
                            }
                        },
                        {
                            key: 'styleLines',
                            get: function () {
                                var a = Lines.b();
                                if (this.featureContext.alignedInputs) {
                                    a('label {', '\tdisplay: inline-block;', '\twidth: 15em;', '\ttext-align: right;', '\tline-height: 0.8em;', '}', '.min {', '\tdisplay: inline-block;', '\twidth: 5em;', '\ttext-align: right;', '}', '.max {', '\tdisplay: inline-block;', '\twidth: 5em;', '\ttext-align: left;', '}');
                                }
                                if (this.featureContext.canvas) {
                                    a('canvas {', '\tborder: 1px solid;', '}');
                                }
                                return a.e();
                            }
                        },
                        {
                            key: 'bodyLines',
                            get: function () {
                                var _this2 = this;
                                return Lines.bae.apply(Lines, this.features.map(function (feature) {
                                    return feature.getHtmlLines(_this2.featureContext, _this2.i18n);
                                }));
                            }
                        },
                        {
                            key: 'scriptLines',
                            get: function () {
                                var _this3 = this, _NoseWrapLines$b;
                                var prevNodeJsNames = [];
                                return InterleaveLines.bae.apply(InterleaveLines, this.features.map(function (feature) {
                                    var lines = feature.getJsInitLines(_this3.featureContext, _this3.i18n, prevNodeJsNames);
                                    prevNodeJsNames = feature.getNodeJsNames(_this3.featureContext, prevNodeJsNames);
                                    return lines;
                                }).concat([(_NoseWrapLines$b = NoseWrapLines.b(JsLines.bae('function visualize() {'), JsLines.bae('\trequestAnimationFrame(visualize);', '}', 'requestAnimationFrame(visualize);'))).ae.apply(_NoseWrapLines$b, this.features.map(function (feature) {
                                        return feature.getJsLoopPreLines(_this3.featureContext, _this3.i18n);
                                    }).concat(this.features.map(function (feature) {
                                        return feature.getJsLoopVisLines(_this3.featureContext, _this3.i18n);
                                    })))]));
                            }
                        }
                    ]);
                    return Code;
                }(BaseWebCode);
                module.exports = Code;
            },
            {
                '15': 15,
                '16': 16,
                '17': 17,
                '18': 18,
                '25': 25,
                '30': 30,
                '32': 32,
                '36': 36,
                '40': 40,
                '43': 43,
                '48': 48
            }
        ],
        35: [
            function (require, module, exports) {
                var Lines = require(17);
                var Feature = require(38);
                var CollectionFeature = function (_Feature) {
                    ___babelHelper___inherits(CollectionFeature, _Feature);
                    function CollectionFeature(entryOptions) {
                        ___babelHelper___classCallCheck(this, CollectionFeature);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _Feature.call(this));
                        var entryCounts = new Map();
                        entryOptions.entries.forEach(function (entryOption) {
                            var entryClass = _this.getEntryClass(entryOption);
                            entryCounts.set(entryClass, entryCounts.get(entryClass) + 1 || 1);
                        });
                        var entryCounts2 = new Map();
                        _this.entries = entryOptions.entries.map(function (entryOption) {
                            var entryClass = _this.getEntryClass(entryOption);
                            if (entryCounts.get(entryClass) > 1) {
                                var n = entryCounts2.get(entryClass) || 0;
                                entryCounts2.set(entryClass, n + 1);
                                return new entryClass(entryOption, n);
                            } else {
                                return new entryClass(entryOption);
                            }
                        });
                        return _this;
                    }
                    CollectionFeature.prototype.getHtmlLines = function getHtmlLines(featureContext, i18n) {
                        return Lines.bae.apply(Lines, this.entries.map(function (entry) {
                            return entry.getHtmlLines(featureContext, i18n);
                        }));
                    };
                    // abstract:
                    // getEntryClass(entryOption) {}
                    return CollectionFeature;
                }(Feature);
                module.exports = CollectionFeature;
            },
            {
                '17': 17,
                '38': 38
            }
        ],
        36: [
            function (require, module, exports) {
                var _templateObject = ___babelHelper___taggedTemplateLiteralLoose([
                    '<label for=my.compressor>',
                    '</label>'
                ], [
                    '<label for=my.compressor>',
                    '</label>'
                ]);
                var Lines = require(17);
                var JsLines = require(16);
                var WrapLines = require(26);
                var NoseWrapLines = require(18);
                var InterleaveLines = require(15);
                var RefLines = require(23);
                var Feature = require(38);
                var Canvas = require(32);
                var Destination = function (_Feature) {
                    ___babelHelper___inherits(Destination, _Feature);
                    function Destination(options) {
                        ___babelHelper___classCallCheck(this, Destination);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _Feature.call(this));
                        _this.options = options;
                        return _this;
                    }
                    Destination.prototype.requestFeatureContext = function requestFeatureContext(featureContext) {
                        if (!featureContext.audioProcessing)
                            return;
                        if (this.options.compressor.enabled || this.options.waveform.enabled || this.options.frequencies.enabled || this.options.volume.enabled) {
                            featureContext.audioContext = true;
                        }
                        if (this.options.waveform.enabled || this.options.frequencies.enabled || this.options.volume.enabled) {
                            featureContext.canvas = true;
                        }
                        if (this.options.volume.enabled) {
                            featureContext.canvasVolumeGradient = true;
                        }
                        if (featureContext.connectSampleToJsNames === undefined) {
                            if (this.options.compressor.enabled) {
                                featureContext.connectSampleToCompressor = true;
                            }
                            featureContext.connectSampleToJsNames = [];
                            if (this.useDirectAnalyser) {
                                featureContext.connectSampleToJsNames.push('analyserNode');
                            }
                            if (this.useSplitAnalyser) {
                                featureContext.connectSampleToJsNames.push('channelSplitterNode');
                            }
                            if (featureContext.connectSampleToJsNames.length == 0) {
                                featureContext.connectSampleToJsNames = ['ctx.destination'];
                            }
                        }
                    };
                    Destination.prototype.getHtmlLines = function getHtmlLines(featureContext, i18n) {
                        var a = NoseWrapLines.b('<div>', '</div>');
                        if (featureContext.audioProcessing && this.options.compressor.enabled) {
                            a('<input id=my.compressor type=checkbox checked>', Lines.html(_templateObject, i18n('label.destination.compressor')));
                        }
                        return a.e();
                    };
                    Destination.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                        var _this2 = this;
                        var getAnalyserNodeLines = function (jsName, prevNodeJsNames, connectArgs) {
                            var a = JsLines.b();
                            a(featureContext.getJsConnectAssignLines('var', jsName, 'ctx.createAnalyser()', prevNodeJsNames, connectArgs));
                            if (_this2.options.analyser.logFftSize != 11) {
                                // default FFT size is 2048
                                a(jsName + '.fftSize=' + (1 << _this2.options.analyser.logFftSize) + ';');
                            }
                            return a.e();
                        };
                        var getCompressorLines = function () {
                            var a = JsLines.b();
                            var nextNodeJsName = _this2.options.waveform.enabled || _this2.options.frequencies.enabled || _this2.options.volume.enabled ? 'analyserNode' : 'ctx.destination';
                            a(RefLines.parse('// ' + i18n('comment.destination.compressor')), featureContext.getJsConnectAssignLines('var', 'compressorNode', 'ctx.createDynamicsCompressor()', prevNodeJsNames));
                            if (prevNodeJsNames.length > 0) {
                                a.apply(undefined, [
                                    'document.getElementById(\'my.compressor\').onchange=function(){',
                                    '\tif (this.checked) {'
                                ].concat(prevNodeJsNames.map(function (prevNodeJsName) {
                                    return '\t\t' + prevNodeJsName + '.disconnect(' + nextNodeJsName + ');';
                                }), prevNodeJsNames.map(function (prevNodeJsName) {
                                    return '\t\t' + prevNodeJsName + '.connect(compressorNode);';
                                }), ['\t} else {'], prevNodeJsNames.map(function (prevNodeJsName) {
                                    return '\t\t' + prevNodeJsName + '.disconnect(compressorNode);';
                                }), prevNodeJsNames.map(function (prevNodeJsName) {
                                    return '\t\t' + prevNodeJsName + '.connect(' + nextNodeJsName + ');';
                                }), [
                                    '\t}',
                                    '};'
                                ]));
                            }
                            return a.e();
                        };
                        var getDirectAnalyserLines = function () {
                            var a = JsLines.b();
                            var comment = '';
                            if (_this2.options.waveform.enabled && !_this2.options.frequencies.enabled) {
                                comment = '.waveform';
                            } else if (!_this2.options.waveform.enabled && _this2.options.frequencies.enabled) {
                                comment = '.frequencies';
                            } else if (_this2.options.waveform.enabled && _this2.options.frequencies.enabled) {
                                comment = '.waveform+frequencies';
                            }
                            a(RefLines.parse('// ' + i18n('comment.destination.analyser' + comment)), getAnalyserNodeLines('analyserNode', prevNodeJsNames), 'var analyserData=new Uint8Array(analyserNode.frequencyBinCount);');
                            return a.e();
                        };
                        var getSplitAnalyserLines = function () {
                            var a = JsLines.b();
                            a(RefLines.parse('// ' + i18n('comment.destination.analyser.split')), featureContext.getJsConnectAssignLines('var', 'channelSplitterNode', 'ctx.createChannelSplitter()', prevNodeJsNames), getAnalyserNodeLines('leftAnalyserNode', ['channelSplitterNode'], '0'), getAnalyserNodeLines('rightAnalyserNode', ['channelSplitterNode'], '1'));
                            if (!_this2.useDirectAnalyser) {
                                // need to create analyserData once
                                a('var analyserData=new Uint8Array(leftAnalyserNode.frequencyBinCount);');
                            }
                            return a.e();
                        };
                        var getDestinationLines = function () {
                            var a = JsLines.b();
                            if (prevNodeJsNames.length > 0) {
                                a.apply(undefined, [RefLines.parse('// ' + i18n('comment.destination'))].concat(prevNodeJsNames.map(function (prevNodeJsName) {
                                    return prevNodeJsName + '.connect(ctx.destination);';
                                })));
                            }
                            return a.e();
                        };
                        var a = InterleaveLines.b();
                        if (featureContext.audioProcessing && featureContext.audioContext) {
                            if (this.options.compressor.enabled) {
                                a(getCompressorLines());
                                prevNodeJsNames = ['compressorNode'];
                            }
                            if (this.useDirectAnalyser || this.useSplitAnalyser) {
                                if (this.useDirectAnalyser) {
                                    a(getDirectAnalyserLines());
                                }
                                if (this.useSplitAnalyser) {
                                    a(getSplitAnalyserLines());
                                }
                                if (this.useDirectAnalyser) {
                                    prevNodeJsNames = ['analyserNode'];
                                }    // split analyser doesn't change prevNodeJsNames b/c its output is not connected to anything
                            }
                            a(getDestinationLines());
                        }
                        return a.e();
                    };
                    Destination.prototype.getJsLoopPreLines = function getJsLoopPreLines(featureContext, i18n) {
                        var _this3 = this;
                        if (!featureContext.audioProcessing)
                            return Lines.be();
                        var getEnterFunctionLines = function () {
                            if (_this3.pushContextForEach) {
                                return JsLines.bae('canvasContext.save();');
                            } else {
                                return Lines.be();
                            }
                        };
                        var getExitFunctionLines = function () {
                            if (_this3.pushContextForEach) {
                                return JsLines.bae('canvasContext.restore();');
                            } else {
                                return Lines.be();
                            }
                        };
                        var getVisualizeVolumeLines = function () {
                            var getVolumeMeterLines = function (analyserNodeJsName, xOffset) {
                                return JsLines.bae(analyserNodeJsName + '.getByteFrequencyData(analyserData);', // TODO reuse in frequencies when in non-stereo mode
                                'var sumAmplitudes=0;', 'for (var i=0;i<analyserData.length;i++) {', '\tsumAmplitudes+=analyserData[i];', '}', 'var meanAmplitude=sumAmplitudes/analyserData.length;', 'var barHeight=meanAmplitude*canvas.height/256;', 'canvasContext.fillStyle=canvasVolumeGradient;', 'canvasContext.fillRect(' + xOffset + ',canvas.height-barHeight,25,barHeight);');
                            };
                            if (!_this3.options.volume.stereo) {
                                return getVolumeMeterLines('analyserNode', '0');
                            } else {
                                return WrapLines.b(JsLines.bae(';[leftAnalyserNode,rightAnalyserNode].forEach(function(channelAnalyserNode,channelNumber){'), JsLines.bae('});')).ae(getVolumeMeterLines('channelAnalyserNode', 'channelNumber*26'));
                            }
                        };
                        var getVisualizeFrequenciesLines = function () {
                            var a = JsLines.b();
                            var nBars = 'analyserData.length';
                            if (_this3.options.frequencies.cutoff != 100) {
                                a('var nBars=Math.floor(analyserData.length*' + (_this3.options.frequencies.cutoff / 100).toFixed(2) + ');');
                                nBars = 'nBars';
                            }
                            var y = _this3.options.frequencies.base == 'bottom' ? 'canvas.height-barHeight' : '(canvas.height-barHeight)/2';
                            var colorInput = _this3.options.frequencies.coloringInput == 'amplitude' ? 'analyserData[i]' : 'Math.round(i*255/' + nBars + ')';
                            var fillStyle = _this3.options.frequencies.coloring == 'component' ? '\'rgb(\'+(' + colorInput + '+100)+\',50,50)\'' : '\'hsl(\'+(255-' + colorInput + ')+\',100%,50%)\'';
                            a('var barWidth=canvas.width/' + nBars + '*0.8;', 'analyserNode.getByteFrequencyData(analyserData);', 'for (var i=0;i<' + nBars + ';i++) {', '\tvar x=i*canvas.width/' + nBars + ';', '\tcanvasContext.fillStyle=' + fillStyle + ';', '\tvar barHeight=analyserData[i]*canvas.height/256;', '\tvar y=' + y + ';', '\tcanvasContext.fillRect(x,y,barWidth,barHeight);', '}');
                            if (_this3.options.frequencies.outline.enabled) {
                                var writeOutline = function (y) {
                                    return JsLines.bae('for (var i=0;i<' + nBars + ';i++) {', '\tvar x=i*canvas.width/' + nBars + ';', '\tvar barHeight=analyserData[i]*canvas.height/256;', '\tvar y=' + y + ';', '\tif (i==0) {', '\t\tcanvasContext.moveTo(0,y);', '\t}', '\tcanvasContext.lineTo(x+barWidth/2,y);', '\tif (i==' + nBars + '-1) {', '\t\tcanvasContext.lineTo(canvas.width,y);', '\t}', '}');
                                };
                                if (_this3.options.frequencies.outline.width != 1) {
                                    a('canvasContext.lineWidth=' + _this3.options.frequencies.outline.width + ';');
                                }
                                a(Canvas.getStyleLines('strokeStyle', _this3.options.frequencies.outline.color));
                                a('canvasContext.beginPath();');
                                if (_this3.options.frequencies.base == 'bottom') {
                                    a(writeOutline(y));
                                } else {
                                    a(WrapLines.b(JsLines.bae(';[-1,+1].forEach(function(aboveOrBelow){'), JsLines.bae('});')).ae(writeOutline('(canvas.height+aboveOrBelow*barHeight)/2')));
                                }
                                a('canvasContext.stroke();');
                            }
                            return a.e();
                        };
                        var getVisualizeWaveformLines = function () {
                            var a = JsLines.b();
                            if (_this3.options.waveform.width != 1) {
                                a('canvasContext.lineWidth=' + _this3.options.waveform.width + ';');
                            }
                            a(Canvas.getStyleLines('strokeStyle', _this3.options.waveform.color), 'analyserNode.getByteTimeDomainData(analyserData);', 'canvasContext.beginPath();', 'for (var i=0;i<analyserData.length;i++) {', '\tvar x=i*canvas.width/(analyserData.length-1);', '\tvar y=analyserData[i]*canvas.height/256;', '\tif (i==0) {', '\t\tcanvasContext.moveTo(x,y);', '\t} else {', '\t\tcanvasContext.lineTo(x,y);', '\t}', '}', 'canvasContext.stroke();');
                            return a.e();
                        };
                        return JsLines.bae.apply(JsLines, [
                            [
                                this.options.volume.enabled,
                                'visualizeVolume',
                                getVisualizeVolumeLines
                            ],
                            [
                                this.options.frequencies.enabled,
                                'visualizeFrequencies',
                                getVisualizeFrequenciesLines
                            ],
                            [
                                this.options.waveform.enabled,
                                'visualizeWaveform',
                                getVisualizeWaveformLines
                            ]
                        ].map(function (conditionAndNameAndFn) {
                            var condition = conditionAndNameAndFn[0];
                            var name = conditionAndNameAndFn[1];
                            var fn = conditionAndNameAndFn[2];
                            if (condition) {
                                return WrapLines.b(JsLines.bae('function ' + name + '() {'), JsLines.bae('}')).ae(getEnterFunctionLines(), fn(), getExitFunctionLines());
                            } else {
                                return Lines.be();
                            }
                        }));
                    };
                    Destination.prototype.getJsLoopVisLines = function getJsLoopVisLines(featureContext, i18n) {
                        if (!featureContext.audioProcessing)
                            return Lines.be();
                        var a = JsLines.b();
                        if (this.pushContextForAll) {
                            a('canvasContext.save();');
                        }
                        if (this.options.volume.enabled) {
                            a('visualizeVolume();');
                        }
                        if (this.options.frequencies.enabled) {
                            a('visualizeFrequencies();');
                        }
                        if (this.options.waveform.enabled) {
                            a('visualizeWaveform();');
                        }
                        if (this.pushContextForAll) {
                            a('canvasContext.restore();');
                        }
                        return a.e();
                    };
                    Destination.prototype.getNodeJsNames = function getNodeJsNames(featureContext, prevNodeJsNames) {
                        if (!featureContext.audioProcessing)
                            return prevNodeJsNames;
                        if (featureContext.audioContext) {
                            return ['ctx.destination'];
                        } else {
                            return prevNodeJsNames;
                        }
                    };
                    ___babelHelper___createClass(Destination, [
                        {
                            key: 'useDirectAnalyser',
                            get: function () {
                                return this.options.waveform.enabled || this.options.frequencies.enabled || this.options.volume.enabled && !this.options.volume.stereo;
                            }
                        },
                        {
                            key: 'useSplitAnalyser',
                            get: function () {
                                return this.options.volume.enabled && this.options.volume.stereo;
                            }
                        },
                        {
                            key: 'pushContextForEach',
                            get: function () {
                                // when stroke style is altered in two different places
                                return this.options.frequencies.enabled && this.options.frequencies.outline.enabled && this.options.waveform.enabled;
                            }
                        },
                        {
                            key: 'pushContextForAll',
                            get: function () {
                                // when fill style is altered and not pushing for each
                                return !this.pushContextForEach && (this.options.frequencies.enabled || this.options.volume.enabled);
                            }
                        }
                    ]);
                    return Destination;
                }(Feature);
                module.exports = Destination;
            },
            {
                '15': 15,
                '16': 16,
                '17': 17,
                '18': 18,
                '23': 23,
                '26': 26,
                '32': 32,
                '38': 38
            }
        ],
        37: [
            function (require, module, exports) {
                var Option = require(45);
                var FilterOptionOutput = require(39);
                var EqualizerFilterOptionOutput = function (_FilterOptionOutput) {
                    ___babelHelper___inherits(EqualizerFilterOptionOutput, _FilterOptionOutput);
                    function EqualizerFilterOptionOutput() {
                        ___babelHelper___classCallCheck(this, EqualizerFilterOptionOutput);
                        return ___babelHelper___possibleConstructorReturn(this, _FilterOptionOutput.apply(this, arguments));
                    }
                    EqualizerFilterOptionOutput.prototype.getFilterNodes = function getFilterNodes(audioContext) {
                        var fixedOption = this.option.fix();
                        return Option.EqualizerFilter.frequencies.map(function (freq) {
                            var biquadNode = audioContext.createBiquadFilter();
                            biquadNode.type = 'peaking';
                            biquadNode.frequency.value = freq;
                            biquadNode.gain.value = fixedOption['gain' + freq].value;
                            return biquadNode;
                        });
                    };
                    return EqualizerFilterOptionOutput;
                }(FilterOptionOutput);
                module.exports = EqualizerFilterOptionOutput;
            },
            {
                '39': 39,
                '45': 45
            }
        ],
        38: [
            function (require, module, exports) {
                var Lines = require(17);
                var Feature = function () {
                    function Feature() {
                        ___babelHelper___classCallCheck(this, Feature);
                    }
                    Feature.prototype.requestFeatureContext = function requestFeatureContext(featureContext) {
                    };
                    Feature.prototype.getHtmlLines = function getHtmlLines(featureContext, i18n) {
                        return Lines.be();
                    };
                    Feature.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                        return Lines.be();
                    };
                    Feature.prototype.getJsLoopPreLines = function getJsLoopPreLines(featureContext, i18n) {
                        return Lines.be();
                    };
                    Feature.prototype.getJsLoopVisLines = function getJsLoopVisLines(featureContext, i18n) {
                        return Lines.be();
                    };
                    Feature.prototype.getNodeJsNames = function getNodeJsNames(featureContext, prevNodeJsNames) {
                        return prevNodeJsNames;
                    };
                    return Feature;
                }();
                module.exports = Feature;
            },
            { '17': 17 }
        ],
        39: [
            function (require, module, exports) {
                var debounce = require(8);
                var formatNumbers = require(10);
                var GroupOptionOutput = require(11);
                var width = 300;
                var height = 300;
                var pad = 30;
                var maxNGridLines = 10;
                var fontSize = 10;
                var fontOffset = 3;
                var minFrequencyInLogMode = 10;
                var audioContext = undefined;
                var linearFrequencyArray = undefined, logFrequencyArray = undefined;
                var logFrequencyArrayLinearLimit0 = undefined, logFrequencyArrayLinearLimit1 = undefined;
                var magnitudeArray = undefined, phaseArray = undefined;
                var magnitudeArray0 = undefined, phaseArray0 = undefined;
                var mix = function (a, b, x) {
                    return a * (1 - x) + b * x;
                };
                var FilterOptionOutput = function (_GroupOptionOutput) {
                    ___babelHelper___inherits(FilterOptionOutput, _GroupOptionOutput);
                    function FilterOptionOutput(option, writeOption, i18n, generateId) {
                        ___babelHelper___classCallCheck(this, FilterOptionOutput);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _GroupOptionOutput.call(this, option, writeOption, i18n, generateId));
                        var $freqResponseUi = $();
                        var isFreqResponseUiShown = function () {
                            return $freqResponseUi.length > 0;
                        };
                        var magnitudeCanvasContext = undefined, phaseCanvasContext = undefined;
                        // TODO remove loitering on hide - but have to cancel update
                        var magnitudeLogScale = true, frequencyLogScale = false;
                        var updatePlots = function (filterNodes) {
                            var removeNans = function (array) {
                                var interpolate = function (i0, i1) {
                                    var hasStartValue = i0 >= 0;
                                    var hasEndValue = i1 < array.length;
                                    var v0 = undefined, v1 = undefined;
                                    if (!hasStartValue && !hasEndValue) {
                                        v0 = v1 = 0;
                                    } else {
                                        if (hasStartValue) {
                                            v0 = array[i0];
                                        } else {
                                            v0 = array[i1];
                                        }
                                        if (hasEndValue) {
                                            v1 = array[i1];
                                        } else {
                                            v1 = array[i0];
                                        }
                                    }
                                    for (var i = i0 + 1; i < i1; i++) {
                                        var x = (i - i0) / (i1 - i0);
                                        array[i] = mix(v0, v1, x);
                                    }
                                };
                                var nanStart = -1;
                                for (var i = 0; i < array.length; i++) {
                                    if (!isFinite(array[i])) {
                                        if (nanStart < 0) {
                                            nanStart = i;
                                        }
                                    } else {
                                        if (nanStart >= 0) {
                                            interpolate(nanStart - 1, i);
                                            nanStart = -1;
                                        }
                                    }
                                }
                                if (nanStart >= 0) {
                                    interpolate(nanStart - 1, array.length);
                                }
                            };
                            var frequencyArray = frequencyLogScale ? logFrequencyArray : linearFrequencyArray;
                            for (var i = 0; i < magnitudeArray.length; i++) {
                                magnitudeArray[i] = 1;
                            }
                            for (var _i = 0; _i < phaseArray.length; _i++) {
                                phaseArray[_i] = 0;
                            }
                            for (var _i2 = 0; _i2 < filterNodes.length; _i2++) {
                                var filterNode = filterNodes[_i2];
                                filterNode.getFrequencyResponse(frequencyArray, magnitudeArray0, phaseArray0);
                                removeNans(magnitudeArray0);
                                removeNans(phaseArray0);
                                for (var _i8 = 0; _i8 < magnitudeArray.length; _i8++) {
                                    magnitudeArray[_i8] *= magnitudeArray0[_i8];
                                }
                                for (var _i9 = 0; _i9 < phaseArray.length; _i9++) {
                                    phaseArray[_i9] += phaseArray0[_i9];
                                }
                            }
                            if (magnitudeLogScale) {
                                for (var _i3 = 0; _i3 < width; _i3++) {
                                    // convert to decibels
                                    magnitudeArray[_i3] = 20 * require(27)(magnitudeArray[_i3]);
                                }
                            }
                            function wrap(v, maxAbs) {
                                v %= maxAbs * 2;
                                if (Math.abs(v) <= maxAbs)
                                    return v;
                                return v - (v > 0 ? 1 : -1) * maxAbs * 2;
                            }
                            var k = 0;
                            var v0 = 0;
                            for (var _i4 = 0; _i4 < width; _i4++) {
                                // unwrap phase
                                var v1 = wrap(phaseArray[_i4] / Math.PI, 1);
                                k += v1 < v0 && v0 - v1 > v1 + 2 - v0;
                                k -= v1 > v0 && v1 - v0 > v0 - (v1 - 2);
                                v0 = v1;
                                phaseArray[_i4] = v0 + 2 * k;
                            }
                            var plotResponse = function (canvasContext, array, units, enforcedCenter, enforcedRange, enforcedFloor, majorGridLineTest) {
                                var _Math, _Math2;
                                var min = undefined, max = undefined;
                                var setPlotRange = function (min0, max0) {
                                    var ph = pad / height;
                                    min = ((min0 + max0) * ph - min0) / (2 * ph - 1);
                                    max = ((min0 + max0) * ph - max0) / (2 * ph - 1);
                                };
                                var minArr = (_Math = Math).min.apply(_Math, array);
                                var maxArr = (_Math2 = Math).max.apply(_Math2, array);
                                var minArrCentered = Math.max(minArr, enforcedFloor) - enforcedCenter;
                                var maxArrCentered = Math.max(maxArr, enforcedFloor) - enforcedCenter;
                                setPlotRange(enforcedCenter + Math.min(0, -enforcedRange + Math.max(0, maxArrCentered - enforcedRange), minArrCentered), enforcedCenter + Math.max(0, enforcedRange - Math.max(0, -enforcedRange - minArrCentered), maxArrCentered));
                                var calcY = function (v) {
                                    return height * (1 - (v - min) / (max - min));
                                };
                                var getGridNumbers = function (min, max) {
                                    var numLogs = require(27)(max - min) - require(27)(maxNGridLines);
                                    var k = undefined;
                                    var p = Infinity;
                                    var _arr = [
                                        1,
                                        2,
                                        5
                                    ];
                                    for (var _i5 = 0; _i5 < _arr.length; _i5++) {
                                        var tk = _arr[_i5];
                                        var tp = Math.ceil(numLogs - require(27)(tk));
                                        if (tp < p) {
                                            p = tp;
                                            k = tk;
                                        }
                                    }
                                    var dv = k * Math.pow(10, p);
                                    var v0 = Math.ceil(min / dv) * dv;
                                    var numbers = [];
                                    for (var v = v0; v < max; v += dv) {
                                        numbers.push(v);
                                    }
                                    return [
                                        numbers,
                                        p < 0 ? -p : 0
                                    ];
                                };
                                var drawGrid = function (numbers, visibleNumbers, calcPosition, labelLimit, units, majorGridLineTest) {
                                    var _Math3;
                                    canvasContext.save();
                                    canvasContext.translate(0, 0.5);
                                    // don't translate along x to keep dashes sharp
                                    canvasContext.fillStyle = '#444';
                                    canvasContext.font = fontSize + 'px';
                                    canvasContext.textAlign = 'right';
                                    var getLabel = function (n) {
                                        return '' + i18n.number(n) + units;
                                    };
                                    var labelWidth = (_Math3 = Math).max.apply(_Math3, visibleNumbers.map(function (n) {
                                        return canvasContext.measureText(getLabel(n)).width;
                                    }));
                                    var _loop = function (_i6) {
                                        var y = Math.round(calcPosition(numbers[_i6]));
                                        var drawLine = function () {
                                            canvasContext.beginPath();
                                            canvasContext.moveTo(0, y);
                                            canvasContext.lineTo(width, y);
                                            canvasContext.stroke();
                                        };
                                        var majorGridLine = majorGridLineTest(Number(visibleNumbers[_i6]));
                                        if (majorGridLine) {
                                            canvasContext.strokeStyle = 'rgba(70%,70%,100%,0.3)';
                                            canvasContext.setLineDash([]);
                                            canvasContext.lineWidth = 3;
                                            drawLine();
                                        }
                                        canvasContext.strokeStyle = majorGridLine ? '#000' : '#888';
                                        canvasContext.setLineDash([1]);
                                        canvasContext.lineWidth = 1;
                                        drawLine();
                                        if (y - fontOffset - fontSize > labelLimit) {
                                            canvasContext.fillText(getLabel(visibleNumbers[_i6]), fontOffset + labelWidth, y - fontOffset);
                                        }
                                    };
                                    for (var _i6 = 0; _i6 < numbers.length; _i6++) {
                                        _loop(_i6);
                                    }
                                    canvasContext.restore();
                                    return labelWidth;
                                };
                                var drawYGrid = function () {
                                    var yGridNumbersAndPrecision = getGridNumbers(min, max);
                                    var yVisibleGridNumbers = formatNumbers.apply(undefined, yGridNumbersAndPrecision);
                                    return drawGrid(yGridNumbersAndPrecision[0], yVisibleGridNumbers, calcY, 0, units, majorGridLineTest);
                                };
                                var drawXGrid = function (yLabelWidth) {
                                    canvasContext.save();
                                    canvasContext.rotate(-Math.PI / 2);
                                    canvasContext.translate(-height, 0);
                                    var calcX = undefined, xGridNumbersAndPrecision = undefined, xVisibleGridNumbers = undefined;
                                    if (frequencyLogScale) {
                                        calcX = function (v) {
                                            return width * (v - logFrequencyArrayLinearLimit0) / (logFrequencyArrayLinearLimit1 - logFrequencyArrayLinearLimit0);
                                        };
                                        xGridNumbersAndPrecision = getGridNumbers(logFrequencyArrayLinearLimit0, logFrequencyArrayLinearLimit1);
                                        xVisibleGridNumbers = formatNumbers(xGridNumbersAndPrecision[0].map(function (n) {
                                            return Math.pow(10, n);
                                        }), 0);
                                    } else {
                                        calcX = function (v) {
                                            return width * (v - frequencyArray[0]) / (frequencyArray[width - 1] - frequencyArray[0]);
                                        };
                                        xGridNumbersAndPrecision = getGridNumbers(frequencyArray[0], frequencyArray[width - 1]);
                                        xVisibleGridNumbers = formatNumbers.apply(undefined, xGridNumbersAndPrecision);
                                    }
                                    drawGrid(xGridNumbersAndPrecision[0], xVisibleGridNumbers, calcX, fontOffset + yLabelWidth, ' ' + i18n('units.hertz.a'), function (v) {
                                        return false;
                                    });
                                    canvasContext.restore();
                                };
                                var drawGraph = function () {
                                    canvasContext.save();
                                    canvasContext.translate(0.5, 0.5);
                                    // aim at centers of pixels
                                    canvasContext.strokeStyle = '#F00';
                                    canvasContext.beginPath();
                                    for (var _i7 = 0; _i7 < width; _i7++) {
                                        var x = _i7;
                                        var _y = calcY(array[_i7]);
                                        if (_i7 == 0) {
                                            canvasContext.moveTo(x, _y);
                                        } else {
                                            canvasContext.lineTo(x, _y);
                                        }
                                    }
                                    canvasContext.stroke();
                                    canvasContext.restore();
                                };
                                canvasContext.clearRect(0, 0, width, height);
                                var yLabelWidth = drawYGrid();
                                drawXGrid(yLabelWidth);
                                drawGraph();
                            };
                            if (magnitudeLogScale) {
                                plotResponse(magnitudeCanvasContext, magnitudeArray, ' ' + i18n('units.decibel.a'), 0, 1, -100, function (v) {
                                    return v == 0;
                                });
                            } else {
                                plotResponse(magnitudeCanvasContext, magnitudeArray, '', 1, 0.1, 0, function (v) {
                                    return v == 0 || v == 1;
                                });
                            }
                            plotResponse(phaseCanvasContext, phaseArray, 'π', 0, 0.1, -Infinity, function (v) {
                                return v % 2 == 0;
                            });
                        };
                        var delayedUpdate = debounce(function () {
                            try {
                                updatePlots(_this.getFilterNodes(audioContext));
                            } catch (e) {
                            }
                        }, 50);
                        var $frOption = undefined;
                        var This = _this;
                        _this.$output.append($frOption = $('<div class=\'option only-buttons\'>').append('<label>' + i18n('options-output.filter.frequencyResponse') + ':</label><span class=\'space\'> </span>', $('<button type=\'button\'>' + i18n('options-output.show') + '</button>').click(function () {
                            var $button = $(this);
                            if (!isFreqResponseUiShown()) {
                                This.runIfCanCreateAudioContext(function (audioContext) {
                                    var filterNodes = undefined;
                                    try {
                                        filterNodes = This.getFilterNodes(audioContext);
                                    } catch (e) {
                                        $button.replaceWith(i18n('options-output.filter.nodeError'));
                                        return;
                                    }
                                    var $magnitudeCanvas = undefined, $phaseCanvas = undefined;
                                    $freqResponseUi = $freqResponseUi.add($('<span>').append(' ', $('<label class=\'nowrap\'>').append($('<input type=\'checkbox\'>').prop('checked', magnitudeLogScale).change(function () {
                                        magnitudeLogScale = $(this).prop('checked');
                                        delayedUpdate();
                                    }), ' ' + i18n('options-output.filter.logMagnitude')), ' ', $('<label class=\'nowrap\'>').append($('<input type=\'checkbox\'>').prop('checked', frequencyLogScale).change(function () {
                                        frequencyLogScale = $(this).prop('checked');
                                        delayedUpdate();
                                    }), ' ' + i18n('options-output.filter.logFrequency')), ' ')).add($('<div>').append($('<figure>').append('<figcaption>' + i18n('options-output.filter.magnitude') + '</figcaption>', $magnitudeCanvas = $('<canvas width=\'' + width + '\' height=\'' + height + '\'></canvas>')), $('<figure>').append('<figcaption>' + i18n('options-output.filter.phase') + '</figcaption>', $phaseCanvas = $('<canvas width=\'' + width + '\' height=\'' + height + '\'></canvas>'))));
                                    $button.after($freqResponseUi).text(i18n('options-output.hide'));
                                    magnitudeCanvasContext = $magnitudeCanvas[0].getContext('2d');
                                    phaseCanvasContext = $phaseCanvas[0].getContext('2d');
                                    updatePlots(filterNodes);
                                    $frOption.removeClass('only-buttons');
                                }, $button, i18n('options-output.filter.contextError'));
                            } else {
                                // TODO cancel scheduled update
                                $freqResponseUi.remove();
                                $freqResponseUi = $();
                                $button.text(i18n('options-output.show'));
                                $frOption.addClass('only-buttons');
                            }
                        })));
                        option.addUpdateCallback(function () {
                            if (isFreqResponseUiShown()) {
                                delayedUpdate();
                            }
                        });
                        return _this;
                    }
                    FilterOptionOutput.prototype.runIfCanCreateAudioContext = function runIfCanCreateAudioContext(fn, $ui, errorMessage) {
                        var initAudioContext = function () {
                            audioContext = new (AudioContext || webkitAudioContext)();
                            linearFrequencyArray = new Float32Array(width);
                            logFrequencyArray = new Float32Array(width);
                            magnitudeArray = new Float32Array(width);
                            phaseArray = new Float32Array(width);
                            magnitudeArray0 = new Float32Array(width);
                            phaseArray0 = new Float32Array(width);
                            var maxFrequency = audioContext.sampleRate / 2;
                            var log10minFrequency = require(27)(minFrequencyInLogMode);
                            var log10maxFrequency = require(27)(maxFrequency);
                            for (var i = 0; i < width; i++) {
                                var x = (i + 0.5) / width;
                                linearFrequencyArray[i] = maxFrequency * x;
                                logFrequencyArray[i] = Math.pow(10, mix(log10minFrequency, log10maxFrequency, x));
                            }
                            logFrequencyArrayLinearLimit0 = mix(log10minFrequency, log10maxFrequency, 0.5 / width);
                            logFrequencyArrayLinearLimit1 = mix(log10minFrequency, log10maxFrequency, 1 - 0.5 / width);
                        };
                        if (!audioContext) {
                            try {
                                initAudioContext();
                            } catch (e) {
                                $ui.replaceWith(errorMessage);
                                return;
                            }
                        }
                        fn(audioContext);
                    };
                    // abstract
                    // getFilterNodes(audioContext)
                    return FilterOptionOutput;
                }(GroupOptionOutput);
                module.exports = FilterOptionOutput;
            },
            {
                '10': 10,
                '11': 11,
                '27': 27,
                '8': 8
            }
        ],
        40: [
            function (require, module, exports) {
                var _templateObject = ___babelHelper___taggedTemplateLiteralLoose([
                        '<abbr title=',
                        '>'
                    ], [
                        '<abbr title=',
                        '>'
                    ]), _templateObject2 = ___babelHelper___taggedTemplateLiteralLoose([
                        '<label for=',
                        '>',
                        ':</label>'
                    ], [
                        '<label for=',
                        '>',
                        ':</label>'
                    ]), _templateObject3 = ___babelHelper___taggedTemplateLiteralLoose([
                        '<input id=',
                        ' type=range value=',
                        ' min=',
                        ' max=',
                        ' step=',
                        '>'
                    ], [
                        '<input id=',
                        ' type=range value=',
                        ' min=',
                        ' max=',
                        ' step=',
                        '>'
                    ]), _templateObject4 = ___babelHelper___taggedTemplateLiteralLoose([
                        '<select id=',
                        '>'
                    ], [
                        '<select id=',
                        '>'
                    ]), _templateObject5 = ___babelHelper___taggedTemplateLiteralLoose([
                        '<option selected=',
                        ' value=',
                        '>',
                        '</option>'
                    ], [
                        '<option selected=',
                        ' value=',
                        '>',
                        '</option>'
                    ]), _templateObject6 = ___babelHelper___taggedTemplateLiteralLoose([
                        '<span id=',
                        '>',
                        '</span>'
                    ], [
                        '<span id=',
                        '>',
                        '</span>'
                    ]);
                var camelCase = require(6);
                var formatNumbers = require(10);
                var Lines = require(17);
                var JsLines = require(16);
                var WrapLines = require(26);
                var NoseWrapLines = require(18);
                var InterleaveLines = require(15);
                var RefLines = require(23);
                var Option = require(45);
                var CollectionFeature = require(35);
                var Filter = function () {
                    function Filter(options, n) {
                        ___babelHelper___classCallCheck(this, Filter);
                        this.options = options;
                        this.n = n;
                    }
                    Filter.prototype.getPropertyOptionName = function getPropertyOptionName(property) {
                        return 'options.filters.' + this.type + '.' + property.name;
                    };
                    Filter.prototype.getPropertyInputHtmlName = function getPropertyInputHtmlName(propertyName) {
                        return 'my.' + this.type + this.nSuffix + '.' + propertyName;
                    };
                    Filter.prototype.getPropertyInputJsName = function getPropertyInputJsName(propertyName) {
                        return camelCase(this.type + this.nSuffix + '.' + propertyName + '.input');
                    };
                    Filter.prototype.requestFeatureContext = function requestFeatureContext(featureContext) {
                        var _this = this;
                        var hasRangeInputs = this.nodeProperties.some(function (property) {
                            if (property.type == 'range') {
                                var option = _this.options[property.name];
                                return option.input;
                            } else {
                                return false;
                            }
                        });
                        if (hasRangeInputs) {
                            featureContext.alignedInputs = true;
                        }
                    };
                    Filter.prototype.getHtmlPropertyLines = function getHtmlPropertyLines(i18n, property) {
                        var _this2 = this;
                        if (property.skip) {
                            return Lines.be();
                        }
                        var option = this.options[property.name];
                        var inputHtmlName = this.getPropertyInputHtmlName(property.name);
                        var a = Lines.b();
                        if (property.type == 'range' && option.input) {
                            var p = option.precision;
                            var fmtAttrs = formatNumbers.html({
                                min: option.min,
                                max: option.max,
                                value: option.value
                            }, p);
                            var fmtLabels = formatNumbers({
                                min: option.min,
                                max: option.max
                            }, p);
                            var minMax = function (n) {
                                return i18n.numberWithUnits(n, option.unit, function (a, e) {
                                    return Lines.html(_templateObject, e) + a + '</abbr>';
                                });
                            };
                            a(Lines.html(_templateObject2, inputHtmlName, i18n(this.getPropertyOptionName(property))), '<span class=min>' + minMax(fmtLabels.min) + '</span>', Lines.html(_templateObject3, inputHtmlName, fmtAttrs.value, fmtAttrs.min, fmtAttrs.max, p ? Math.pow(0.1, p).toFixed(p) : false), '<span class=max>' + minMax(fmtLabels.max) + '</span>');
                        } else if (property.type == 'select' && option.input) {
                            var _WrapLines$b;
                            a(Lines.html(_templateObject2, inputHtmlName, i18n(this.getPropertyOptionName(property))), (_WrapLines$b = WrapLines.b(Lines.html(_templateObject4, inputHtmlName), '</select>')).ae.apply(_WrapLines$b, option.availableValues.map(function (value) {
                                var title = i18n(_this2.getPropertyOptionName(property) + '.' + value);
                                return Lines.html(_templateObject5, option.value == value, value != title && value, title);
                            })));
                        } else if (property.type == 'xhr') {
                            a(Lines.html(_templateObject6, inputHtmlName, i18n(this.getPropertyOptionName(property) + '.loading')));
                        }
                        return a.e();
                    };
                    // { not called if skipNode is set
                    Filter.prototype.getHtmlLines = function getHtmlLines(featureContext, i18n) {
                        var _this3 = this;
                        return Lines.bae.apply(Lines, this.nodeProperties.map(function (property) {
                            return NoseWrapLines.b('<div>', '</div>').ae(_this3.getHtmlPropertyLines(i18n, property));
                        }));
                    };
                    Filter.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                        return JsLines.bae(RefLines.parse('// ' + i18n('comment.filters.' + this.type)), featureContext.getJsConnectAssignLines('var', this.nodeJsName, 'ctx.' + this.ctxCreateMethodName + '()', prevNodeJsNames));
                    };
                    ___babelHelper___createClass(Filter, [
                        {
                            key: 'nSuffix',
                            get: function () {
                                if (this.n !== undefined) {
                                    return '.' + this.n;
                                } else {
                                    return '';
                                }
                            }
                        },
                        {
                            key: 'nodeJsName',
                            get: function () {
                                return camelCase(this.type + this.nSuffix + '.node');
                            }
                        },
                        {
                            key: 'skipNode',
                            get: function () {
                                return false;
                            }
                        },
                        {
                            key: 'nodeJsNames',
                            get: function () {
                                return [this.nodeJsName];
                            }
                        },
                        {
                            key: 'connectToNodeJsNames',
                            get: function () {
                                return this.nodeJsNames;
                            }    // }
                                 // abstract:
                                 // get type()
                                 // get ctxCreateMethodName()
                                 // get nodeProperties()
                        }
                    ]);
                    return Filter;
                }();
                var SinglePathFilter = function (_Filter) {
                    ___babelHelper___inherits(SinglePathFilter, _Filter);
                    function SinglePathFilter() {
                        ___babelHelper___classCallCheck(this, SinglePathFilter);
                        return ___babelHelper___possibleConstructorReturn(this, _Filter.apply(this, arguments));
                    }
                    SinglePathFilter.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                        var _this5 = this;
                        return Lines.bae.apply(Lines, [_Filter.prototype.getJsInitLines.call(this, featureContext, i18n, prevNodeJsNames)].concat(this.nodeProperties.map(function (property) {
                            if (property.skip) {
                                return Lines.be();
                            }
                            var option = _this5.options[property.name];
                            var nodePropertyJsName = _this5.nodeJsName + '.' + property.name + (property.type == 'range' ? '.value' : '');
                            var a = JsLines.b();
                            if (option.input) {
                                var inputJsName = _this5.getPropertyInputJsName(property.name);
                                var inputHtmlName = _this5.getPropertyInputHtmlName(property.name);
                                var value = inputJsName + '.value';
                                if (property.fn) {
                                    value = property.fn(value);
                                }
                                var eventProp = property.type == 'range' ? 'oninput' : 'onchange';
                                a('var ' + inputJsName + '=document.getElementById(\'' + inputHtmlName + '\');', // was for IE11 compat (but IE11 has no Web Audio): (property.type=='range'?inputJsName+".oninput=":"")+inputJsName+".onchange=function(){",
                                ';(' + inputJsName + '.' + eventProp + '=function(){', '\t' + nodePropertyJsName + '=' + value + ';', '})();');
                            } else if (option.value != option.defaultValue) {
                                var _value = option.value;
                                if (property.type == 'select') {
                                    _value = '\'' + _value + '\'';
                                }
                                if (property.fn) {
                                    _value = property.fn(_value);
                                }
                                a(nodePropertyJsName + '=' + _value + ';');
                            }
                            return a.e();
                        })));
                    };
                    return SinglePathFilter;
                }(Filter);
                var PassiveByDefaultSinglePathFilter = function (_SinglePathFilter) {
                    ___babelHelper___inherits(PassiveByDefaultSinglePathFilter, _SinglePathFilter);
                    function PassiveByDefaultSinglePathFilter() {
                        ___babelHelper___classCallCheck(this, PassiveByDefaultSinglePathFilter);
                        return ___babelHelper___possibleConstructorReturn(this, _SinglePathFilter.apply(this, arguments));
                    }
                    ___babelHelper___createClass(PassiveByDefaultSinglePathFilter, [{
                            key: 'skipNode',
                            get: function () {
                                var _this7 = this;
                                return this.nodeProperties.every(function (property) {
                                    var option = _this7.options[property.name];
                                    return option.value == option.defaultValue && !option.input;
                                });
                            }
                        }]);
                    return PassiveByDefaultSinglePathFilter;
                }(SinglePathFilter);
                var filterClasses = {
                    gain: function (_PassiveByDefaultSing) {
                        ___babelHelper___inherits(gain, _PassiveByDefaultSing);
                        function gain() {
                            ___babelHelper___classCallCheck(this, gain);
                            return ___babelHelper___possibleConstructorReturn(this, _PassiveByDefaultSing.apply(this, arguments));
                        }
                        ___babelHelper___createClass(gain, [
                            {
                                key: 'type',
                                get: function () {
                                    return 'gain';
                                }
                            },
                            {
                                key: 'ctxCreateMethodName',
                                get: function () {
                                    return 'createGain';
                                }
                            },
                            {
                                key: 'nodeProperties',
                                get: function () {
                                    return [{
                                            name: 'gain',
                                            type: 'range'
                                        }];
                                }
                            }
                        ]);
                        return gain;
                    }(PassiveByDefaultSinglePathFilter),
                    panner: function (_PassiveByDefaultSing2) {
                        ___babelHelper___inherits(panner, _PassiveByDefaultSing2);
                        function panner() {
                            ___babelHelper___classCallCheck(this, panner);
                            return ___babelHelper___possibleConstructorReturn(this, _PassiveByDefaultSing2.apply(this, arguments));
                        }
                        ___babelHelper___createClass(panner, [
                            {
                                key: 'type',
                                get: function () {
                                    return 'panner';
                                }
                            },
                            {
                                key: 'ctxCreateMethodName',
                                get: function () {
                                    return 'createStereoPanner';
                                }
                            },
                            {
                                key: 'nodeProperties',
                                get: function () {
                                    return [{
                                            name: 'pan',
                                            type: 'range'
                                        }];
                                }
                            }
                        ]);
                        return panner;
                    }(PassiveByDefaultSinglePathFilter),
                    biquad: function (_SinglePathFilter2) {
                        ___babelHelper___inherits(biquad, _SinglePathFilter2);
                        function biquad() {
                            ___babelHelper___classCallCheck(this, biquad);
                            return ___babelHelper___possibleConstructorReturn(this, _SinglePathFilter2.apply(this, arguments));
                        }
                        ___babelHelper___createClass(biquad, [
                            {
                                key: 'type',
                                get: function () {
                                    return 'biquad';
                                }
                            },
                            {
                                key: 'ctxCreateMethodName',
                                get: function () {
                                    return 'createBiquadFilter';
                                }
                            },
                            {
                                key: 'nodeProperties',
                                get: function () {
                                    return [
                                        {
                                            name: 'type',
                                            type: 'select'
                                        },
                                        {
                                            name: 'frequency',
                                            type: 'range'
                                        },
                                        {
                                            name: 'detune',
                                            type: 'range'
                                        },
                                        {
                                            name: 'Q',
                                            type: 'range',
                                            fn: function (x) {
                                                return 'Math.pow(10,' + x + ')';
                                            },
                                            skip: !this.options.type.input && !Option.BiquadFilter.typeUsesQ(this.options.type.value)
                                        },
                                        {
                                            name: 'gain',
                                            type: 'range',
                                            skip: !this.options.type.input && !Option.BiquadFilter.typeUsesGain(this.options.type.value)
                                        }
                                    ];
                                }
                            },
                            {
                                key: 'skipNode',
                                get: function () {
                                    // lowshelf, highshelf and peaking are passive when gain==0
                                    return !this.options.type.input && [
                                        'lowshelf',
                                        'highshelf',
                                        'peaking'
                                    ].indexOf(this.options.type.value) >= 0 && !this.options.gain.input && this.options.gain == 0;
                                }
                            }
                        ]);
                        return biquad;
                    }(SinglePathFilter),
                    iir: function (_SinglePathFilter3) {
                        ___babelHelper___inherits(iir, _SinglePathFilter3);
                        function iir() {
                            ___babelHelper___classCallCheck(this, iir);
                            return ___babelHelper___possibleConstructorReturn(this, _SinglePathFilter3.apply(this, arguments));
                        }
                        iir.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                            return JsLines.bae(RefLines.parse('// ' + i18n('comment.filters.' + this.type)), featureContext.getJsConnectAssignLines('var', this.nodeJsName, 'ctx.' + this.ctxCreateMethodName + '([' + this.options.feedforward.entries + '],[' + this.options.feedback.entries + '])', prevNodeJsNames));
                        };
                        ___babelHelper___createClass(iir, [
                            {
                                key: 'type',
                                get: function () {
                                    return 'iir';
                                }
                            },
                            {
                                key: 'ctxCreateMethodName',
                                get: function () {
                                    return 'createIIRFilter';
                                }
                            },
                            {
                                key: 'nodeProperties',
                                get: function () {
                                    return [];
                                }
                            }
                        ]);
                        return iir;
                    }(SinglePathFilter),
                    convolver: function (_Filter2) {
                        ___babelHelper___inherits(convolver, _Filter2);
                        function convolver() {
                            ___babelHelper___classCallCheck(this, convolver);
                            return ___babelHelper___possibleConstructorReturn(this, _Filter2.apply(this, arguments));
                        }
                        convolver.prototype.requestFeatureContext = function requestFeatureContext(featureContext) {
                            _Filter2.prototype.requestFeatureContext.call(this, featureContext);
                            featureContext.loader = true;
                        };
                        convolver.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                            var messageHtmlName = this.getPropertyInputHtmlName('buffer');
                            var a = JsLines.b();
                            if (this.options.reverb.input || this.options.reverb != 1) {
                                a(RefLines.parse('// ' + i18n('comment.filters.' + this.type)));
                            } else {
                                a(RefLines.parse('// ' + i18n('comment.filters.' + this.type + '.single')));
                            }
                            a(featureContext.getJsConnectAssignLines('var', this.nodeJsName, 'ctx.' + this.ctxCreateMethodName + '()', prevNodeJsNames));
                            if (this.options.reverb.input || this.options.reverb != 1) {
                                a(featureContext.getJsConnectAssignLines('var', this.wetGainNodeJsName, 'ctx.createGain()', [this.nodeJsName]), featureContext.getJsConnectAssignLines('var', this.dryGainNodeJsName, 'ctx.createGain()', prevNodeJsNames));
                                if (this.options.reverb.input) {
                                    var inputHtmlName = this.getPropertyInputHtmlName('reverb');
                                    var inputJsName = this.getPropertyInputJsName('reverb');
                                    a('var ' + inputJsName + '=document.getElementById(\'' + inputHtmlName + '\');', ';(' + inputJsName + '.oninput=function(){', '\t' + this.wetGainNodeJsName + '.gain.value=' + inputJsName + '.value;', '\t' + this.dryGainNodeJsName + '.gain.value=1-' + inputJsName + '.value;', '})();');
                                }
                            }
                            a('loadSample(\'' + this.options.url + '\',function(buffer){', // TODO html escape
                            '\t' + this.nodeJsName + '.buffer=buffer;', '\tdocument.getElementById(\'' + messageHtmlName + '\').textContent=\'\';', '}');
                            if (featureContext.loaderOnError) {
                                a.t(',function(){', '\tdocument.getElementById(\'' + messageHtmlName + '\').textContent=\'' + i18n('options.filters.convolver.buffer.error') + '\';', '}');
                            }
                            a.t(');');
                            return a.e();
                        };
                        ___babelHelper___createClass(convolver, [
                            {
                                key: 'type',
                                get: function () {
                                    return 'convolver';
                                }
                            },
                            {
                                key: 'ctxCreateMethodName',
                                get: function () {
                                    return 'createConvolver';
                                }
                            },
                            {
                                key: 'nodeProperties',
                                get: function () {
                                    return [
                                        {
                                            name: 'reverb',
                                            type: 'range'
                                        },
                                        {
                                            name: 'buffer',
                                            type: 'xhr'
                                        }
                                    ];
                                }
                            },
                            {
                                key: 'dryGainNodeJsName',
                                get: function () {
                                    return camelCase(this.type + this.nSuffix + '.dry.gain.node');
                                }
                            },
                            {
                                key: 'wetGainNodeJsName',
                                get: function () {
                                    return camelCase(this.type + this.nSuffix + '.wet.gain.node');
                                }
                            },
                            {
                                key: 'skipNode',
                                get: function () {
                                    return this.options.reverb == 0 && !this.options.reverb.input;
                                }
                            },
                            {
                                key: 'nodeJsNames',
                                get: function () {
                                    if (this.options.reverb.input || this.options.reverb != 1) {
                                        return [
                                            this.wetGainNodeJsName,
                                            this.dryGainNodeJsName
                                        ];
                                    } else {
                                        return [this.nodeJsName];
                                    }
                                }
                            },
                            {
                                key: 'connectToNodeJsNames',
                                get: function () {
                                    if (this.options.reverb.input || this.options.reverb != 1) {
                                        return [
                                            this.nodeJsName,
                                            this.dryGainNodeJsName
                                        ];
                                    } else {
                                        return [this.nodeJsName];
                                    }
                                }
                            }
                        ]);
                        return convolver;
                    }(Filter),
                    equalizer: function (_Filter3) {
                        ___babelHelper___inherits(equalizer, _Filter3);
                        function equalizer() {
                            ___babelHelper___classCallCheck(this, equalizer);
                            return ___babelHelper___possibleConstructorReturn(this, _Filter3.apply(this, arguments));
                        }
                        equalizer.prototype.getFrequencyOption = function getFrequencyOption(i) {
                            return this.options[this.nodeProperties[i].name];
                        };
                        equalizer.prototype.requestFeatureContext = function requestFeatureContext(featureContext) {
                            if (!this.allGainsConstant) {
                                // TODO this check is likely not needed, this.allGainsConstant is not set
                                featureContext.alignedInputs = true;
                            }
                        };
                        equalizer.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                            var _this14 = this;
                            var singleFreq = this.affectedFreqsAndOptions.length == 1;
                            var allGainsConstant = this.affectedFreqsAndOptions.every(function (fo) {
                                return fo.option.input == false;
                            });
                            var noGainsConstant = this.affectedFreqsAndOptions.every(function (fo) {
                                return fo.option.input == true;
                            });
                            var getJsData = function () {
                                return _this14.affectedFreqsAndOptions.map(function (fo) {
                                    if (noGainsConstant) {
                                        return fo.freq;
                                    } else {
                                        return '[' + fo.freq + ',' + (fo.option.input ? 'null' : fo.option.value) + ']';
                                    }
                                }).join();
                            };
                            var getJsDataItem = function () {
                                if (noGainsConstant) {
                                    return 'freq';
                                } else {
                                    return 'freqData';
                                }
                            };
                            var getJsLoopLines = function () {
                                var freq = singleFreq ? _this14.affectedFreqsAndOptions[0].freq : 'freq';
                                var gain = singleFreq ? _this14.affectedFreqsAndOptions[0].option.value : 'gain';
                                var nodeJsName = allGainsConstant || singleFreq ? _this14.nodeJsName : 'node';
                                var inputJsName = singleFreq ? _this14.getPropertyInputJsName('gain' + freq) : 'input';
                                var inputHtmlNameExpr = singleFreq ? '\'' + _this14.getPropertyInputHtmlName('gain' + freq) + '\'' : '\'' + _this14.getPropertyInputHtmlName('gain') + '\'+freq';
                                var a = JsLines.b();
                                if (!(noGainsConstant || singleFreq)) {
                                    a('var freq=freqData[0], gain=freqData[1];');
                                }
                                var connectors = undefined;
                                if (singleFreq) {
                                    connectors = prevNodeJsNames;
                                } else {
                                    if (prevNodeJsNames.length == 1) {
                                        connectors = ['prevNode'];
                                    } else {
                                        connectors = 'prevNodes';
                                    }
                                }
                                a(featureContext.getJsConnectAssignLines(allGainsConstant && !singleFreq ? '' : 'var', nodeJsName, 'ctx.' + _this14.ctxCreateMethodName + '()', connectors));
                                if (featureContext.setConnectSampleToJsNames && !singleFreq) {
                                    a('if (' + _this14.connectToNodeJsName + '===undefined) {', '\t' + _this14.connectToNodeJsName + '=' + nodeJsName + ';', '}');
                                }
                                a(nodeJsName + '.type=\'peaking\';', nodeJsName + '.frequency.value=' + freq + ';');
                                var constLines = JsLines.bae(nodeJsName + '.gain.value=' + gain + ';');
                                var varLines = JsLines.bae('var ' + inputJsName + '=document.getElementById(' + inputHtmlNameExpr + ');', ';(' + inputJsName + '.oninput=function(){', '\t' + nodeJsName + '.gain.value=' + inputJsName + '.value;', '})();');
                                if (!noGainsConstant && allGainsConstant) {
                                    a(constLines);
                                } else if (noGainsConstant && !allGainsConstant) {
                                    a(varLines);
                                } else if (!noGainsConstant && !allGainsConstant) {
                                    a(WrapLines.b('if (gain!==null) {', '} else {', '}').ae(constLines, varLines));
                                }
                                if (!singleFreq) {
                                    var outerNodeJsName = allGainsConstant ? nodeJsName : _this14.nodeJsName + '=' + nodeJsName;
                                    if (prevNodeJsNames.length == 1) {
                                        a('prevNode=' + outerNodeJsName + ';');
                                    } else {
                                        a('prevNodes=[' + outerNodeJsName + '];');
                                    }
                                }
                                return a.e();
                            };
                            if (singleFreq) {
                                return JsLines.bae(RefLines.parse('// ' + i18n('comment.filters.' + this.type + '.single')), getJsLoopLines());
                            } else {
                                var a = JsLines.b();
                                a(RefLines.parse('// ' + i18n('comment.filters.' + this.type)));
                                if (prevNodeJsNames.length == 1) {
                                    a('var prevNode=' + prevNodeJsNames[0] + ';');
                                } else {
                                    a('var prevNodes=[' + prevNodeJsNames.join() + '];');
                                }
                                if (featureContext.setConnectSampleToJsNames) {
                                    a('var ' + this.connectToNodeJsName + ';');
                                }
                                a('var ' + this.nodeJsName + ';', WrapLines.b(JsLines.bae(';[' + getJsData() + '].forEach(function(' + getJsDataItem() + '){'), JsLines.bae('});')).ae(getJsLoopLines()));
                                return a.e();
                            }
                        };
                        ___babelHelper___createClass(equalizer, [
                            {
                                key: 'type',
                                get: function () {
                                    return 'equalizer';
                                }
                            },
                            {
                                key: 'ctxCreateMethodName',
                                get: function () {
                                    return 'createBiquadFilter';
                                }
                            },
                            {
                                key: 'frequencies',
                                get: function () {
                                    return Option.EqualizerFilter.frequencies;
                                }
                            },
                            {
                                key: 'nodeProperties',
                                get: function () {
                                    return this.frequencies.map(function (freq) {
                                        return {
                                            name: 'gain' + freq,
                                            type: 'range'
                                        };
                                    });
                                }
                            },
                            {
                                key: 'affectedFreqsAndOptions',
                                get: function () {
                                    var _this15 = this;
                                    return this.frequencies.map(function (freq, i) {
                                        var option = _this15.getFrequencyOption(i);
                                        return {
                                            freq: freq,
                                            option: option
                                        };
                                    }).filter(function (fo) {
                                        return fo.option.input != false || fo.option.value != 0;
                                    });
                                }
                            },
                            {
                                key: 'skipNode',
                                get: function () {
                                    return this.affectedFreqsAndOptions.length == 0;
                                }
                            },
                            {
                                key: 'connectToNodeJsName',
                                get: function () {
                                    if (this.affectedFreqsAndOptions.length == 1) {
                                        return this.nodeJsName;
                                    } else {
                                        return camelCase('connect.to.' + this.type + this.nSuffix + '.node');
                                    }
                                }
                            },
                            {
                                key: 'connectToNodeJsNames',
                                get: function () {
                                    return [this.connectToNodeJsName];
                                }
                            }
                        ]);
                        return equalizer;
                    }(Filter)
                };
                var FilterSequence = function (_CollectionFeature) {
                    ___babelHelper___inherits(FilterSequence, _CollectionFeature);
                    function FilterSequence() {
                        ___babelHelper___classCallCheck(this, FilterSequence);
                        return ___babelHelper___possibleConstructorReturn(this, _CollectionFeature.apply(this, arguments));
                    }
                    FilterSequence.prototype.getEntryClass = function getEntryClass(entryOption) {
                        return filterClasses[entryOption.filter];
                    };
                    FilterSequence.prototype.requestFeatureContext = function requestFeatureContext(featureContext) {
                        if (!featureContext.audioProcessing)
                            return;
                        var _arr = this.entries;
                        for (var _i = 0; _i < _arr.length; _i++) {
                            var entry = _arr[_i];
                            if (!entry.skipNode) {
                                featureContext.audioContext = true;
                                entry.requestFeatureContext(featureContext);
                                if (featureContext.connectSampleToJsNames === undefined) {
                                    featureContext.connectSampleToJsNames = entry.connectToNodeJsNames;
                                }
                            }
                        }
                    };
                    FilterSequence.prototype.getHtmlLines = function getHtmlLines(featureContext, i18n) {
                        if (!featureContext.audioProcessing)
                            return Lines.be();
                        return Lines.bae.apply(Lines, this.entries.filter(function (entry) {
                            return !entry.skipNode;
                        }).map(function (entry) {
                            return entry.getHtmlLines(featureContext, i18n);
                        }));
                    };
                    FilterSequence.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                        if (!featureContext.audioProcessing)
                            return Lines.be();
                        return InterleaveLines.bae.apply(InterleaveLines, this.entries.filter(function (entry) {
                            return !entry.skipNode;
                        }).map(function (entry) {
                            var lines = entry.getJsInitLines(featureContext, i18n, prevNodeJsNames);
                            prevNodeJsNames = entry.nodeJsNames;
                            return lines;
                        }));
                    };
                    FilterSequence.prototype.getNodeJsNames = function getNodeJsNames(featureContext, prevNodeJsNames) {
                        if (!featureContext.audioProcessing)
                            return prevNodeJsNames;
                        var _arr2 = this.entries;
                        for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
                            var entry = _arr2[_i2];
                            if (!entry.skipNode) {
                                prevNodeJsNames = entry.nodeJsNames;
                            }
                        }
                        return prevNodeJsNames;
                    };
                    return FilterSequence;
                }(CollectionFeature);
                module.exports = FilterSequence;
            },
            {
                '10': 10,
                '15': 15,
                '16': 16,
                '17': 17,
                '18': 18,
                '23': 23,
                '26': 26,
                '35': 35,
                '45': 45,
                '6': 6
            }
        ],
        41: [
            function (require, module, exports) {
                var webaudioSpec = 'https://webaudio.github.io/web-audio-api/';
                var webaudioIssue = function (n) {
                    return '<a href=\'https://github.com/WebAudio/web-audio-api/issues/' + n + '\'>' + n + '</a>';
                };
                var webaudioDetect = 'https://github.com/GoogleChrome/web-audio-samples/wiki/Detection-of-lowpass-BiquadFilter-implementation';
                var enColors = '{<span style=\'color:#800\'>red</span>,<span style=\'color:#080\'>green</span>,<span style=\'color:#008\'>blue</span>,opacity}';
                var ruColors = '{<span style=\'color:#800\'>Красный</span> ,<span style=\'color:#080\'>Зелёный</span> ,<span style=\'color:#008\'>Синий</span> ,Альфа-}канал';
                var langStrings = {
                    en: {
                        'options.sources': 'Sources',
                        'options.sources.{audio,video}': '{Audio,Video} element',
                        'options.sources.{audio,video}.add': 'Add {} element',
                        'options.sources.sample': 'Sample',
                        'options.sources.sample.add': 'Add sample',
                        'options.sources.sample.buffer.loading': 'Loading and decoding the sample',
                        'options.sources.sample.buffer.error': 'Error while loading the sample',
                        'options.sources.sample.repeat': 'Repeat sample',
                        'options.sources.sample.interval': 'Interval between repeats',
                        'options.sources.sample.randomShift': 'Random shift of a start time',
                        'options.sources.sample.pitch': 'Pitch',
                        'options.sources.sample.randomPitch': 'Random pitch',
                        'options.sources.sample.gain': 'Gain',
                        'options.sources.sample.randomGain': 'Random gain',
                        'options.sources.{audio,video,sample}.url': 'Source URL',
                        'options.sources.video.{width,height}': 'Player {}',
                        'options.filters': 'Filters',
                        'options.filters.gain': 'Gain',
                        'options.filters.gain.add': 'Add gain',
                        'options.filters.gain.gain': 'Gain',
                        'options.filters.panner': 'Stereo panner',
                        'options.filters.panner.add': 'Add stereo panner',
                        'options.filters.panner.pan': 'Pan',
                        'options.filters.biquad': 'Biquad filter',
                        // [[Digital biquad filter]]
                        'options.filters.biquad.add': 'Add biquad filter',
                        'options.filters.biquad.type': 'Filter type',
                        'options.filters.biquad.type.{lowpass,highpass,bandpass,lowshelf,highshelf,peaking,notch,allpass}': '{}',
                        'options.filters.biquad.frequency': 'Frequency',
                        'options.filters.biquad.detune': 'Detune',
                        'options.filters.biquad.Q': 'log(Q)',
                        'options.filters.biquad.gain': 'Gain',
                        'options.filters.iir': 'IIR filter',
                        'options.filters.iir.add': 'Add IIR filter',
                        'options.filters.iir.feedforward': 'Feedforward coefficients',
                        // Transfer fn numerator coefs
                        'options.filters.iir.feedforward.b': 'b',
                        'options.filters.iir.feedforward.b.add': 'Add coefficient',
                        'options.filters.iir.feedback': 'Feedback coefficients',
                        // Transfer fn denominator coefs
                        'options.filters.iir.feedback.a': 'a',
                        'options.filters.iir.feedback.a.add': 'Add coefficient',
                        'options.filters.convolver': 'Convolver',
                        'options.filters.convolver.add': 'Add convolver',
                        'options.filters.convolver.url': 'Impulse responce URL',
                        'options.filters.convolver.reverb': 'Reverb (dry/wet)',
                        'options.filters.convolver.buffer.loading': 'Loading and decoding the impulse response',
                        'options.filters.convolver.buffer.error': 'Error while loading the impulse response',
                        'options.filters.equalizer': 'Equalizer',
                        'options.filters.equalizer.add': 'Add equalizer',
                        'options.filters.equalizer.gain{60,170,350,1000,3500,10000}': '{} Hz gain',
                        'options.destination': 'Destination',
                        'options.destination.compressor': 'Dynamics compressor',
                        'options.destination.compressor.enabled': 'Add dynamics compressor before the destination',
                        'options.destination.{waveform,frequencies}': '{Waveform,Frequencies} visualization',
                        'options.destination.{waveform,frequencies}.enabled': 'Enable {} visualization',
                        'options.destination.waveform.width': 'Waveform line width',
                        'options.destination.waveform.color': 'Waveform line color',
                        'options.destination.waveform.color.{r,g,b,a}': 'Waveform line ' + enColors,
                        'options.destination.frequencies.cutoff': 'Limit plot to a fraction of low frequences',
                        'options.destination.frequencies.base': 'Frequency bars extend from',
                        'options.destination.frequencies.base.{bottom,middle}': '{} of canvas',
                        'options.destination.frequencies.coloring': 'Frequency bars coloring',
                        'options.destination.frequencies.coloring.component': 'with single color component',
                        'options.destination.frequencies.coloring.spectral': 'spectral',
                        'options.destination.frequencies.coloringInput': 'Frequency bars color depends on',
                        'options.destination.frequencies.coloringInput.{amplitude,frequency}': '{}',
                        'options.destination.frequencies.outline': 'Frequency bars outline',
                        'options.destination.frequencies.outline.enabled': 'Enable frequency bars outline',
                        'options.destination.frequencies.outline.width': 'Frequency bars outline width',
                        'options.destination.frequencies.outline.color': 'Frequency bars outline color',
                        'options.destination.frequencies.outline.color.{r,g,b,a}': 'Frequency bars outline ' + enColors,
                        'options.destination.volume': 'Volume meter',
                        'options.destination.volume.enabled': 'Enable volume meter',
                        'options.destination.volume.stereo': 'Meters for left and right stereo channels',
                        'options.destination.analyser': 'Analyser',
                        'options.destination.analyser.logFftSize': 'FFT size (power of 2)',
                        'options.canvas': 'Canvas',
                        'options.canvas.{width,height}': 'Canvas {}',
                        'options.canvas.background': 'Background',
                        'options.canvas.background.type': 'Background type',
                        'options.canvas.background.type.{clear,filled}': '{}',
                        'options.canvas.background.color': 'Background fill color',
                        'options.canvas.background.color.{r,g,b,a}': 'Background fill ' + enColors,
                        'options.loader': 'Sample loader',
                        'options.loader.errors': 'Error handling',
                        'options.loader.errors.none': 'disabled',
                        'options.loader.errors.network': 'network errors',
                        'options.loader.errors.http': 'network and HTTP errors',
                        'options.api': 'Web Audio API support',
                        'options.api.noVendorPrefix': 'Can create an audio context without a vendor prefix',
                        'options.api.connectReturnValue': 'Can use a return value of <code>AudioNode.connect()</code>',
                        'options-info.destination.analyser.logFftSize': '[[Fast Fourier transform]] size for the waveform/frequency visualization. Use a larger size to get a wider time window for the waveform and thinner frequency bars.',
                        'options-info.canvas.background.color.a': 'Lower opacity values lead to a blur effect.',
                        'options-output.input': 'Editable',
                        'options-output.range': 'with range',
                        'options-output.filter.frequencyResponse': 'Frequency response',
                        'options-output.filter.magnitude': 'Magnitude',
                        'options-output.filter.phase': 'Phase',
                        'options-output.filter.logMagnitude': 'log magnitude scale',
                        'options-output.filter.logFrequency': 'log frequency scale',
                        'options-output.filter.contextError': 'Error creating audio context. Your browser likely doesn\'t support Web Audio API.',
                        'options-output.filter.nodeError': 'Error creating filter node. Your browser likely doesn\'t support this filter type.',
                        'options-output.filter.biquad.clone': 'Clone as IIR filter',
                        'options-output.filter.biquad.clone.{pre,post}': 'Clone with {}-2016-04-15 coefficients',
                        'options-output.filter.biquad.clone.info': '<a href=\'' + webaudioSpec + '\'>The API specification</a> was self-contradictory and implementations weren\'t following it. Additionally, it was discovered that filter coefficient formulas need to be changed to accomodate a wider range of lowpass and highpass filters. See Web Audio API issues ' + webaudioIssue(769) + ', ' + webaudioIssue(771) + ' and ' + webaudioIssue(791) + ' for details. A possible method to check if an implementation has switched to the updated formulas is offered <a href=\'' + webaudioDetect + '\'>here</a>.',
                        'options-output.show': 'Show',
                        'options-output.hide': 'Hide',
                        'code-output.warning.jsfiddle-run': 'You may have to click <kbd>Run</kbd> in JSFiddle to get sound output working',
                        'code-output.warning.interesting': 'You need at least one source and some processing enabled to get interesting JavaScript code',
                        'code.title': 'Web Audio API example \u2014 generated code',
                        'label.sources.sample.play': 'Play sample',
                        'label.destination.compressor': 'Enable dynamics compressor',
                        'comment.context': 'create [audio context][context]',
                        'comment.sources.audio': 'create [audio source node][source]',
                        'comment.sources.video': 'create [video source node][source]',
                        'comment.sources.sample': 'load [sample][buffer]',
                        'comment.filters.gain': 'create [gain node][gain]',
                        'comment.filters.panner': 'create [stereo panner node][panner]',
                        'comment.filters.biquad': 'create [biquad filter node][biquad]',
                        'comment.filters.iir': 'create [IIR filter node][iir]',
                        'comment.filters.convolver': 'create dry and wet routes with [convolver node][convolver]',
                        'comment.filters.convolver.single': 'create [convolver node][convolver]',
                        'comment.filters.equalizer': 'create equalizer as a sequence of [peaking][peaking] [biquad filter nodes][biquad]',
                        'comment.filters.equalizer.single': 'create equalizer as a [peaking][peaking] [biquad filter node][biquad]',
                        'comment.destination': 'connect last node to [destination][destination]',
                        'comment.destination.compressor': 'create [dynamics compressor node][compressor]',
                        'comment.destination.analyser': 'create [analyser node][analyser]',
                        'comment.destination.analyser.{waveform,frequencies,waveform+frequencies}': 'create [analyser node][analyser] for {waveform,frequencies,waveform and frequencies} visualization',
                        'comment.destination.analyser.split': 'create [channel splitter node][splitter] connected to two [analyser nodes][analyser]',
                        'units.pixel.a': 'px',
                        'units.pixel.{1,2}': 'pixel{,s}',
                        'units.hertz.a': 'Hz',
                        'units.hertz.{1,2}': 'Hertz',
                        'units.decibel.a': 'dB',
                        'units.decibel.{1,2}': 'decibel{,s}',
                        'units.second.a': 's',
                        'units.second.{1,2}': 'second{,s}'
                    },
                    ru: {
                        'options.sources': 'Источники',
                        'options.sources.{audio,video}': 'Элемент <code>{}</code>',
                        'options.sources.{audio,video}.add': 'Добавить элемент <code>{}</code>',
                        'options.sources.sample': 'Сэмпл',
                        'options.sources.sample.add': 'Добавить сэмпл',
                        'options.sources.sample.buffer.loading': 'Идёт загрузка и декодирование сэмпла',
                        'options.sources.sample.buffer.error': 'Ошибка загрузки сэмпла',
                        'options.sources.sample.repeat': 'Повторить сэмпл',
                        'options.sources.sample.interval': 'Интервал между повторами',
                        'options.sources.sample.randomShift': 'Случайный сдвиг начала проигрывания',
                        'options.sources.sample.pitch': 'Высота',
                        'options.sources.sample.randomPitch': 'Случайная высота',
                        'options.sources.sample.gain': 'Громкость',
                        'options.sources.sample.randomGain': 'Случайная громкость',
                        'options.sources.{audio,video,sample}.url': 'URL источника',
                        'options.sources.video.{width,height}': '{Ширина,Высота} проигрывателя',
                        'options.filters': 'Фильтры',
                        'options.filters.gain': 'Усилитель',
                        'options.filters.gain.add': 'Добавить усилитель',
                        'options.filters.gain.gain': 'Коэффициент усиления',
                        'options.filters.panner': 'Панорамирование',
                        'options.filters.panner.add': 'Добавить панорамирование',
                        'options.filters.panner.pan': 'Баланс',
                        'options.filters.biquad': 'Биквадратичный фильтр',
                        'options.filters.biquad.add': 'Добавить биквадратичный фильтр',
                        'options.filters.biquad.type': 'Тип фильтра',
                        'options.filters.biquad.type.lowpass': 'нижних частот',
                        'options.filters.biquad.type.highpass': 'верхних частот',
                        'options.filters.biquad.type.bandpass': 'полосовой',
                        'options.filters.biquad.type.{lowshelf,highshelf,peaking}': '{}',
                        // TODO
                        'options.filters.biquad.type.notch': 'полосно-заграждающий',
                        'options.filters.biquad.type.allpass': 'всепропускающий',
                        // http://www.dsplib.ru/content/allpass/allpass.html
                        'options.filters.biquad.frequency': 'Частота',
                        'options.filters.biquad.detune': 'Detune',
                        'options.filters.biquad.Q': 'Логарифм добротности',
                        'options.filters.biquad.gain': 'Усиление',
                        'options.filters.iir': 'БИХ-фильтр',
                        'options.filters.iir.add': 'Добавить БИХ-фильтр',
                        'options.filters.iir.feedforward': 'Коэффициенты прямой связи',
                        // Transfer fn numerator coefs
                        'options.filters.iir.feedforward.b': 'b',
                        'options.filters.iir.feedforward.b.add': 'Добавить коэффициент',
                        'options.filters.iir.feedback': 'Коэффициенты обратной связи',
                        // Transfer fn denominator coefs
                        'options.filters.iir.feedback.a': 'a',
                        'options.filters.iir.feedback.a.add': 'Добавить коэффициент',
                        'options.filters.convolver': 'Свёртка',
                        'options.filters.convolver.add': 'Добавить свёртку',
                        'options.filters.convolver.url': 'URL импульсной характеристики',
                        'options.filters.convolver.reverb': 'Соотношение прямого/обработанного звука',
                        // http://www.ixbt.com/proaudio/theory-of-reverb.shtml
                        'options.filters.convolver.buffer.loading': 'Идёт загрузка и декодирование импульсной характеристики',
                        'options.filters.convolver.buffer.error': 'Ошибка загрузки импульсной характеристики',
                        'options.filters.equalizer': 'Эквалайзер',
                        'options.filters.equalizer.add': 'Добавить эквалайзер',
                        'options.filters.equalizer.gain{60,170,350,1000,3500,10000}': 'Усиление частоты {} Гц',
                        'options.destination': 'Выход',
                        'options.destination.compressor': 'Компрессор',
                        'options.destination.compressor.enabled': 'Добавить компрессор перед выходом',
                        'options.destination.{waveform,frequencies}': 'Визуализация {формы волны,частот}',
                        'options.destination.{waveform,frequencies}.enabled': 'Включить визуализацию {формы волны,частот}',
                        'options.destination.waveform.width': 'Ширина линии волны',
                        'options.destination.waveform.color': 'Цвет линии волны',
                        'options.destination.waveform.color.{r,g,b,a}': ruColors + ' линии волны',
                        'options.destination.frequencies.cutoff': 'Ограничить рисование долей низких частот',
                        'options.destination.frequencies.base': 'Полосы частот растут от',
                        'options.destination.frequencies.base.{bottom,middle}': '{низа,середины} элемента <code>canvas</code>',
                        'options.destination.frequencies.coloring': 'Раскраска полос частот',
                        'options.destination.frequencies.coloring.component': 'одним цветовым каналом',
                        'options.destination.frequencies.coloring.spectral': 'спектральная',
                        'options.destination.frequencies.coloringInput': 'Цвет полос зависит от',
                        'options.destination.frequencies.coloringInput.{amplitude,frequency}': '{амплитуды,частоты}',
                        'options.destination.frequencies.outline': 'Контур полос частот',
                        'options.destination.frequencies.outline.enabled': 'Включить рисование контура частот',
                        'options.destination.frequencies.outline.width': 'Ширина контура частот',
                        'options.destination.frequencies.outline.color': 'Цвет контура частот',
                        'options.destination.frequencies.outline.color.{r,g,b,a}': ruColors + ' контура частот',
                        'options.destination.volume': 'Индикатор громкости',
                        'options.destination.volume.enabled': 'Включить индикатор громкости',
                        'options.destination.volume.stereo': 'Отдельные индикаторы для левого и правого каналов',
                        'options.destination.analyser': 'Анализатор',
                        'options.destination.analyser.logFftSize': 'Размер БПФ (степень 2)',
                        'options.canvas': 'Элемент <code>canvas</code>',
                        'options.canvas.{width,height}': '{Ширина,Высота} элемента <code>canvas</code>',
                        'options.canvas.background': 'Фон',
                        'options.canvas.background.type': 'Тип фона',
                        'options.canvas.background.type.{clear,filled}': '{прозрачный,закрашенный}',
                        'options.canvas.background.color': 'Цвет фона',
                        'options.canvas.background.color.{r,g,b,a}': ruColors + ' фона',
                        'options.loader': 'Загрузчик сэмплов',
                        'options.loader.errors': 'Обработка ошибок загрузки',
                        'options.loader.errors.none': 'отключена',
                        'options.loader.errors.network': 'для сетевых ошибок',
                        'options.loader.errors.http': 'для сетевых ошибок и ошибок HTTP',
                        'options.api': 'Поддержка Web Audio API',
                        'options.api.noVendorPrefix': 'Можно создавать аудио-контекст без префиксов производителей',
                        'options.api.connectReturnValue': 'Можно использовать значение, возвращаемое <code>AudioNode.connect()</code>',
                        'options-info.destination.analyser.logFftSize': 'Размер [[Быстрое преобразование Фурье|Быстрого преобразования Фурье]] для визуализаций формы волны и частот. Больший размер даёт более широкое окно для формы волны и более тонкие полосы частот.',
                        'options-info.canvas.background.color.a': 'Низкие значения альфа-канала приводят к эффекту размывания.',
                        'options-output.input': 'Значение изменяемо',
                        'options-output.range': 'в диапазоне',
                        'options-output.filter.frequencyResponse': 'Частотная характеристика',
                        'options-output.filter.magnitude': 'Амплитуда',
                        'options-output.filter.phase': 'Фаза',
                        'options-output.filter.logMagnitude': 'логарифмическая шкала амплитуды',
                        'options-output.filter.logFrequency': 'логарифмическая шкала частоты',
                        'options-output.filter.contextError': 'Ошибка создания аудио-контекста. Вероятно, браузер не поддерживает Web Audio API.',
                        'options-output.filter.nodeError': 'Ошибка создания узла фильтра. Вероятно, браузер не поддерживает данный тип фильтров.',
                        'options-output.filter.biquad.clone': 'Клонировать в виде БИХ-фильтра',
                        'options-output.filter.biquad.clone.{pre,post}': 'Клонировать с коэффициентами по версиям {до,после} 2016-04-15',
                        'options-output.filter.biquad.clone.info': '<a href=\'' + webaudioSpec + '\'>Спецификация API</a> была противоречива и реализации ей не следовали. Также было обнаружено, что формулы для коэффициентов фильтров должны быть изменены, чтобы стало возможно задавать некоторые фильтры низких и высоких частот, которые ранее задать было невозможно. Подробности можно узнать из Web Audio API issues ' + webaudioIssue(769) + ', ' + webaudioIssue(771) + ' и ' + webaudioIssue(791) + '. Возможный метод обнаружения, перешла ли реализация на новые формулы, приводится <a href=\'' + webaudioDetect + '\'>здесь</a>.',
                        'options-output.show': 'Показать',
                        'options-output.hide': 'Скрыть',
                        'code-output.warning.jsfiddle-run': 'Для корректного вывода звука в JSFiddle может потребоваться нажатие кнопки <kbd>Run</kbd>',
                        'code-output.warning.interesting': 'Для нетривиального JavaScript-кода нужно включить по крайней мере один источник и последующую обработку звука',
                        'code.title': 'Пример использования Web Audio API \u2014 сгенерированный код',
                        'label.sources.sample.play': 'Играть сэмпл',
                        'label.destination.compressor': 'Включить компрессор',
                        'comment.context': 'создаём [аудио-контекст][context]',
                        'comment.sources.audio': 'создаём [узел источника аудио][source]',
                        'comment.sources.video': 'создаём [узел источника видео][source]',
                        'comment.sources.sample': 'загружаем [сэмпл][buffer]',
                        'comment.filters.gain': 'создаём [узел усилителя][gain]',
                        'comment.filters.panner': 'создаём [узел панорамирования][panner]',
                        'comment.filters.biquad': 'создаём [узел биквадратичного фильтра][biquad]',
                        'comment.filters.iir': 'создаём [узел БИХ-фильтра][iir]',
                        'comment.filters.convolver': 'создаём прямой путь и путь через [узел свёртки][convolver]',
                        'comment.filters.convolver.single': 'создаём [узел свёртки][convolver]',
                        'comment.filters.equalizer': 'создаём эквалайзер в виде последовательности [peaking][peaking] [биквадратичных фильтров][biquad]',
                        'comment.filters.equalizer.single': 'создаём эквалайзер в виде [peaking][peaking] [биквадратичного фильтра][biquad]',
                        'comment.destination': 'соединяем последний узел с [выходом][destination]',
                        'comment.destination.compressor': 'создаём [узел компрессора][compressor]',
                        'comment.destination.analyser': 'создаём [узел анализатора][analyser]',
                        'comment.destination.analyser.{waveform,frequencies,waveform+frequencies}': 'создаём [узел анализатора][analyser] для визуализации {формы волны,частот,формы волны и частот}',
                        'comment.destination.analyser.split': 'создаём [узел разделения каналов][splitter], соединённый с двумя [узлами анализатора][analyser]',
                        'units.pixel.a': 'px',
                        'units.pixel.{1,2,5}': 'пиксел{ь,я,ей}',
                        'units.hertz.a': 'Гц',
                        'units.hertz.{1,2,5}': 'Герц{,а,}',
                        'units.decibel.a': 'дБ',
                        'units.decibel.{1,2,5}': 'децибел{,а,ов}',
                        'units.second.a': 'с',
                        'units.second.{1,2,5}': 'секунд{а,ы,}'
                    }
                };
                /*
function i18nLinkFilter(inStrings) {
	const linkRegexp=/\[(\S+)\s+([^\]]+)]/g
	const outStrings={}
	for (let id in inStrings) {
		outStrings[id]=inStrings[id].replace(linkRegexp,(match,url,text)=>"<a href='"+url+"'>"+text+"</a>")
	}
	return outStrings
}
strings=i18nLinkFilter(strings)
*/
                for (var lang in langStrings) {
                    var strings = langStrings[lang];
                    strings = require(12)(strings);
                    strings = require(13)(lang)(strings);
                    strings = require(20)(lang)(strings);
                    strings = require(2)(lang)(strings);
                    langStrings[lang] = strings;
                }
                module.exports = require(14)(langStrings);
            },
            {
                '12': 12,
                '13': 13,
                '14': 14,
                '2': 2,
                '20': 20
            }
        ],
        42: [
            function (require, module, exports) {
                var FilterOptionOutput = require(39);
                var IIRFilterOptionOutput = function (_FilterOptionOutput) {
                    ___babelHelper___inherits(IIRFilterOptionOutput, _FilterOptionOutput);
                    function IIRFilterOptionOutput() {
                        ___babelHelper___classCallCheck(this, IIRFilterOptionOutput);
                        return ___babelHelper___possibleConstructorReturn(this, _FilterOptionOutput.apply(this, arguments));
                    }
                    IIRFilterOptionOutput.prototype.getFilterNodes = function getFilterNodes(audioContext) {
                        return [audioContext.createIIRFilter(this.option.entries[0].entries.map(function (entry) {
                                return entry.value;
                            }), this.option.entries[1].entries.map(function (entry) {
                                return entry.value;
                            }))];
                    };
                    return IIRFilterOptionOutput;
                }(FilterOptionOutput);
                module.exports = IIRFilterOptionOutput;
            },
            { '39': 39 }
        ],
        43: [
            function (require, module, exports) {
                var WrapLines = require(26);
                var JsLines = require(16);
                var Feature = require(38);
                var Loader = function (_Feature) {
                    ___babelHelper___inherits(Loader, _Feature);
                    function Loader(options) {
                        ___babelHelper___classCallCheck(this, Loader);
                        var _this = ___babelHelper___possibleConstructorReturn(this, _Feature.call(this));
                        _this.options = options;
                        return _this;
                    }
                    Loader.prototype.requestFeatureContext = function requestFeatureContext(featureContext) {
                        if (this.options.errors != 'none') {
                            featureContext.loaderOnError = true;
                        }
                    };
                    Loader.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                        if (!featureContext.loader)
                            return JsLines.be();
                        var a = JsLines.b();
                        a('var xhr=new XMLHttpRequest();', 'xhr.open(\'GET\',url);', // TODO html escape
                        'xhr.responseType=\'arraybuffer\';', 'xhr.onload=function(){');
                        if (this.options.errors == 'http') {
                            a('\tif (this.status==200) {', '\t\tctx.decodeAudioData(this.response,onDecode);', // TODO decoding error handling
                            '\t} else {', '\t\tthis.onerror();', '\t}');
                        } else {
                            a('\tctx.decodeAudioData(this.response,onDecode);');
                        }
                        a('};');
                        if (this.options.errors != 'none') {
                            a('xhr.onerror=onError;');
                        }
                        a('xhr.send();');
                        return WrapLines.b(JsLines.bae('function loadSample(url,onDecode' + (this.options.errors != 'none' ? ',onError' : '') + ') {'), JsLines.bae('}')).ae(a.e());
                    };
                    return Loader;
                }(Feature);
                module.exports = Loader;
            },
            {
                '16': 16,
                '26': 26,
                '38': 38
            }
        ],
        44: [
            function (require, module, exports) {
                var idCounter = 0;
                function generateId() {
                    return 'webaudio-starter-id-' + idCounter++;
                }
                var i18ns = require(41);
                var Options = require(47);
                var Code = require(34);
                var OptionsOutput = require(46);
                var CodeOutput = require(33);
                $(function () {
                    $('.webaudio-starter').each(function () {
                        var $container = $(this);
                        var lang = $container.closest('[lang]').attr('lang');
                        var i18n = i18ns(lang);
                        var options = new Options();
                        var codeOutput = new CodeOutput(function () {
                            return new Code(options.fix(), i18n);
                        }, i18n);
                        options.addUpdateCallback(codeOutput.update);
                        var optionsOutput = new OptionsOutput(options, generateId, i18n);
                        $container.empty().append(optionsOutput.$output, codeOutput.$output);
                    });
                });
            },
            {
                '33': 33,
                '34': 34,
                '41': 41,
                '46': 46,
                '47': 47
            }
        ],
        45: [
            function (require, module, exports) {
                var Option = Object.create(require(19));
                // differs from webgl-starter:
                //	input is a boolean
                // 	float subclasses have a fixed precision of 2
                //	no speed
                //	can specify defaultMin, defaultMax
                //	fixed has defaultValue - although it's potentially confusing: user input default vs Web Audio Node property default - they are currently the same
                Option.LiveNumber = function (_Option$Number) {
                    ___babelHelper___inherits(_class, _Option$Number);
                    function _class(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class);
                        var dataValue = undefined, dataMin = undefined, dataMax = undefined, dataInput = undefined;
                        if (typeof data == 'object') {
                            dataValue = data.value;
                            dataMin = data.min;
                            dataMax = data.max;
                            dataInput = data.input;
                        } else {
                            dataValue = data;
                        }
                        var _this = ___babelHelper___possibleConstructorReturn(this, _Option$Number.apply(this, arguments));
                        if (settings.defaultMin !== undefined) {
                            _this.defaultMin = settings.defaultMin;
                        } else {
                            _this.defaultMin = _this.availableMin;
                        }
                        if (settings.defaultMax !== undefined) {
                            _this.defaultMax = settings.defaultMax;
                        } else {
                            _this.defaultMax = _this.availableMax;
                        }
                        _this._min = dataMin !== undefined ? dataMin : _this.defaultMin;
                        _this._max = dataMax !== undefined ? dataMax : _this.defaultMax;
                        _this._input = !!dataInput;
                        _this._$range = null;
                        return _this;
                    }
                    _class.prototype.updateInternalVisibility = function updateInternalVisibility() {
                        if (this._$range)
                            this._$range.toggle(this._input);
                    };
                    _class.prototype.exportHelper = function exportHelper(src) {
                        var data = {};
                        if (src.value != src.defaultValue)
                            data.value = src.value;
                        if (src.min != src.availableMin)
                            data.min = src.min;
                        if (src.max != src.availableMax)
                            data.max = src.max;
                        if (src.input)
                            data.input = src.input;
                        return data;
                    };
                    _class.prototype.export = function _export() {
                        return this.exportHelper(this);
                    };
                    _class.prototype.fix = function fix() {
                        var fixed = _Option$Number.prototype.fix.call(this);
                        fixed.min = this.min;
                        fixed.max = this.max;
                        fixed.input = this.input;
                        fixed.defaultValue = this.defaultValue;
                        return fixed;
                    };
                    ___babelHelper___createClass(_class, [
                        {
                            key: 'input',
                            get: function () {
                                return this._input;
                            },
                            set: function (input) {
                                this._input = input;
                                this.updateInternalVisibility();
                                this.update();
                            }
                        },
                        {
                            key: 'min',
                            get: function () {
                                return this._min;
                            },
                            set: function (min) {
                                this._min = min;
                                this.update();
                            }
                        },
                        {
                            key: 'max',
                            get: function () {
                                return this._max;
                            },
                            set: function (max) {
                                this._max = max;
                                this.update();
                            }
                        },
                        {
                            key: '$range',
                            get: function () {
                                return this._$range;
                            },
                            set: function ($range) {
                                this._$range = $range;
                                this.updateInternalVisibility();
                            }
                        }
                    ]);
                    return _class;
                }(Option.Number);
                Option.LiveInt = function (_Option$LiveNumber) {
                    ___babelHelper___inherits(_class2, _Option$LiveNumber);
                    function _class2() {
                        ___babelHelper___classCallCheck(this, _class2);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$LiveNumber.apply(this, arguments));
                    }
                    ___babelHelper___createClass(_class2, [{
                            key: 'precision',
                            get: function () {
                                return 0;
                            }
                        }]);
                    return _class2;
                }(Option.LiveNumber);
                Option.LiveFloat = function (_Option$LiveNumber2) {
                    ___babelHelper___inherits(_class3, _Option$LiveNumber2);
                    function _class3() {
                        ___babelHelper___classCallCheck(this, _class3);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$LiveNumber2.apply(this, arguments));
                    }
                    ___babelHelper___createClass(_class3, [{
                            key: 'precision',
                            get: function () {
                                return 2;
                            }
                        }]);
                    return _class3;
                }(Option.LiveNumber);
                var FixedLiveSelect = function () {
                    function FixedLiveSelect(src) {
                        ___babelHelper___classCallCheck(this, FixedLiveSelect);
                        this.value = src.value;
                        this.input = src.input;
                        this.defaultValue = src.defaultValue;
                        this.availableValues = src.availableValues;
                        this.name = src.name;
                    }
                    FixedLiveSelect.prototype.valueOf = function valueOf() {
                        return this.value;
                    };
                    FixedLiveSelect.prototype.toString = function toString() {
                        return this.value;
                    };
                    return FixedLiveSelect;
                }();
                Option.LiveSelect = function (_Option$Select) {
                    ___babelHelper___inherits(_class4, _Option$Select);
                    function _class4(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class4);
                        var dataValue = undefined, dataInput = undefined;
                        if (typeof data == 'object') {
                            dataValue = data.value;
                            dataInput = data.input;
                        } else {
                            dataValue = data;
                        }
                        var _this4 = ___babelHelper___possibleConstructorReturn(this, _Option$Select.apply(this, arguments));
                        _this4._input = !!dataInput;
                        return _this4;
                    }
                    _class4.prototype.export = function _export() {
                        var data = {};
                        if (this.value != this.defaultValue)
                            data.value = this.value;
                        if (this.input)
                            data.input = this.input;
                        return data;
                    };
                    _class4.prototype.fix = function fix() {
                        return new FixedLiveSelect(this);
                    };
                    ___babelHelper___createClass(_class4, [{
                            key: 'input',
                            get: function () {
                                return this._input;
                            },
                            set: function (input) {
                                this._input = input;
                                this.update();
                            }
                        }]);
                    return _class4;
                }(Option.Select);
                Option.AnyFloat = function (_Option$NonBoolean) {
                    ___babelHelper___inherits(_class5, _Option$NonBoolean);
                    function _class5() {
                        ___babelHelper___classCallCheck(this, _class5);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$NonBoolean.apply(this, arguments));
                    }
                    return _class5;
                }(Option.NonBoolean);
                Option.BiquadFilter = function (_Option$Group) {
                    ___babelHelper___inherits(_class6, _Option$Group);
                    _class6.typeUsesQ = function typeUsesQ(type) {
                        return !!{
                            'lowpass': true,
                            'highpass': true,
                            'bandpass': true,
                            'peaking': true,
                            'notch': true,
                            'allpass': true
                        }[type];
                    };
                    _class6.typeUsesGain = function typeUsesGain(type) {
                        return !!{
                            'lowshelf': true,
                            'highshelf': true,
                            'peaking': true
                        }[type];
                    };
                    _class6.collectArgs = function collectArgs(scalarArg, arrayArg, settings) {
                        settings = Object.create(settings);
                        settings.descriptions = [
                            [
                                'LiveSelect',
                                'type',
                                [
                                    'lowpass',
                                    'highpass',
                                    'bandpass',
                                    'lowshelf',
                                    'highshelf',
                                    'peaking',
                                    'notch',
                                    'allpass'
                                ]
                            ],
                            [
                                'LiveInt',
                                'frequency',
                                [
                                    0,
                                    22050
                                ],
                                350,
                                { unit: 'hertz' }
                            ],
                            [
                                'LiveInt',
                                'detune',
                                [
                                    0,
                                    100
                                ],
                                { unit: '\xA2' }
                            ],
                            [
                                'LiveFloat',
                                'Q',
                                [
                                    -4,
                                    4
                                ],
                                0
                            ],
                            // log Q
                            [
                                'LiveInt',
                                'gain',
                                [
                                    -30,
                                    30
                                ],
                                0,
                                { unit: 'decibel' }
                            ]
                        ];
                        return _Option$Group.collectArgs.call(this, scalarArg, arrayArg, settings);
                    };
                    function _class6(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class6);
                        var _this6 = ___babelHelper___possibleConstructorReturn(this, _Option$Group.apply(this, arguments));
                        var type = _this6.entries[0];
                        var Q = _this6.entries[3];
                        var gain = _this6.entries[4];
                        Q.isVisible = function () {
                            return type.input || Option.BiquadFilter.typeUsesQ(type.value);
                        };
                        gain.isVisible = function () {
                            return type.input || Option.BiquadFilter.typeUsesGain(type.value);
                        };
                        type.addUpdateCallback(function () {
                            Q.updateVisibility();
                            gain.updateVisibility();
                        });
                        return _this6;
                    }
                    return _class6;
                }(Option.Group);
                Option.IIRFilterCoefs = function (_Option$Array) {
                    ___babelHelper___inherits(_class7, _Option$Array);
                    function _class7(name, settings, data, parent, visibilityManager, makeEntry) {
                        ___babelHelper___classCallCheck(this, _class7);
                        var _this7 = ___babelHelper___possibleConstructorReturn(this, _Option$Array.apply(this, arguments));
                        if (_this7._entries.length == 0) {
                            var type = _this7.availableTypes[0];
                            _this7._entries.push(_this7.makeEntry(type));
                        }
                        return _this7;
                    }
                    return _class7;
                }(Option.Array);
                Option.IIRFilter = function (_Option$Group2) {
                    ___babelHelper___inherits(_class8, _Option$Group2);
                    function _class8() {
                        ___babelHelper___classCallCheck(this, _class8);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Group2.apply(this, arguments));
                    }
                    _class8.collectArgs = function collectArgs(scalarArg, arrayArg, settings) {
                        settings = Object.create(settings);
                        settings.descriptions = [
                            [
                                'IIRFilterCoefs',
                                'feedforward',
                                [[
                                        'AnyFloat',
                                        'b',
                                        1
                                    ]]
                            ],
                            [
                                'IIRFilterCoefs',
                                'feedback',
                                [[
                                        'AnyFloat',
                                        'a',
                                        1
                                    ]]
                            ]
                        ];
                        return _Option$Group2.collectArgs.call(this, scalarArg, arrayArg, settings);
                    };
                    return _class8;
                }(Option.Group);
                Option.EqualizerFilter = function (_Option$Group3) {
                    ___babelHelper___inherits(_class9, _Option$Group3);
                    function _class9() {
                        ___babelHelper___classCallCheck(this, _class9);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Group3.apply(this, arguments));
                    }
                    _class9.collectArgs = function collectArgs(scalarArg, arrayArg, settings) {
                        settings = Object.create(settings);
                        settings.descriptions = Option.EqualizerFilter.frequencies.map(function (freq) {
                            return [
                                'LiveInt',
                                'gain' + freq,
                                [
                                    -30,
                                    30
                                ],
                                0,
                                { unit: 'decibel' }
                            ];
                        });
                        return _Option$Group3.collectArgs.call(this, scalarArg, arrayArg, settings);
                    };
                    ___babelHelper___createClass(_class9, null, [{
                            key: 'frequencies',
                            get: function () {
                                return [
                                    60,
                                    170,
                                    350,
                                    1000,
                                    3500,
                                    10000
                                ];
                            }
                        }]);
                    return _class9;
                }(Option.Group);
                Option.Filters = function (_Option$Array2) {
                    ___babelHelper___inherits(_class10, _Option$Array2);
                    function _class10() {
                        ___babelHelper___classCallCheck(this, _class10);
                        return ___babelHelper___possibleConstructorReturn(this, _Option$Array2.apply(this, arguments));
                    }
                    return _class10;
                }(Option.Array);
                module.exports = Option;
            },
            { '19': 19 }
        ],
        46: [
            function (require, module, exports) {
                var Option = require(45);
                var BaseOptionsOutput = require(21);
                var ArrayOptionOutput = require(1);
                var BiquadFilterOptionOutput = require(31);
                var IIRFilterOptionOutput = require(42);
                var EqualizerFilterOptionOutput = require(37);
                var FiltersOptionOutput = function (_ArrayOptionOutput) {
                    ___babelHelper___inherits(FiltersOptionOutput, _ArrayOptionOutput);
                    function FiltersOptionOutput() {
                        ___babelHelper___classCallCheck(this, FiltersOptionOutput);
                        return ___babelHelper___possibleConstructorReturn(this, _ArrayOptionOutput.apply(this, arguments));
                    }
                    FiltersOptionOutput.prototype.writeDraggableSubOption = function writeDraggableSubOption(subOption, writeOption, i18n) {
                        var $subOutput = _ArrayOptionOutput.prototype.writeDraggableSubOption.call(this, subOption, writeOption, i18n);
                        var This = this;
                        if (subOption instanceof Option.BiquadFilter) {
                            $subOutput.find('button.clone').click(function () {
                                var $button = $(this);
                                var coefs = $button.data('coefs');
                                if (coefs) {
                                    var entry = This.option.makeEntry('iir', coefs);
                                    This.$entries.append(This.writeDraggableSubOption(entry, writeOption, i18n));
                                    This.updateArrayEntries();
                                }
                            });
                        }
                        return $subOutput;
                    };
                    return FiltersOptionOutput;
                }(ArrayOptionOutput);
                var IIRFilterCoefsOptionOutput = function (_ArrayOptionOutput2) {
                    ___babelHelper___inherits(IIRFilterCoefsOptionOutput, _ArrayOptionOutput2);
                    function IIRFilterCoefsOptionOutput(option, writeOption, i18n, generateId) {
                        ___babelHelper___classCallCheck(this, IIRFilterCoefsOptionOutput);
                        var _this2 = ___babelHelper___possibleConstructorReturn(this, _ArrayOptionOutput2.call(this, option, writeOption, i18n, generateId));
                        _this2.updateArrayEntryLabels();
                        return _this2;
                    }
                    IIRFilterCoefsOptionOutput.prototype.canDeleteEntry = function canDeleteEntry($entry) {
                        return this.option.entries.length > 1;
                    };
                    IIRFilterCoefsOptionOutput.prototype.updateArrayEntries = function updateArrayEntries() {
                        _ArrayOptionOutput2.prototype.updateArrayEntries.call(this);
                        this.updateArrayEntryLabels();
                    };
                    IIRFilterCoefsOptionOutput.prototype.updateArrayEntryLabels = function updateArrayEntryLabels() {
                        this.$entries.children().each(function (i) {
                            var c = $(this).data('option').name;
                            $(this).find('label').addClass('short').html(c + '<sub>' + i + '</sub>:');
                        });
                    };
                    return IIRFilterCoefsOptionOutput;
                }(ArrayOptionOutput);
                var OptionsOutput = function (_BaseOptionsOutput) {
                    ___babelHelper___inherits(OptionsOutput, _BaseOptionsOutput);
                    function OptionsOutput() {
                        ___babelHelper___classCallCheck(this, OptionsOutput);
                        return ___babelHelper___possibleConstructorReturn(this, _BaseOptionsOutput.apply(this, arguments));
                    }
                    OptionsOutput.prototype.setOptionClassWriters = function setOptionClassWriters(optionClassWriters) {
                        var _this4 = this;
                        _BaseOptionsOutput.prototype.setOptionClassWriters.call(this, optionClassWriters);
                        optionClassWriters.set(Option.LiveNumber, function (option, writeOption, i18n, generateId) {
                            var p = option.precision;
                            var setInputAttrs = function ($input) {
                                return $input.attr('min', option.availableMin).attr('max', option.availableMax).attr('step', Math.pow(0.1, p).toFixed(p));
                            };
                            var writeMinMaxInput = function (minOrMax) {
                                return setInputAttrs($('<input type=\'number\' required>')).val(option[minOrMax]).on('input change', function () {
                                    if (this.checkValidity()) {
                                        option[minOrMax] = parseFloat(this.value);
                                    }
                                });
                            };
                            var $inputCheckbox = undefined, $rangeMinInput = undefined, $rangeMaxInput = undefined;
                            var $output = optionClassWriters.get(Option.Number)(option, writeOption, i18n, generateId);
                            $output.find('button').before($('<label class=\'nowrap\'>').append($inputCheckbox = $('<input type=\'checkbox\'>').prop('checked', option.input).change(function () {
                                option.input = $(this).prop('checked');
                            }), ' ' + i18n('options-output.input')), ' ', option.$range = $('<span class=\'range\'>').append(i18n('options-output.range') + ' ', $('<span class=\'nowrap\'>').append($rangeMinInput = writeMinMaxInput('min'), ' .. ', $rangeMaxInput = writeMinMaxInput('max'))), ' ').click(function () {
                                $inputCheckbox.prop('checked', false).change();
                                $rangeMinInput.val(option.defaultMin).change();
                                $rangeMaxInput.val(option.defaultMax).change();
                            });
                            return $output;
                        });
                        optionClassWriters.set(Option.LiveSelect, function (option, writeOption, i18n, generateId) {
                            var id = generateId();
                            var $select = undefined, $inputCheckbox = undefined;
                            return option.$ = $('<div class=\'option\'>').append(// not inheriting Option.Select b/c don't know how to handle reset button
                            _this4.getLeadLabel(id, i18n, option), $select = $('<select id=\'' + id + '\'>').append(option.availableValues.map(function (availableValue) {
                                return $('<option>').val(availableValue).html(i18n('options.' + option.fullName + '.' + availableValue));
                            })).val(option.value).change(function () {
                                option.value = this.value;
                            }), ' ', $('<label class=\'nowrap\'>').append($inputCheckbox = $('<input type=\'checkbox\'>').prop('checked', option.input).change(function () {
                                option.input = $(this).prop('checked');
                            }), ' ' + i18n('options-output.input')), ' ', $('<button type=\'button\'>' + i18n('options-output.reset') + '</button>').click(function () {
                                $select.val(option.defaultValue).change();
                                $inputCheckbox.prop('checked', false).change();
                            }));
                        });
                        optionClassWriters.set(Option.AnyFloat, function (option, writeOption, i18n, generateId) {
                            var id = generateId();
                            return option.$ = $('<div class=\'option\'>').append(_this4.getLeadLabel(id, i18n, option), $('<input type=\'number\' id=\'' + id + '\' step=\'any\' required>').val(option.value).on('input change', function () {
                                if (this.checkValidity()) {
                                    option.value = parseFloat(this.value);
                                }
                            }));
                        });
                        optionClassWriters.set(Option.IIRFilterCoefs, function () {
                            return new (Function.prototype.bind.apply(IIRFilterCoefsOptionOutput, [null].concat(Array.prototype.slice.call(arguments))))().$output;
                        });
                        optionClassWriters.set(Option.BiquadFilter, function () {
                            return new (Function.prototype.bind.apply(BiquadFilterOptionOutput, [null].concat(Array.prototype.slice.call(arguments))))().$output;
                        });
                        optionClassWriters.set(Option.IIRFilter, function () {
                            return new (Function.prototype.bind.apply(IIRFilterOptionOutput, [null].concat(Array.prototype.slice.call(arguments))))().$output;
                        });
                        optionClassWriters.set(Option.EqualizerFilter, function () {
                            return new (Function.prototype.bind.apply(EqualizerFilterOptionOutput, [null].concat(Array.prototype.slice.call(arguments))))().$output;
                        });
                        optionClassWriters.set(Option.Filters, function () {
                            return new (Function.prototype.bind.apply(FiltersOptionOutput, [null].concat(Array.prototype.slice.call(arguments))))().$output;
                        });
                    };
                    return OptionsOutput;
                }(BaseOptionsOutput);
                module.exports = OptionsOutput;
            },
            {
                '1': 1,
                '21': 21,
                '31': 31,
                '37': 37,
                '42': 42,
                '45': 45
            }
        ],
        47: [
            function (require, module, exports) {
                var BaseOptions = require(22);
                var Options = function (_BaseOptions) {
                    ___babelHelper___inherits(Options, _BaseOptions);
                    function Options() {
                        ___babelHelper___classCallCheck(this, Options);
                        return ___babelHelper___possibleConstructorReturn(this, _BaseOptions.apply(this, arguments));
                    }
                    ___babelHelper___createClass(Options, [
                        {
                            key: 'entriesDescription',
                            get: function () {
                                return [
                                    [
                                        'Array',
                                        'sources',
                                        [
                                            [
                                                'Group',
                                                'audio',
                                                [[
                                                        'Text',
                                                        'url',
                                                        [
                                                            // original w3c mooc
                                                            'http://mainline.i3s.unice.fr/mooc/guitarRiff1.mp3',
                                                            'http://mainline.i3s.unice.fr/mooc/drums.mp3',
                                                            'http://mainline.i3s.unice.fr/mooc/LaSueur.mp3',
                                                            // Web Audio Playground via RawGit
                                                            'https://cdn.rawgit.com/cwilso/WebAudio/9ece1787cede81ddcd26f2a78d4fb3ba0812379a/sounds/bass.ogg',
                                                            'https://cdn.rawgit.com/cwilso/WebAudio/9ece1787cede81ddcd26f2a78d4fb3ba0812379a/sounds/drums.ogg',
                                                            'https://cdn.rawgit.com/cwilso/WebAudio/9ece1787cede81ddcd26f2a78d4fb3ba0812379a/sounds/guitar.ogg'
                                                        ]
                                                    ]]
                                            ],
                                            [
                                                'Group',
                                                'video',
                                                [
                                                    [
                                                        'Text',
                                                        'url',
                                                        [
                                                            'http://mainline.i3s.unice.fr/mooc/elephants-dream-medium.webm',
                                                            'http://mainline.i3s.unice.fr/mooc/elephants-dream-medium.mp4',
                                                            'http://mainline.i3s.unice.fr/mooc/sintel.webm',
                                                            'http://mainline.i3s.unice.fr/mooc/sintel.mp4'
                                                        ]
                                                    ],
                                                    [
                                                        'Int',
                                                        'width',
                                                        [
                                                            1,
                                                            1920
                                                        ],
                                                        320,
                                                        { unit: 'pixel' }
                                                    ],
                                                    [
                                                        'Int',
                                                        'height',
                                                        [
                                                            1,
                                                            1080
                                                        ],
                                                        240,
                                                        { unit: 'pixel' }
                                                    ]
                                                ]
                                            ],
                                            [
                                                'Group',
                                                'sample',
                                                [
                                                    [
                                                        'Text',
                                                        'url',
                                                        [
                                                            'http://mainline.i3s.unice.fr/mooc/shoot1.mp3',
                                                            'http://mainline.i3s.unice.fr/mooc/shoot2.mp3'
                                                        ]
                                                    ],
                                                    [
                                                        'Int',
                                                        'repeat',
                                                        [
                                                            1,
                                                            20
                                                        ]
                                                    ],
                                                    [
                                                        'Float',
                                                        'interval',
                                                        [
                                                            0,
                                                            1
                                                        ],
                                                        0.1,
                                                        { unit: 'second' }
                                                    ],
                                                    [
                                                        'Float',
                                                        'randomShift',
                                                        [
                                                            0,
                                                            1
                                                        ],
                                                        { unit: 'second' }
                                                    ],
                                                    [
                                                        'Float',
                                                        'pitch',
                                                        [
                                                            0,
                                                            2
                                                        ],
                                                        1
                                                    ],
                                                    [
                                                        'Float',
                                                        'randomPitch',
                                                        [
                                                            0,
                                                            1
                                                        ]
                                                    ],
                                                    [
                                                        'Float',
                                                        'gain',
                                                        [
                                                            0,
                                                            2
                                                        ],
                                                        1
                                                    ],
                                                    [
                                                        'Float',
                                                        'randomGain',
                                                        [
                                                            0,
                                                            1
                                                        ]
                                                    ]
                                                ]
                                            ]
                                        ],
                                        'source'
                                    ],
                                    [
                                        'Filters',
                                        'filters',
                                        [
                                            [
                                                'Group',
                                                'gain',
                                                [[
                                                        'LiveFloat',
                                                        'gain',
                                                        [
                                                            0,
                                                            10
                                                        ],
                                                        1,
                                                        { defaultMax: 1 }
                                                    ]]
                                            ],
                                            [
                                                'Group',
                                                'panner',
                                                [[
                                                        'LiveFloat',
                                                        'pan',
                                                        [
                                                            -1,
                                                            1
                                                        ],
                                                        0
                                                    ]]
                                            ],
                                            [
                                                'BiquadFilter',
                                                'biquad'
                                            ],
                                            [
                                                'IIRFilter',
                                                'iir'
                                            ],
                                            [
                                                'Group',
                                                'convolver',
                                                [
                                                    [
                                                        'LiveFloat',
                                                        'reverb',
                                                        [
                                                            0,
                                                            1
                                                        ]
                                                    ],
                                                    [
                                                        'Text',
                                                        'url',
                                                        [
                                                            // original w3c mooc
                                                            'http://mainline.i3s.unice.fr/mooc/Scala-Milan-Opera-Hall.wav',
                                                            // Web Audio Playground via RawGit
                                                            'https://cdn.rawgit.com/cwilso/WebAudio/9ece1787cede81ddcd26f2a78d4fb3ba0812379a/sounds/irHall.ogg'
                                                        ]
                                                    ]
                                                ]
                                            ],
                                            [
                                                'EqualizerFilter',
                                                'equalizer'
                                            ]
                                        ],
                                        'filter'
                                    ],
                                    [
                                        'Group',
                                        'destination',
                                        [
                                            [
                                                'Group',
                                                'compressor',
                                                [[
                                                        'Checkbox',
                                                        'enabled'
                                                    ]]
                                            ],
                                            // Firefox compresses automatically?
                                            [
                                                'Group',
                                                'waveform',
                                                [
                                                    [
                                                        'Checkbox',
                                                        'enabled'
                                                    ],
                                                    [
                                                        'Float',
                                                        'width',
                                                        [
                                                            0,
                                                            10
                                                        ],
                                                        1,
                                                        {
                                                            unit: 'pixel',
                                                            visibilityData: { 'destination.waveform.enabled': [true] }
                                                        }
                                                    ],
                                                    [
                                                        'Group',
                                                        'color',
                                                        [
                                                            [
                                                                'Int',
                                                                'r',
                                                                [
                                                                    0,
                                                                    100
                                                                ],
                                                                0,
                                                                { unit: '%' }
                                                            ],
                                                            [
                                                                'Int',
                                                                'g',
                                                                [
                                                                    0,
                                                                    100
                                                                ],
                                                                0,
                                                                { unit: '%' }
                                                            ],
                                                            [
                                                                'Int',
                                                                'b',
                                                                [
                                                                    0,
                                                                    100
                                                                ],
                                                                0,
                                                                { unit: '%' }
                                                            ],
                                                            [
                                                                'Int',
                                                                'a',
                                                                [
                                                                    0,
                                                                    100
                                                                ],
                                                                100,
                                                                { unit: '%' }
                                                            ]
                                                        ],
                                                        { visibilityData: { 'destination.waveform.enabled': [true] } }
                                                    ]
                                                ]
                                            ],
                                            [
                                                'Group',
                                                'frequencies',
                                                [
                                                    [
                                                        'Checkbox',
                                                        'enabled'
                                                    ],
                                                    [
                                                        'Int',
                                                        'cutoff',
                                                        [
                                                            10,
                                                            100
                                                        ],
                                                        100,
                                                        {
                                                            unit: '%',
                                                            visibilityData: { 'destination.frequencies.enabled': [true] }
                                                        }
                                                    ],
                                                    [
                                                        'Select',
                                                        'base',
                                                        [
                                                            'bottom',
                                                            'middle'
                                                        ],
                                                        { visibilityData: { 'destination.frequencies.enabled': [true] } }
                                                    ],
                                                    [
                                                        'Select',
                                                        'coloring',
                                                        [
                                                            'component',
                                                            'spectral'
                                                        ],
                                                        { visibilityData: { 'destination.frequencies.enabled': [true] } }
                                                    ],
                                                    [
                                                        'Select',
                                                        'coloringInput',
                                                        [
                                                            'amplitude',
                                                            'frequency'
                                                        ],
                                                        { visibilityData: { 'destination.frequencies.enabled': [true] } }
                                                    ],
                                                    [
                                                        'Group',
                                                        'outline',
                                                        [
                                                            [
                                                                'Checkbox',
                                                                'enabled'
                                                            ],
                                                            [
                                                                'Float',
                                                                'width',
                                                                [
                                                                    0,
                                                                    10
                                                                ],
                                                                1,
                                                                {
                                                                    unit: 'pixel',
                                                                    visibilityData: { 'destination.frequencies.outline.enabled': [true] }
                                                                }
                                                            ],
                                                            [
                                                                'Group',
                                                                'color',
                                                                [
                                                                    [
                                                                        'Int',
                                                                        'r',
                                                                        [
                                                                            0,
                                                                            100
                                                                        ],
                                                                        0,
                                                                        { unit: '%' }
                                                                    ],
                                                                    [
                                                                        'Int',
                                                                        'g',
                                                                        [
                                                                            0,
                                                                            100
                                                                        ],
                                                                        0,
                                                                        { unit: '%' }
                                                                    ],
                                                                    [
                                                                        'Int',
                                                                        'b',
                                                                        [
                                                                            0,
                                                                            100
                                                                        ],
                                                                        0,
                                                                        { unit: '%' }
                                                                    ],
                                                                    [
                                                                        'Int',
                                                                        'a',
                                                                        [
                                                                            0,
                                                                            100
                                                                        ],
                                                                        100,
                                                                        { unit: '%' }
                                                                    ]
                                                                ],
                                                                { visibilityData: { 'destination.frequencies.outline.enabled': [true] } }
                                                            ]
                                                        ],
                                                        { visibilityData: { 'destination.frequencies.enabled': [true] } }
                                                    ]
                                                ]
                                            ],
                                            [
                                                'Group',
                                                'volume',
                                                [
                                                    [
                                                        'Checkbox',
                                                        'enabled'
                                                    ],
                                                    [
                                                        'Checkbox',
                                                        'stereo',
                                                        { visibilityData: { 'destination.volume.enabled': [true] } }
                                                    ]
                                                ]
                                            ],
                                            [
                                                'Group',
                                                'analyser',
                                                [[
                                                        'Int',
                                                        'logFftSize',
                                                        [
                                                            5,
                                                            12
                                                        ],
                                                        8
                                                    ]],
                                                {
                                                    visibilityData: {
                                                        'destination.waveform.enabled': [true],
                                                        'destination.frequencies.enabled': [true],
                                                        'destination.volume.enabled': [true]
                                                    },
                                                    visibilityDataLogic: 'or'
                                                }
                                            ]
                                        ]
                                    ],
                                    [
                                        'Group',
                                        'canvas',
                                        [
                                            [
                                                'Int',
                                                'width',
                                                [
                                                    1,
                                                    1920
                                                ],
                                                300,
                                                { unit: 'pixel' }
                                            ],
                                            [
                                                'Int',
                                                'height',
                                                [
                                                    1,
                                                    1080
                                                ],
                                                100,
                                                { unit: 'pixel' }
                                            ],
                                            [
                                                'Group',
                                                'background',
                                                [
                                                    [
                                                        'Select',
                                                        'type',
                                                        [
                                                            'clear',
                                                            'filled'
                                                        ]
                                                    ],
                                                    [
                                                        'Group',
                                                        'color',
                                                        [
                                                            [
                                                                'Int',
                                                                'r',
                                                                [
                                                                    0,
                                                                    100
                                                                ],
                                                                100,
                                                                { unit: '%' }
                                                            ],
                                                            [
                                                                'Int',
                                                                'g',
                                                                [
                                                                    0,
                                                                    100
                                                                ],
                                                                100,
                                                                { unit: '%' }
                                                            ],
                                                            [
                                                                'Int',
                                                                'b',
                                                                [
                                                                    0,
                                                                    100
                                                                ],
                                                                100,
                                                                { unit: '%' }
                                                            ],
                                                            [
                                                                'Int',
                                                                'a',
                                                                [
                                                                    0,
                                                                    100
                                                                ],
                                                                100,
                                                                { unit: '%' }
                                                            ]
                                                        ],
                                                        { visibilityData: { 'canvas.background.type': ['filled'] } }
                                                    ]
                                                ]
                                            ]
                                        ],
                                        {
                                            visibilityData: {
                                                'destination.waveform.enabled': [true],
                                                'destination.frequencies.enabled': [true],
                                                'destination.volume.enabled': [true]
                                            },
                                            visibilityDataLogic: 'or'
                                        }
                                    ],
                                    [
                                        'Group',
                                        'loader',
                                        [[
                                                'Select',
                                                'errors',
                                                [
                                                    'none',
                                                    'network',
                                                    'http'
                                                ]
                                            ]]
                                    ],
                                    // TODO visibility depending on sources and filters
                                    [
                                        'Group',
                                        'api',
                                        [
                                            [
                                                'Checkbox',
                                                'noVendorPrefix'
                                            ],
                                            [
                                                'Checkbox',
                                                'connectReturnValue'
                                            ]
                                        ]
                                    ]
                                ];
                            }
                        },
                        {
                            key: 'optionClasses',
                            get: function () {
                                return require(45);
                            }
                        }
                    ]);
                    return Options;
                }(BaseOptions);
                module.exports = Options;
            },
            {
                '22': 22,
                '45': 45
            }
        ],
        48: [
            function (require, module, exports) {
                var _templateObject = ___babelHelper___taggedTemplateLiteralLoose([
                        '<audio src=',
                        ' id=',
                        ' controls loop crossorigin=',
                        '></audio>'
                    ], [
                        '<audio src=',
                        ' id=',
                        ' controls loop crossorigin=',
                        '></audio>'
                    ]), _templateObject2 = ___babelHelper___taggedTemplateLiteralLoose([
                        '<video src=',
                        ' id=',
                        ' width=',
                        ' height=',
                        ' controls loop crossorigin=',
                        '></video>'
                    ], [
                        '<video src=',
                        ' id=',
                        ' width=',
                        ' height=',
                        ' controls loop crossorigin=',
                        '></video>'
                    ]), _templateObject3 = ___babelHelper___taggedTemplateLiteralLoose([
                        '<button id=',
                        ' disabled>',
                        '</button> <span id=',
                        '>',
                        '</span>'
                    ], [
                        '<button id=',
                        ' disabled>',
                        '</button> <span id=',
                        '>',
                        '</span>'
                    ]);
                var camelCase = require(6);
                var formatNumbers = require(10);
                var Lines = require(17);
                var JsLines = require(16);
                var WrapLines = require(26);
                var InterleaveLines = require(15);
                var RefLines = require(23);
                var CollectionFeature = require(35);
                var Source = function () {
                    function Source(options, n) {
                        ___babelHelper___classCallCheck(this, Source);
                        this.options = options;
                        this.n = n;
                    }
                    Source.prototype.getHtmlLines = function getHtmlLines(featureContext, i18n) {
                        return WrapLines.b('<div>', '</div>').ae(this.getElementHtmlLines(featureContext, i18n));
                    };
                    Source.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n) {
                        return JsLines.bae(RefLines.parse('// ' + i18n('comment.sources.' + this.type)), 'var ' + this.nodeJsName + '=ctx.createMediaElementSource(document.getElementById(\'' + this.elementHtmlName + '\'));');
                    };
                    // abstract:
                    // get type()
                    // getElementHtmlLines(featureContext,i18n)
                    ___babelHelper___createClass(Source, [
                        {
                            key: 'nSuffix',
                            get: function () {
                                if (this.n !== undefined) {
                                    return '.' + this.n;
                                } else {
                                    return '';
                                }
                            }
                        },
                        {
                            key: 'elementHtmlName',
                            get: function () {
                                return 'my.' + this.type + this.nSuffix;
                            }
                        },
                        {
                            key: 'nodeJsName',
                            get: function () {
                                return camelCase(this.type + this.nSuffix + '.node');
                            }
                        }
                    ]);
                    return Source;
                }();
                var sourceClasses = {
                    audio: function (_Source) {
                        ___babelHelper___inherits(audio, _Source);
                        function audio() {
                            ___babelHelper___classCallCheck(this, audio);
                            return ___babelHelper___possibleConstructorReturn(this, _Source.apply(this, arguments));
                        }
                        audio.prototype.getElementHtmlLines = function getElementHtmlLines(featureContext, i18n) {
                            return Lines.bae(Lines.html(_templateObject, this.options.url, this.elementHtmlName, featureContext.audioContext ? 'anonymous' : false));
                        };
                        ___babelHelper___createClass(audio, [{
                                key: 'type',
                                get: function () {
                                    return 'audio';
                                }
                            }]);
                        return audio;
                    }(Source),
                    video: function (_Source2) {
                        ___babelHelper___inherits(video, _Source2);
                        function video() {
                            ___babelHelper___classCallCheck(this, video);
                            return ___babelHelper___possibleConstructorReturn(this, _Source2.apply(this, arguments));
                        }
                        video.prototype.getElementHtmlLines = function getElementHtmlLines(featureContext, i18n) {
                            return Lines.bae(Lines.html(_templateObject2, this.options.url, this.elementHtmlName, this.options.width, this.options.height, featureContext.audioContext ? 'anonymous' : false));
                        };
                        ___babelHelper___createClass(video, [{
                                key: 'type',
                                get: function () {
                                    return 'video';
                                }
                            }]);
                        return video;
                    }(Source),
                    sample: function (_Source3) {
                        ___babelHelper___inherits(sample, _Source3);
                        function sample() {
                            ___babelHelper___classCallCheck(this, sample);
                            return ___babelHelper___possibleConstructorReturn(this, _Source3.apply(this, arguments));
                        }
                        sample.prototype.getElementHtmlLines = function getElementHtmlLines(featureContext, i18n) {
                            var messageHtmlName = this.elementHtmlName + '.buffer';
                            return Lines.bae(Lines.html(_templateObject3, this.elementHtmlName, i18n('label.sources.sample.play'), messageHtmlName, i18n('options.sources.sample.buffer.loading')));
                        };
                        sample.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n) {
                            var _this4 = this;
                            var messageHtmlName = this.elementHtmlName + '.buffer';
                            var fmtMul = function (fmtNum) {
                                if (fmtNum == 1) {
                                    return '';
                                } else {
                                    return '*' + fmtNum;
                                }
                            };
                            var getSampleLines = function (startOptions) {
                                var randomValue = function (baseOption, randomOption) {
                                    var numbers = {};
                                    numbers.base = baseOption;
                                    if (randomOption > 0) {
                                        numbers.random = randomOption;
                                    }
                                    var fmt = formatNumbers.js(numbers);
                                    var value = fmt.base;
                                    if (randomOption > 0) {
                                        value += '+Math.random()' + fmtMul(fmt.random);
                                    }
                                    return value;
                                };
                                var a = JsLines.b();
                                var lastNodeName = 'bufferSourceNode';
                                a('var bufferSourceNode=ctx.createBufferSource();', 'bufferSourceNode.buffer=buffer;');
                                if (_this4.options.pitch != 1 || _this4.options.randomPitch > 0) {
                                    a('bufferSourceNode.playbackRate.value=' + randomValue(_this4.options.pitch, _this4.options.randomPitch) + ';');
                                }
                                if (_this4.options.gain != 1 || _this4.options.randomGain > 0) {
                                    lastNodeName = 'bufferSourceGainNode';
                                    a(featureContext.getJsConnectAssignLines('var', 'bufferSourceGainNode', 'ctx.createGain()', ['bufferSourceNode']), 'bufferSourceGainNode.gain.value=' + randomValue(_this4.options.gain, _this4.options.randomGain) + ';');
                                }
                                if (featureContext.connectSampleToCompressor) {
                                    a.apply(undefined, [
                                        'if (document.getElementById(\'my.compressor\').checked) {',
                                        '\t' + lastNodeName + '.connect(compressorNode);',
                                        '} else {'
                                    ].concat(featureContext.connectSampleToJsNames.map(function (nodeJsName) {
                                        return '\t' + lastNodeName + '.connect(' + nodeJsName + ');';
                                    }), ['}']));
                                } else {
                                    a.apply(undefined, featureContext.connectSampleToJsNames.map(function (nodeJsName) {
                                        return lastNodeName + '.connect(' + nodeJsName + ');';
                                    }));
                                }
                                a('bufferSourceNode.start(' + startOptions + ');');
                                return a.e();
                            };
                            var getOnClickLines = function () {
                                var startOptions = '';
                                var numbers = {};
                                if (_this4.options.repeat != 1) {
                                    numbers.interval = _this4.options.interval;
                                }
                                if (_this4.options.randomShift > 0) {
                                    numbers.randomShift = _this4.options.randomShift;
                                }
                                var fmt = formatNumbers.js(numbers);
                                if (_this4.options.repeat != 1) {
                                    startOptions += '+i' + fmtMul(fmt.interval);
                                }
                                if (_this4.options.randomShift > 0) {
                                    startOptions += '+Math.random()' + fmtMul(fmt.randomShift);
                                }
                                if (startOptions.length > 0) {
                                    startOptions = 'ctx.currentTime' + startOptions;
                                }
                                if (_this4.options.repeat == 1) {
                                    return getSampleLines(startOptions);
                                } else {
                                    return WrapLines.b(JsLines.bae('for (var i=0;i<' + _this4.options.repeat + ';i++) {'), JsLines.bae('}')).ae(getSampleLines(startOptions));
                                }
                            };
                            var getOnDecodeLines = function () {
                                var a = JsLines.b();
                                a('var button=document.getElementById(\'' + _this4.elementHtmlName + '\');');
                                a(WrapLines.b(JsLines.bae('button.onclick=function(){'), JsLines.bae('};')).ae(getOnClickLines()));
                                a('button.disabled=false;', 'document.getElementById(\'' + messageHtmlName + '\').textContent=\'\';');
                                return a.e();
                            };
                            var getOnErrorLines = function () {
                                return JsLines.bae('document.getElementById(\'' + messageHtmlName + '\').textContent=\'' + i18n('options.sources.sample.buffer.error') + '\';');
                            };
                            var leadLines = JsLines.bae(RefLines.parse('// ' + i18n('comment.sources.' + this.type)), 'loadSample(\'' + this.options.url + '\',function(buffer){');
                            var midLines = JsLines.bae('},function(){');
                            var endLines = JsLines.bae('});');
                            if (!featureContext.loaderOnError) {
                                return WrapLines.b(leadLines, endLines).ae(getOnDecodeLines());
                            } else {
                                return WrapLines.b(leadLines, midLines, endLines).ae(getOnDecodeLines(), getOnErrorLines());
                            }
                        };
                        ___babelHelper___createClass(sample, [{
                                key: 'type',
                                get: function () {
                                    return 'sample';
                                }
                            }]);
                        return sample;
                    }(Source)
                };
                var SourceSet = function (_CollectionFeature) {
                    ___babelHelper___inherits(SourceSet, _CollectionFeature);
                    function SourceSet() {
                        ___babelHelper___classCallCheck(this, SourceSet);
                        return ___babelHelper___possibleConstructorReturn(this, _CollectionFeature.apply(this, arguments));
                    }
                    SourceSet.prototype.getEntryClass = function getEntryClass(entryOption) {
                        return sourceClasses[entryOption.source];
                    };
                    SourceSet.prototype.requestFeatureContext = function requestFeatureContext(featureContext) {
                        if (this.entries.length > 0) {
                            featureContext.audioProcessing = true;
                        }
                        if (this.entries.some(function (entry) {
                                return entry.type == 'sample';
                            })) {
                            featureContext.audioContext = true;
                            featureContext.loader = true;
                            featureContext.setConnectSampleToJsNames = true;
                        }
                    };
                    SourceSet.prototype.getJsInitLines = function getJsInitLines(featureContext, i18n, prevNodeJsNames) {
                        var a = InterleaveLines.b();
                        if (featureContext.audioContext) {
                            a.apply(undefined, this.entries.map(function (entry) {
                                return entry.getJsInitLines(featureContext, i18n);
                            }));
                        }
                        return a.e();
                    };
                    SourceSet.prototype.getNodeJsNames = function getNodeJsNames(featureContext, prevNodeJsNames) {
                        var nodeJsNames = [];
                        if (featureContext.audioContext) {
                            nodeJsNames = this.entries.filter(function (entry) {
                                return entry.type != 'sample';
                            }).map(function (entry) {
                                return entry.nodeJsName;
                            });
                        }
                        if (nodeJsNames.length > 0) {
                            return nodeJsNames;
                        } else {
                            return prevNodeJsNames;
                        }
                    };
                    return SourceSet;
                }(CollectionFeature);
                module.exports = SourceSet;
            },
            {
                '10': 10,
                '15': 15,
                '16': 16,
                '17': 17,
                '23': 23,
                '26': 26,
                '35': 35,
                '6': 6
            }
        ]
    }, {}, [44]));
}());